import { __assign, __extends, __rest, __spreadArray } from "tslib";
import React from 'react';
import { View, Image, ScrollView, Platform } from 'react-native';
import { PnmacSectionListView, PnmacSelect, PnmacRowHeader, PnmacSpecialRowHeader, PnmacMediaQuery, PnmacTextInput, PnmacRadioButton, PnmacCard, PnmacUIButton, PnmacText, PnmacRow, PnmacTable, PnmacTabs, PnmacTermsModal, PnmacToolTip, PnmacDatePicker, PnmacModal, PnmacHtmlToNative, PnmacNavigation, PnmacTitle, PnmacPaper, PnmacParagraph, PnmacRadioButtonGroup, PnmacSubheading, LocalStorage, HtmlToNativeNative } from 'pnmac-universal-components';
import Interstitial from '../InterstitialCompontentPayments.js';
import { PAYMENT_VALIDATION, RESET_STATE } from '../../redux/actions/actions.js';
import { maskBankInfo, getActiveFeatures, getActiveFeaturesWithExceptions, getActiveFeaturesDescription, checkForAllNumbersCurrency, currencyFormatter, paymentStatus, paymentTypes, accountype, ammountPaymentAhead, checkForAllNumbers, isEmptyOrSpaces, checkIfStringHasSpecialChar, RuleId, defaulPaymentType, defaulPaymentTypeStr, windowObject, encryptBankAccountNumber } from '../../utils.js';
import BannerView from '../../v2/BannerView';
import { textStyle } from '../../v2/theme';
import moment from 'moment';
import styles from '../../styles/styles.js';
import AddBankAccount from "./AddBankAccount";
import { TrackerHitTypeLID_ENUM, TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events.js';
import { SELECT_LOAN, NACHA_BANKACCOUNT, CLOSED_END_SECONDS } from '../../redux/actions/actions.js';
import BankAccountGrid from "./BankAccountGrid";
import Rate from '../../PnmacRate';
import LegacyDelinquent from './LegacyDelinquent.js';
import Delinquent from './Delinquent.js';
import { trackEvent } from "../../Tealium";
String.prototype.countDecimals = function () {
  var numStr = String(this.valueOf());
  if (numStr.includes('.')) {
    return numStr.split('.')[1].length;
  }
  ;
  return 0;
};
var useStyles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 500,
    margin: 'auto'
  },
  paper: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 20,
    margin: 20
  },
  consrm: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginLeft: -10,
    marginBottom: 10
  },
  root: {
    width: '90%',
    '& > * + *': {
      marginTop: 2
    }
  }
};
function TransitionsModal(_a) {
  var _b, _c, _d, _e, _f;
  var matches = _a.matches,
    open = _a.open,
    closeModal = _a.closeModal,
    paymentCallback = _a.paymentCallback,
    translations = _a.translations,
    modalType = _a.modalType,
    layout = _a.layout,
    nextPaymentDueDate = _a.nextPaymentDueDate,
    displayedConfirmationId = _a.displayedConfirmationId,
    firstMonthlyPaymentDate = _a.firstMonthlyPaymentDate,
    rest = __rest(_a, ["matches", "open", "closeModal", "paymentCallback", "translations", "modalType", "layout", "nextPaymentDueDate", "displayedConfirmationId", "firstMonthlyPaymentDate"]);
  var display = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
      "pendingPayments": {
        hr: translations === null || translations === void 0 ? void 0 : translations.MakeOTPMonthlyPaymentAlertModalTitle,
        body: (_a = translations === null || translations === void 0 ? void 0 : translations.MakeOTPMonthlyPaymentAlertModalMessage) === null || _a === void 0 ? void 0 : _a.replace("{0}", moment(nextPaymentDueDate).format("MM/DD/YYYY")),
        buttonOne: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalNo,
        buttonTwo: translations === null || translations === void 0 ? void 0 : translations.MakeOTPMonthlyPaymentAlertModalContinue,
        buttonOneClick: function () {
          PnmacNavigation(__assign({
            action: {
              pathname: "/"
            },
            layout: layout
          }, rest));
          closeModal();
        },
        buttonTwoClick: function () {
          return closeModal();
        }
      },
      "effectiveDateConfirmation": {
        hr: translations === null || translations === void 0 ? void 0 : translations.EffectiveDateConfirmation,
        body: getActiveFeatures(layout.features, "View_NACHA", false) ? "<span data-focusable=\"true\" tabindex=\"0\"><span>".concat(translations === null || translations === void 0 ? void 0 : translations.CanCancelPayment, "</span><br /><br /><span>").concat(translations === null || translations === void 0 ? void 0 : translations.NachaBankAccountBusinessValidationMessage1, "</span><br /><br /><span>").concat(translations === null || translations === void 0 ? void 0 : translations.NachaBankAccountBusinessValidationMessage2, "</span></span>") : "<span><span>".concat(translations === null || translations === void 0 ? void 0 : translations.CanCancelPayment, "</span></span>"),
        buttonOne: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalNo,
        buttonTwo: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalYes,
        buttonOneClick: function () {
          closeModal();
          rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "changed mind on effective date pop up", 0);
        },
        buttonTwoClick: function () {
          paymentCallback();
          rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "yes confirm on effective date pop up", 0);
        }
      },
      "pendingOneTimePayment": {
        hr: translations === null || translations === void 0 ? void 0 : translations.YouHavePendingMonthlyPayment,
        body: "".concat(translations === null || translations === void 0 ? void 0 : translations.OTPMonthlyPaymentAlreadyscheduledMsg1, " ").concat(moment(firstMonthlyPaymentDate).format("MM/DD/YYYY"), " ").concat(translations === null || translations === void 0 ? void 0 : translations.OTPMonthlyPaymentAlreadyscheduledMsg2),
        buttonOne: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalNo,
        buttonTwo: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalYes,
        buttonOneClick: function () {
          return closeModal();
        },
        buttonTwoClick: function () {
          return paymentCallback(true);
        }
      },
      "oneDelinquentPayment": {
        hr: translations === null || translations === void 0 ? void 0 : translations.OtpDelAlertModalTitle,
        body: "<span><span>".concat(translations === null || translations === void 0 ? void 0 : translations.OtpDelAlertMessageLine1, "</span><br /><span>").concat(translations === null || translations === void 0 ? void 0 : translations.OtpDelAlertMessageLine2, "</span></span>"),
        buttonOne: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalNo,
        buttonTwo: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalYes,
        buttonOneClick: function () {
          return closeModal();
        },
        buttonTwoClick: function () {
          return paymentCallback(true);
        }
      },
      "paymentSubmitted": ((_b = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _b === void 0 ? void 0 : _b.lienPriorityType) == 2 && !(((_c = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _c === void 0 ? void 0 : _c.pendingPayments) || []).some(function (d) {
        return d.paymentType == 201309;
      }) ? {
        hr: translations === null || translations === void 0 ? void 0 : translations.PaymentSubmitted,
        body: "<span><span>".concat(translations.PaymentSubmittedMessage, "</span><span>").concat((_d = translations.PaymentConfirmationNumberMessage) === null || _d === void 0 ? void 0 : _d.replace("{0}", "<b>".concat(displayedConfirmationId, "</b>")), "</span><br/><br/>").concat(translations.CesAchComplete, "</span>"),
        buttonOne: translations.PaymentButtonEnroll,
        buttonTwo: translations.NoContinue,
        buttonOneClick: function () {
          PnmacNavigation(__assign({
            action: {
              pathname: "/Payment/Ach"
            },
            layout: layout
          }, rest));
          closeModal();
          rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Go to ACH payment CES Clicked ", 0);
        },
        buttonTwoClick: function () {
          var _a;
          PnmacNavigation(__assign({
            action: {
              pathname: "/Payment/Pending"
            },
            layout: layout
          }, rest));
          closeModal();
          rest.refreshBankData(layout.selectedLoanNumber);
          rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "No thanks ACH CES Clicked", 0);
          if (getActiveFeatures(layout.features, "in_app_survey", layout.whitelisted) && !rest.edit) {
            var days = getActiveFeaturesDescription(layout.features, "in_app_survey");
            days = days ? JSON.parse(days).surveyTimeoutInDays : 1000;
            var tocount = (_a = layout.reviews) === null || _a === void 0 ? void 0 : _a.find(function (s) {
              return s.daysSinceLastSeen <= days;
            });
            var appDevice_1 = Platform.select({
              android: "Android",
              ios: "IOS"
            });
            if (!tocount) {
              Rate.rate(function (success, errorMessage) {
                if (success) {
                  // this technically only tells us if the user successfully went to the Review Page. Whether they actually did anything, we do not know.
                  rest.review_request();
                  rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_1, " - User successfully went to the mobile survey."), 0);
                }
                if (errorMessage) {
                  // errorMessage comes from the native code. Useful for debugging, but probably not for users to view
                  rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_1, " - Something went wrong with appstore lib"), 0);
                }
              });
              rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_1, " - Request to app stores for a mobile survey"), 0);
            } else {
              rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_1, " - Criteria not met to send survey req to app store"), 0);
            }
          }
        }
      } : layout.closedEndSeconds && ((_e = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _e === void 0 ? void 0 : _e.lienPriorityType) != 2 && layout.closedEndSeconds.loanId != layout.selectedLoanNumber && (((_f = layout === null || layout === void 0 ? void 0 : layout.closedEndSeconds) === null || _f === void 0 ? void 0 : _f.pendingPayments.filter(function (d) {
        return d.status != 201295 && !(d.paymentType == 201309 && moment(d.effectiveDate).month() > moment().month());
      })) || []).length == 0 ? {
        hr: translations === null || translations === void 0 ? void 0 : translations.PaymentSubmitted,
        body: "<span><span>".concat(translations.PaymentSubmittedMessage, "</span><span>").concat((_g = translations.PaymentConfirmationNumberMessage) === null || _g === void 0 ? void 0 : _g.replace("{0}", "<b>".concat(displayedConfirmationId, "</b>")), "</span><br/><br/>").concat(translations.ClosedEndSeconds, "</span>"),
        buttonOne: translations.PaymentButtonYes,
        buttonTwo: translations.PaymentButtonNo,
        buttonOneClick: function () {
          LocalStorage.storeDataString("PennyTime", layout.closedEndSeconds.loanId);
          PnmacNavigation(__assign({
            action: {
              pathname: "/ClosedEndSeconds"
            },
            layout: layout
          }, rest));
          closeModal();
          rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Go to one time payment CES Clicked ", 0);
          rest.dispatch({
            type: RESET_STATE,
            seconds: true
          });
          rest.authenticate();
        },
        buttonTwoClick: function () {
          var _a;
          PnmacNavigation(__assign({
            action: {
              pathname: "/Payment/Pending"
            },
            layout: layout
          }, rest));
          closeModal();
          rest.refreshBankData(layout.selectedLoanNumber);
          rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "No thanks CES Clicked", 0);
          if (getActiveFeatures(layout.features, "in_app_survey", layout.whitelisted) && !rest.edit) {
            var days = getActiveFeaturesDescription(layout.features, "in_app_survey");
            days = days ? JSON.parse(days).surveyTimeoutInDays : 1000;
            var tocount = (_a = layout.reviews) === null || _a === void 0 ? void 0 : _a.find(function (s) {
              return s.daysSinceLastSeen <= days;
            });
            var appDevice_2 = Platform.select({
              android: "Android",
              ios: "IOS"
            });
            if (!tocount) {
              Rate.rate(function (success, errorMessage) {
                if (success) {
                  // this technically only tells us if the user successfully went to the Review Page. Whether they actually did anything, we do not know.
                  rest.review_request();
                  rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_2, " - User successfully went to the mobile survey."), 0);
                }
                if (errorMessage) {
                  // errorMessage comes from the native code. Useful for debugging, but probably not for users to view
                  rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_2, " - Something went wrong with appstore lib"), 0);
                }
              });
              rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_2, " - Request to app stores for a mobile survey"), 0);
            } else {
              rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_2, " - Criteria not met to send survey req to app store"), 0);
            }
          }
        }
      } : {
        hr: translations === null || translations === void 0 ? void 0 : translations.PaymentSubmitted,
        // body: `<span><span>${translations.PaymentSubmittedMessage}</span><span>${translations.PaymentConfirmationNumberMessage?.replace("{0}", `<b>${displayedConfirmationId}</b>`)}</span><span>${translations.AlertPostCutOffOHolidayWarning}</span></span>`,
        body: "<span><span>".concat(translations.PaymentSubmittedMessage, "</span><span>").concat((_h = translations.PaymentConfirmationNumberMessage) === null || _h === void 0 ? void 0 : _h.replace("{0}", "<b>".concat(displayedConfirmationId, "</b>")), "</span></span>"),
        buttonOne: null,
        buttonTwo: translations === null || translations === void 0 ? void 0 : translations.ModalPopupOkButtonText,
        buttonOneClick: null,
        buttonTwoClick: function () {
          var _a;
          PnmacNavigation(__assign({
            action: {
              pathname: "/Payment/Pending"
            },
            layout: layout
          }, rest));
          closeModal();
          rest.refreshBankData(layout.selectedLoanNumber);
          if (getActiveFeatures(layout.features, "in_app_survey", layout.whitelisted) && !rest.edit) {
            var days = getActiveFeaturesDescription(layout.features, "in_app_survey");
            days = days ? JSON.parse(days).surveyTimeoutInDays : 1000;
            var tocount = (_a = layout.reviews) === null || _a === void 0 ? void 0 : _a.find(function (s) {
              return s.daysSinceLastSeen <= days;
            });
            var appDevice_3 = Platform.select({
              android: "Android",
              ios: "IOS"
            });
            if (!tocount) {
              Rate.rate(function (success, errorMessage) {
                if (success) {
                  // this technically only tells us if the user successfully went to the Review Page. Whether they actually did anything, we do not know.
                  rest.review_request();
                  rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_3, " - User successfully went to the mobile survey."), 0);
                }
                if (errorMessage) {
                  // errorMessage comes from the native code. Useful for debugging, but probably not for users to view
                  rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_3, " - Something went wrong with appstore lib"), 0);
                }
              });
              rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_3, " - Request to app stores for a mobile survey"), 0);
            } else {
              rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_3, " - Criteria not met to send survey req to app store"), 0);
            }
          }
        }
      },
      "achPaymentSubmitted": {
        hr: translations === null || translations === void 0 ? void 0 : translations.ApplicationSubmitted,
        body: translations.AutoPaySubmittedMessageLine1,
        buttonOne: null,
        buttonTwo: translations === null || translations === void 0 ? void 0 : translations.Close,
        buttonOneClick: null,
        buttonTwoClick: function () {
          PnmacNavigation(__assign({
            action: {
              pathname: "/Payment/Ach"
            },
            layout: layout
          }, rest));
          closeModal();
          rest.dispatch({
            type: RESET_STATE,
            seconds: true
          });
          rest.authenticate();
        }
      }
    }[modalType];
  };
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacModal, {
    open: open,
    style: {
      borderRadius: 10
    }
  }, /*#__PURE__*/React.createElement(View, {
    accessibilityRole: layout.mobile ? "alert" : "dialog",
    accessibilityLabel: "One time payment confirmation information",
    style: __assign(__assign({}, useStyles.paper), {
      maxWidth: matches.small ? "90%" : 500,
      maxHeight: "60%",
      flex: 1,
      flexDirection: "column"
    })
  }, /*#__PURE__*/React.createElement(View, {
    accessibilityRole: "header",
    accessibilityLevel: 1
  }, /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: "txtOTPPaymentConfirmation",
    style: __assign(__assign({}, textStyle.defaultTextTitle), {
      textAlign: "center",
      marginBottom: 20
    })
  }, (_b = display()) === null || _b === void 0 ? void 0 : _b.hr)), /*#__PURE__*/React.createElement(ScrollView, null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, rest, {
    layout: layout,
    value: (_c = display()) === null || _c === void 0 ? void 0 : _c.body
  }))), /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }
  }, ((_d = display()) === null || _d === void 0 ? void 0 : _d.buttonOne) ? /*#__PURE__*/React.createElement(PnmacUIButton, {
    idTag1: 'btnButtonOne',
    idTag7: 'txtOne',
    testID: "ModalPopupOkButtonText",
    mode: 'outlined',
    style: __assign(__assign({}, styles.accountSettings.button), {
      width: matches.small ? "90%" : "50%",
      marginTop: 50
    }),
    onPress: function () {
      display().buttonOneClick();
    }
  }, (_e = display()) === null || _e === void 0 ? void 0 : _e.buttonOne) : null, /*#__PURE__*/React.createElement(PnmacUIButton, {
    mode: 'contained',
    idTag1: 'btnButtonTwo',
    idTag7: 'txtTwo',
    style: __assign(__assign({}, styles.accountSettings.button), {
      width: matches.small ? "90%" : "50%",
      marginTop: 25
    }),
    testID: "ModalPopupOkButtonText",
    onPress: function () {
      display().buttonTwoClick();
    }
  }, (_f = display()) === null || _f === void 0 ? void 0 : _f.buttonTwo)))));
}
var NachaAddBanks = /** @class */function (_super) {
  __extends(NachaAddBanks, _super);
  function NachaAddBanks(props) {
    var _this = _super.call(this, props) || this;
    _this.addBankAccount = function () {
      var layout = _this.props.layout;
      var _a = _this.state,
        banks = _a.banks,
        newAccountNumber = _a.newAccountNumber,
        newAccountRoutingNumber = _a.newAccountRoutingNumber,
        newBankAccountType = _a.newBankAccountType,
        accountFirstName = _a.accountFirstName,
        accountMiddleName = _a.accountMiddleName,
        accountLastName = _a.accountLastName,
        borrowerId = _a.borrowerId,
        last4ofSSN = _a.last4ofSSN,
        accountFirstNameChanged = _a.accountFirstNameChanged,
        accountMiddleNameChanged = _a.accountMiddleNameChanged,
        accountLastNameChanged = _a.accountLastNameChanged,
        newAccountNumberChanged = _a.newAccountNumberChanged,
        newAccountRoutingNumberChanged = _a.newAccountRoutingNumberChanged,
        newAccountNumberRepeatChanged = _a.newAccountNumberRepeatChanged;
      var accountName = "".concat(accountFirstName, " ").concat(accountMiddleName, " ").concat(accountLastName);
      var b = banks || [];
      var account = b === null || b === void 0 ? void 0 : b.filter(function (s) {
        return s.unmaskedAccountNumber == newAccountNumber && s.routingTransitNumber == newAccountRoutingNumber;
      });
      if (account.length > 0) {
        _this.setState({
          duplicateroutingAndAccountNumber: true
        });
      } else {
        var today = new Date();
        var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        var dateTime = date + ' ' + time;
        var newBank = {
          accountNumber: newAccountNumber.replace(/\d(?=\d{4})/g, "*"),
          unmaskedAccountNumber: newAccountNumber,
          confirmAccountNumber: newAccountNumber,
          routingTransitNumber: newAccountRoutingNumber,
          bankAccountType: newBankAccountType,
          accountFirstName: accountFirstName,
          accountMiddleName: accountMiddleName,
          accountLastName: accountLastName,
          borrowerid: borrowerId,
          loanId: layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber,
          last4ofSSN: last4ofSSN,
          accountName: accountName,
          isRemoved: false,
          createDate: dateTime
        };
        var newlyAddedAccountIndex = _this.props.layout.paymentModel.bankAccounts.findIndex(function (s) {
          return s.newlyAdded;
        });
        if (newlyAddedAccountIndex > -1) {
          _this.props.layout.paymentModel.bankAccounts.splice(newlyAddedAccountIndex, 1);
        }
        _this.props.layout.paymentModel.bankAccounts.push(__assign(__assign({}, newBank), {
          newlyAdded: true
        }));
        _this.props.layout.paymentModel.bankAccounts.reverse();
        _this.props.dispatch({
          type: NACHA_BANKACCOUNT,
          paymentModel: _this.props.layout.paymentModel
        });
        _this.setState({
          banks: b,
          selectedBank: null,
          accountFirstName: '',
          accountMiddleName: '',
          selectedBorrower: -1,
          accountLastName: '',
          newAccountRoutingNumber: '',
          newAccountNumber: '',
          newAccountNumberRepeat: '',
          newBankAccountType: null,
          deleteit: '',
          yesname: null,
          duplicateroutingAndAccountNumber: false,
          accountName: '',
          accountFirstNameChanged: false,
          accountMiddleNameChanged: false,
          accountLastNameChanged: false,
          newAccountNumberChanged: false,
          newAccountRoutingNumberChanged: false,
          newAccountNumberRepeatChanged: false
        });
        _this.props.addBank(newBank);
      }
    };
    _this.removeBankAccount = function (removeAccount) {
      var layout = _this.props.layout;
      var banks = _this.state.banks;
      _this.setState({
        bankAccountRemoved: true
      });
      fetch("".concat(layout.pennyHomeUrl, "api/payment/remove_bank_account"), {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(layout.token)
        },
        body: JSON.stringify(__assign(__assign({}, removeAccount), {
          unmaskedAccountNumber: undefined,
          unmaskedAccountNumberEncode: encryptBankAccountNumber(removeAccount.unmaskedAccountNumber)
        }))
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        if (data) {
          var delBanks = banks === null || banks === void 0 ? void 0 : banks.filter(function (bank) {
            return (bank === null || bank === void 0 ? void 0 : bank.bankAccountId) !== data.bankAccountId;
          });
          _this.setState({
            banks: delBanks,
            selectedBank: null,
            selectedBorrower: -1,
            accountFirstName: '',
            accountMiddleName: '',
            accountLastName: '',
            newAccountRoutingNumber: '',
            newAccountNumber: '',
            newAccountNumberRepeat: '',
            newBankAccountType: null,
            yesname: null,
            deleteit: '',
            duplicateroutingAndAccountNumber: false,
            accountName: '',
            accountFirstNameChanged: false,
            accountMiddleNameChanged: false,
            accountLastNameChanged: false,
            newAccountNumberChanged: false,
            newAccountRoutingNumberChanged: false,
            newAccountNumberRepeatChanged: false
          });
          _this.props.dispatch({
            type: SELECT_LOAN,
            loanId: layout.selectedLoanNumber
          });
          _this.props.refreshSingleLoanData(layout.selectedLoanNumber);
        }
      });
      _this.setState({
        bankAccountRemoved: false
      });
    };
    _this.expRef = /*#__PURE__*/React.createRef();
    _this.pushHederRef = /*#__PURE__*/React.createRef();
    _this.state = {
      deleteit: null,
      borrowers: null,
      selectedBorrower: -1,
      yesname: null,
      banks: [],
      newAccountNumber: '',
      newAccountRoutingNumber: '',
      newAccountNumberRepeat: '',
      newBankAccountType: null,
      accountFirstName: '',
      accountMiddleName: '',
      accountLastName: '',
      accountFirstNameChanged: false,
      accountMiddleNameChanged: false,
      accountLastNameChanged: false,
      newAccountNumberChanged: false,
      newAccountRoutingNumberChanged: false,
      newAccountNumberRepeatChanged: false,
      borrowerId: 0,
      selectedBank: null,
      firstNameError: false,
      lastNameError: false,
      nameOnBankAccountLengthError: false,
      newAccountNumberError: false,
      newAccountNumberRepeatError: false,
      newAccountRoutingNumberError: false,
      yesNameError: false,
      last4ofSSN: null,
      accountName: null,
      duplicateroutingAndAccountNumber: false,
      bankAccountRemoved: false,
      payment: _this.props.payment
    };
    return _this;
  }
  NachaAddBanks.getDerivedStateFromProps = function (props, state) {
    var _a, _b, _c, _d, _e, _f;
    return __assign(__assign({}, state), {
      banks: ((_c = (_b = (_a = props.layout) === null || _a === void 0 ? void 0 : _a.paymentModel) === null || _b === void 0 ? void 0 : _b.bankAccounts) === null || _c === void 0 ? void 0 : _c.filter(function (r) {
        return r.isRemoved === false;
      })) || [],
      borrowers: (_f = (_e = (_d = props.layout) === null || _d === void 0 ? void 0 : _d.currentLoan) === null || _e === void 0 ? void 0 : _e.borrowerSummary) === null || _f === void 0 ? void 0 : _f.filter(function (borrower) {
        var _a;
        return borrower.loanId === ((_a = props.layout) === null || _a === void 0 ? void 0 : _a.selectedLoanNumber) && borrower.customerDeceasedFlag === false;
      }) //changes SVT-42623
    });
  };
  NachaAddBanks.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      layout = _a.layout,
      matches = _a.matches,
      translations = _a.translations;
    var _b = this.state,
      banks = _b.banks,
      borrowers = _b.borrowers;
    var borrowernames = (borrowers === null || borrowers === void 0 ? void 0 : borrowers.map(function (borrower) {
      var _a, _b, _c;
      return {
        label: "".concat((_a = borrower === null || borrower === void 0 ? void 0 : borrower.borrowerFirstName) !== null && _a !== void 0 ? _a : "", " ").concat((_b = borrower === null || borrower === void 0 ? void 0 : borrower.borrowerMiddleName) !== null && _b !== void 0 ? _b : "", " ").concat((_c = borrower === null || borrower === void 0 ? void 0 : borrower.borrowerLastName) !== null && _c !== void 0 ? _c : ""),
        value: parseInt(borrower === null || borrower === void 0 ? void 0 : borrower.borrowerId)
      };
    })) || [];
    var nonborower = [{
      label: 'Non Borrower',
      value: 0
    }];
    var borrowersnameList = (borrowernames === null || borrowernames === void 0 ? void 0 : borrowernames.concat(nonborower)) || nonborower;
    var Func = function (_a) {
      var d = _a.d;
      return _this.state.deleteit != d ? /*#__PURE__*/React.createElement(PnmacRadioButton, {
        disabled: false,
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Remove account-Remove|Mobile', -1, d, false);
          _this.setState({
            deleteit: d
          });
        }
      }) : /*#__PURE__*/React.createElement(View, {
        style: {
          fontSize: matches.small ? 10 : 14,
          display: "flex",
          flexDirection: "column",
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          marginBottom: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'lblNachaRemoveBankConfirmMessge'
      }, translations === null || translations === void 0 ? void 0 : translations.NachaRemoveBankConfirmMessge)), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: matches.small ? 'column' : 'row',
          justifyContent: "space-between",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        style: {
          flex: 1
        },
        disabled: layout.pennyWise,
        mode: 'contained',
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Div, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Clicked on Removed a Bank Section", 0);
          _this.removeBankAccount(_this.state.deleteit);
        }
      }, "Confirm"), /*#__PURE__*/React.createElement(PnmacUIButton, {
        style: {
          marginLeft: matches.small ? 0 : 10,
          marginTop: matches.small ? 10 : 0,
          flex: 1
        },
        mode: 'outlined',
        onPress: function () {
          _this.setState({
            deleteit: ''
          });
        }
      }, "Cancel")));
    };
    var tableHead = ['Eligible Bank Accounts', 'Account Type', 'Remove'];
    var allInputsFilled = (this.state.yesname !== null || this.state.selectedBorrower == 0) && !isEmptyOrSpaces(this.state.newAccountNumber) && !this.state.newAccountNumberError && this.state.newAccountNumberRepeat === this.state.newAccountNumber && !isEmptyOrSpaces(this.state.newAccountRoutingNumber) && this.state.newBankAccountType !== null && !this.state.newAccountRoutingNumberError && !isEmptyOrSpaces(this.state.accountFirstName) && !isEmptyOrSpaces(this.state.accountLastName) && !this.state.nameOnBankAccountLengthError;
    var tableData = banks.filter(function (s) {
      return !s.newlyAdded;
    }).map(function (bank) {
      var _a;
      return [/*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1,
          flexDirection: "column"
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: __assign(__assign({}, textStyle.formBody), {
          padding: 5
        })
      }, "Account Number: ", (_a = bank.accountNumber) === null || _a === void 0 ? void 0 : _a.replace(/\d(?=\d{4})/g, "*")), /*#__PURE__*/React.createElement(PnmacText, {
        style: __assign(__assign({}, textStyle.formBody), {
          padding: 5
        })
      }, "Routing Number: ", bank.routingTransitNumber)), /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: __assign(__assign({}, textStyle.formBody), {
          padding: 5
        })
      }, bank.bankAccountType === 201286 ? "Checking" : bank.bankAccountType === 201287 ? "Savings" : bank.bankAccountType === 201288 ? translations.eDis_Debit_Card : translations.eDis_Unknown), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          alignItems: matches.small ? "center" : "flex-start"
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexWrap: "wrap"
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          padding: 5
        }
      }, /*#__PURE__*/React.createElement(Func, {
        d: bank
      }))))];
    });
    return /*#__PURE__*/React.createElement(PnmacSectionListView, {
      noShadow: true,
      idTag1: 'listViewNachaAddOrManageBankAccount',
      ref: this.pushHederRef,
      data: [{
        title: translations.NachaAddOrManageBankAccount,
        data: [{
          header: translations.NachaAddOrManageBankAccount
        }]
      }],
      collapsableSections: true,
      expandCallback: function (item) {
        if (item == "Add or Manage Bank Accounts") {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Div, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "click on Add or Manage Bank Account section", 0);
        }
      },
      renderItem: function (_a, collapsed) {
        var item = _a.item,
          index = _a.index;
        if (collapsed.some(function (s) {
          return s == item.header;
        })) {
          if (item.header == translations.NachaAddOrManageBankAccount) {
            return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
              queries: {
                small: "(max-width: 599px)",
                smallMedium: "(max-width: 938px)",
                medium: "(min-width: 600px) and (max-width: 1199px)",
                mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
                large: "(min-width: 1200px)"
              }
            }, function (matches) {
              var _a, _b;
              return /*#__PURE__*/React.createElement(View, {
                style: {
                  width: "100%",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 20
                }
              }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
                style: textStyle.defaultTextTitle
              }, translations.AddBank_Note)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
                layout: layout,
                value: translations.NachaNoteForAddBankAccount
              }))), /*#__PURE__*/React.createElement(View, {
                style: {
                  display: "flex",
                  justifyContent: "center"
                }
              }, /*#__PURE__*/React.createElement(View, {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  width: "100%"
                }
              }, /*#__PURE__*/React.createElement(PnmacPaper, {
                containerStyles: {
                  overflow: "visible",
                  backgroundColor: "#FFF",
                  marginTop: 20,
                  marginBottom: 20,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  elevation: 1,
                  width: "100%",
                  cursor: "auto"
                }
              }, /*#__PURE__*/React.createElement(View, {
                style: {
                  display: matches.small ? "flex" : "initial",
                  flexDirection: matches.small ? "column" : "flex-start",
                  alignItems: "center",
                  paddingBottom: 30,
                  width: "100%"
                }
              }, /*#__PURE__*/React.createElement(View, {
                style: {
                  marginBottom: 20
                }
              }, /*#__PURE__*/React.createElement(PnmacText, {
                idTag1: 'lblNachaAddOrManageBankAccountSubHeading',
                style: __assign({}, textStyle.defaultTextTitle)
              }, translations.NachaAddOrManageBankAccountSubHeading)), /*#__PURE__*/React.createElement(PnmacCard, {
                style: {
                  width: matches.small ? "97%" : "93%",
                  marginLeft: matches.small ? 0 : 20
                }
              }, /*#__PURE__*/React.createElement(PnmacTable, {
                style: {
                  width: "100%"
                },
                borderstyle: {
                  borderColor: 'transparent'
                }
              }, /*#__PURE__*/React.createElement(PnmacRow, {
                noBorder: true,
                flexArr: [3, 2, 3],
                data: tableHead,
                style: __assign(__assign({}, styles.eDisbursement.head), {
                  height: "auto",
                  paddingLeft: 5
                }),
                textStyle: __assign(__assign({}, styles.eDisbursement.textHead), textStyle.defaultTextTitle)
              }), !_this.state.bankAccountRemoved ? ((_a = banks === null || banks === void 0 ? void 0 : banks.filter(function (s) {
                return !s.newlyAdded;
              })) === null || _a === void 0 ? void 0 : _a.length) > 0 ? tableData === null || tableData === void 0 ? void 0 : tableData.map(function (rowData, index) {
                return /*#__PURE__*/React.createElement(View, {
                  key: "rowKey".concat(index)
                }, /*#__PURE__*/React.createElement(PnmacRow, {
                  key: index,
                  flexArr: [3, 2, 3],
                  data: rowData,
                  style: {
                    borderBottomWidth: 0,
                    paddingLeft: 10,
                    backgroundColor: index % 2 === 0 ? '#fff' : '#efefef',
                    borderBottomLeftRadius: index === tableData.length - 1 ? 10 : 0,
                    borderBottomRightRadius: index === tableData.length - 1 ? 10 : 0
                  },
                  textStyle: __assign(__assign({}, styles.eDisbursement.text), textStyle.formBody)
                }));
              }) : /*#__PURE__*/React.createElement(View, {
                style: {
                  padding: 10
                }
              }, /*#__PURE__*/React.createElement(PnmacText, {
                idTag1: 'lblNachaNoBankAccounts',
                style: textStyle.formBody
              }, translations.NoBankAccounts)) : /*#__PURE__*/React.createElement(View, {
                style: {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginTop: 50,
                  marginBottom: 50
                }
              }, /*#__PURE__*/React.createElement(FadeLoader, {
                size: 200,
                color: "#003187",
                loading: true
              }))))), ((_b = banks === null || banks === void 0 ? void 0 : banks.filter(function (s) {
                return !s.newlyAdded;
              })) === null || _b === void 0 ? void 0 : _b.length) >= 5 ? /*#__PURE__*/React.createElement(View, {
                style: {
                  display: "flex",
                  flexDirection: matches.small || matches.medium ? "column" : "row",
                  alignItems: matches.small || matches.medium ? "flex-start" : "center"
                }
              }, /*#__PURE__*/React.createElement(PnmacText, {
                idTag1: 'lblMaximumBankAccountMessage',
                style: __assign(__assign({}, textStyle.formBody), {
                  color: "red"
                })
              }, translations === null || translations === void 0 ? void 0 : translations.MaximumBankAccountMessage)) : null, /*#__PURE__*/React.createElement(View, {
                style: {
                  width: "100%"
                }
              }, /*#__PURE__*/React.createElement(PnmacSectionListView, {
                noShadow: true,
                idTag1: 'listViewNachaAddNewBankAccount',
                ref: _this.expRef,
                data: [{
                  title: translations === null || translations === void 0 ? void 0 : translations.NachaAddNewBankAccount,
                  data: [{
                    header: translations === null || translations === void 0 ? void 0 : translations.NachaAddNewBankAccount
                  }]
                }],
                expandCallback: function (item) {
                  if (item == "Add a New Bank Account") {}
                },
                collapsableSections: true,
                renderItem: function (_a, collapsed) {
                  var _b;
                  var item = _a.item,
                    index = _a.index;
                  if (collapsed.some(function (s) {
                    return s == item.header;
                  })) {
                    if (item.header == (translations === null || translations === void 0 ? void 0 : translations.NachaAddNewBankAccount)) {
                      if (((_b = banks === null || banks === void 0 ? void 0 : banks.filter(function (s) {
                        return !s.newlyAdded;
                      })) === null || _b === void 0 ? void 0 : _b.length) >= 5) {
                        return null;
                      }
                      return /*#__PURE__*/React.createElement(View, {
                        style: matches.small ? {} : {
                          paddingLeft: 20,
                          paddingRight: 10,
                          paddingTop: 10
                        }
                      }, /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(HtmlToNativeNative, {
                        value: translations === null || translations === void 0 ? void 0 : translations.NachaBusinessProcessMessage
                      })), /*#__PURE__*/React.createElement(View, {
                        style: {
                          marginTop: 10
                        }
                      }, /*#__PURE__*/React.createElement(PnmacText, {
                        style: textStyle.formBody,
                        idTag1: 'txtNachaBankBelongBorrower'
                      }, translations.bankBelongBorrower)), /*#__PURE__*/React.createElement(View, {
                        style: {
                          alignSelf: "flex-start",
                          display: "flex",
                          flexDirection: "column",
                          marginTop: 20,
                          width: matches.small ? "100%" : "50%"
                        }
                      }, /*#__PURE__*/React.createElement(View, {
                        style: {
                          marginTop: 10,
                          marginBottom: 10
                        }
                      }, /*#__PURE__*/React.createElement(PnmacText, {
                        style: textStyle.formBody,
                        idTag1: 'txtNachaBorrowersSelectMessage'
                      }, translations.NachaBorrowersSelectMessage)), /*#__PURE__*/React.createElement(View, {
                        onPress: function () {
                          _this.setState({
                            selectedBank: null
                          });
                          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Div, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Add a Bank section", 0);
                        }
                      }, /*#__PURE__*/React.createElement(PnmacSelect, {
                        accessibilityLabel: "Select borrower",
                        idTag1: 'borrowerSelect',
                        Icon: layout.mobile && Platform.OS === 'ios' ? function () {
                          return /*#__PURE__*/React.createElement(Image, {
                            style: {
                              marginTop: 3,
                              marginRight: 5,
                              width: 12,
                              height: 8
                            },
                            source: require("../../assets/expand-icon.png")
                          });
                        } : function () {
                          return null;
                        },
                        placeholder: {
                          label: 'Select a name...',
                          value: -1
                        },
                        onValueChange: function (value) {
                          if (!isNaN(value) && parseInt(value) > 1) {
                            var bor = borrowers.find(function (s) {
                              return s.borrowerId == parseInt(value);
                            });
                            if (bor) {
                              _this.setState({
                                selectedBank: null,
                                selectedBorrower: value,
                                accountFirstName: "",
                                accountMiddleName: "",
                                accountLastName: "",
                                borrowerId: bor === null || bor === void 0 ? void 0 : bor.borrowerId,
                                last4ofSSN: bor.borrowerLastFourSsn,
                                accountName: null,
                                accountFirstNameChanged: false,
                                accountMiddleNameChanged: false,
                                accountLastNameChanged: false,
                                newAccountNumberChanged: false,
                                newAccountRoutingNumberChanged: false,
                                newAccountNumberRepeatChanged: false
                              });
                              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.SelectOne, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "customers selecting a name from drop down", 0);
                            }
                          } else if (parseInt(value) == 0) {
                            _this.setState({
                              selectedBorrower: value,
                              accountFirstName: "",
                              accountMiddleName: "",
                              accountLastName: "",
                              borrowerId: 0,
                              last4ofSSN: null,
                              accountName: null,
                              firstNameError: true,
                              lastNameError: true,
                              accountFirstNameChanged: false,
                              accountMiddleNameChanged: false,
                              accountLastNameChanged: false,
                              newAccountNumberChanged: false,
                              newAccountRoutingNumberChanged: false,
                              newAccountNumberRepeatChanged: false
                            });
                            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.SelectOne, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "customers selecting a NonBorrower from drop down", 0);
                          }
                        },
                        value: parseInt(_this.state.selectedBorrower),
                        items: borrowersnameList,
                        useNativeAndroidPickerStyle: Platform.select({
                          android: true,
                          web: true,
                          ios: true
                        }),
                        style: {
                          viewContainer: __assign({}, layout.mobile ? {
                            flex: 1,
                            justifyContent: "center",
                            backgroundColor: "white",
                            borderRadius: 10,
                            height: 50,
                            width: '100%',
                            borderColor: '#707070',
                            borderWidth: 1
                          } : null),
                          inputAndroid: {
                            color: "#707070",
                            width: '100%',
                            paddingLeft: 10,
                            paddingRight: 20
                          },
                          inputIOS: {
                            color: "#707070",
                            width: '100%',
                            paddingLeft: 10,
                            paddingRight: 20
                          }
                        }
                      }))), _this.state.selectedBorrower > 0 ? /*#__PURE__*/React.createElement(View, {
                        style: {
                          alignSelf: "flex-start",
                          display: "flex",
                          flexDirection: "column",
                          marginTop: 20,
                          paddingLeft: matches.small ? 0 : 10,
                          width: matches.small ? "100%" : "50%"
                        }
                      }, /*#__PURE__*/React.createElement(View, {
                        style: {
                          display: "flex",
                          flexDirection: "column"
                        }
                      }, /*#__PURE__*/React.createElement(View, {
                        style: {
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexWrap: "nowrap",
                          width: "100%",
                          marginBottom: 10
                        }
                      }, /*#__PURE__*/React.createElement(View, {
                        style: {
                          width: "80%"
                        }
                      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
                        layout: layout,
                        idTag1: 'txtNachaBorrowerNameSelectedMatch',
                        value: translations.NachaBorrowerNameSelectedMatch
                      })), /*#__PURE__*/React.createElement(PnmacRadioButtonGroup, {
                        onValueChange: function (val) {
                          var _a, _b, _c;
                          var bor = borrowers.find(function (s) {
                            return s.borrowerId == _this.state.selectedBorrower;
                          });
                          if (val == "yes") {
                            var firstName = (_a = bor.borrowerFirstName) !== null && _a !== void 0 ? _a : "";
                            var middleName = (_b = bor.borrowerMiddleName) !== null && _b !== void 0 ? _b : "";
                            var lastName = (_c = bor.borrowerLastName) !== null && _c !== void 0 ? _c : "";
                            _this.setState({
                              yesname: val,
                              accountFirstName: firstName,
                              accountMiddleName: middleName,
                              accountLastName: lastName,
                              borrowerId: bor === null || bor === void 0 ? void 0 : bor.borrowerId,
                              last4ofSSN: bor.borrowerLastFourSsn,
                              accountName: "".concat(firstName, " ").concat(middleName, " ").concat(lastName),
                              yesNameError: false
                            });
                            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Radio, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "customers selecting yes button that their name matches", 0);
                          } else {
                            _this.setState({
                              yesname: val,
                              accountFirstName: "",
                              accountMiddleName: "",
                              accountLastName: "",
                              yesNameError: false,
                              firstNameError: true,
                              lastNameError: true,
                              accountFirstNameChanged: false,
                              accountMiddleNameChanged: false,
                              accountLastNameChanged: false,
                              newAccountNumberChanged: false,
                              newAccountRoutingNumberChanged: false,
                              newAccountNumberRepeatChanged: false
                            });
                            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Radio, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "customers selecting no button that their name matches", 0);
                          }
                        },
                        value: _this.state.yesname
                      }, /*#__PURE__*/React.createElement(View, {
                        style: {
                          width: "20%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }
                      }, /*#__PURE__*/React.createElement(View, {
                        style: {
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          fontSize: 12
                        }
                      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
                        style: textStyle.formBody,
                        idTag1: 'txtNachaYes'
                      }, translations.yes)), /*#__PURE__*/React.createElement(PnmacRadioButton, {
                        idTag1: 'rbnNachaYes',
                        value: "yes",
                        status: _this.state.yesname ? "checked" : "unchecked"
                      })), /*#__PURE__*/React.createElement(View, {
                        style: {
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          fontSize: 12
                        }
                      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
                        style: textStyle.formBody,
                        idTag1: 'txtnNachaNo'
                      }, translations.no)), /*#__PURE__*/React.createElement(PnmacRadioButton, {
                        idTag1: 'rbnNachaNo',
                        value: "no"
                      }))))), _this.state.yesNameError ? /*#__PURE__*/React.createElement(View, {
                        style: {
                          color: "#b33734"
                        }
                      }, /*#__PURE__*/React.createElement(PnmacText, {
                        style: textStyle.formBody,
                        idTag1: 'lblNachaBorrowerNameValidationMessage'
                      }, translations === null || translations === void 0 ? void 0 : translations.NachaBorrowerNameValidationMessage)) : null)) : null, _this.state.yesname === 'no' || _this.state.selectedBorrower == 0 ? /*#__PURE__*/React.createElement(View, {
                        style: {
                          alignSelf: "flex-start",
                          display: "flex",
                          flexDirection: "column",
                          paddingLeft: 10
                        }
                      }, /*#__PURE__*/React.createElement(View, {
                        style: {
                          display: "flex",
                          flexDirection: "column",
                          marginTop: 20
                        }
                      }, /*#__PURE__*/React.createElement(View, {
                        style: {
                          width: "98%",
                          marginBottom: matches.small ? 20 : 0,
                          fontSize: matches.small ? 14 : 16
                        }
                      }, /*#__PURE__*/React.createElement(PnmacText, {
                        style: textStyle.formBody,
                        idTag1: 'lblNachaFirstNameLastNameMessage'
                      }, translations === null || translations === void 0 ? void 0 : translations.NachaFirstNameLastNameMessage)), _this.state.nameOnBankAccountLengthError ? layout.mobile ? /*#__PURE__*/React.createElement(View, {
                        style: {
                          paddingTop: 5,
                          paddingBottom: 15
                        }
                      }, /*#__PURE__*/React.createElement(PnmacText, {
                        style: {
                          color: 'red',
                          fontSize: 12
                        }
                      }, translations === null || translations === void 0 ? void 0 : translations.BankAccountLengthError)) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
                        style: __assign(__assign({}, textStyle.defaultTextDescription), {
                          color: 'red',
                          height: 15
                        })
                      }, translations === null || translations === void 0 ? void 0 : translations.BankAccountLengthError), /*#__PURE__*/React.createElement("br", null)) : null, /*#__PURE__*/React.createElement(View, {
                        style: {
                          display: "flex",
                          flexDirection: matches.small ? "column" : "row",
                          justifyContent: "space-between",
                          width: matches.small ? "98%" : "70%"
                        }
                      }, /*#__PURE__*/React.createElement(View, {
                        style: {
                          display: "flex",
                          flexDirection: "column"
                        }
                      }, /*#__PURE__*/React.createElement(PnmacText, {
                        style: [textStyle.defaultTextTitle, {
                          marginVertical: 10
                        }]
                      }, translations === null || translations === void 0 ? void 0 : translations.FirstName), /*#__PURE__*/React.createElement(PnmacTextInput, {
                        textAlign: 'left',
                        accessibilityLabel: "Account first name",
                        nativeID: "txtNachaAccountFirstName",
                        disabled: _this.state.selectedBank !== null,
                        mode: "outlined",
                        value: _this.state.accountFirstName,
                        placeholder: translations === null || translations === void 0 ? void 0 : translations.FirstName,
                        error: _this.state.firstNameError,
                        onChangeText: function (data) {
                          if (checkIfStringHasSpecialChar(data)) {
                            if (_this.state.accountFirstName != data) {
                              _this.setState({
                                accountFirstNameChanged: true
                              });
                            }
                            _this.setState({
                              accountFirstName: data
                            });
                          }
                        },
                        onBlur: function () {
                          if (isEmptyOrSpaces(_this.state.accountFirstName)) {
                            _this.setState({
                              firstNameError: true
                            });
                          } else {
                            _this.setState({
                              firstNameError: false
                            });
                            if (_this.state.accountFirstNameChanged == true) {
                              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Text, TrackerHitTypeLID_ENUM.Transaction, TrackerActionLID_ENUM.Select, "customers entering First Name", 0);
                              _this.setState({
                                accountFirstNameChanged: false
                              });
                            }
                          }
                          if (_this.state.accountFirstName.length + _this.state.accountMiddleName.length + _this.state.accountLastName.length > 50) {
                            _this.setState({
                              nameOnBankAccountLengthError: true
                            });
                          } else {
                            _this.setState({
                              nameOnBankAccountLengthError: false
                            });
                          }
                        }
                      })), /*#__PURE__*/React.createElement(View, {
                        style: {
                          display: "flex",
                          flexDirection: "column"
                        }
                      }, /*#__PURE__*/React.createElement(PnmacText, {
                        style: [textStyle.defaultTextTitle, {
                          marginTop: 10,
                          marginBottom: 10
                        }]
                      }, translations === null || translations === void 0 ? void 0 : translations.MiddleInitial), /*#__PURE__*/React.createElement(PnmacTextInput, {
                        textAlign: 'left',
                        accessibilityLabel: "Account middle name",
                        nativeID: "txtNachaAccountMiddleName",
                        disabled: _this.state.selectedBank !== null,
                        mode: "outlined",
                        value: _this.state.accountMiddleName,
                        placeholder: translations === null || translations === void 0 ? void 0 : translations.MiddleInitial,
                        error: "",
                        onChangeText: function (data) {
                          if (checkIfStringHasSpecialChar(data) && (data === null || data === void 0 ? void 0 : data.length) <= 1) {
                            if (_this.state.accountMiddleName != data) {
                              _this.setState({
                                accountMiddleNameChanged: true
                              });
                            }
                            _this.setState({
                              accountMiddleName: data
                            });
                          }
                        },
                        onBlur: function () {
                          if (!isEmptyOrSpaces(_this.state.accountMiddleName)) {
                            if (_this.state.accountMiddleNameChanged == true) {
                              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Text, TrackerHitTypeLID_ENUM.Transaction, TrackerActionLID_ENUM.Select, "customers entering Middle Name", 0);
                              _this.setState({
                                accountMiddleNameChanged: false
                              });
                            }
                          }
                          if (_this.state.accountFirstName.length + _this.state.accountMiddleName.length + _this.state.accountLastName.length > 50) {
                            _this.setState({
                              nameOnBankAccountLengthError: true
                            });
                          } else {
                            _this.setState({
                              nameOnBankAccountLengthError: false
                            });
                          }
                        }
                      })), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
                        style: [textStyle.defaultTextTitle, {
                          marginTop: 10,
                          marginBottom: 10
                        }]
                      }, translations === null || translations === void 0 ? void 0 : translations.LastName), /*#__PURE__*/React.createElement(PnmacTextInput, {
                        textAlign: 'left',
                        accessibilityLabel: "Account last name",
                        nativeID: "txtNachaAccountLastName",
                        disabled: _this.state.selectedBank !== null,
                        mode: "outlined",
                        value: _this.state.accountLastName,
                        placeholder: translations === null || translations === void 0 ? void 0 : translations.LastName,
                        error: _this.state.lastNameError,
                        onChangeText: function (data) {
                          if (checkIfStringHasSpecialChar(data)) {
                            if (_this.state.accountLastName != data) {
                              _this.setState({
                                accountLastNameChanged: true
                              });
                            }
                            _this.setState({
                              accountLastName: data
                            });
                          }
                        },
                        onBlur: function () {
                          if (isEmptyOrSpaces(_this.state.accountLastName)) {
                            _this.setState({
                              lastNameError: true
                            });
                          } else {
                            _this.setState({
                              lastNameError: false
                            });
                            if (_this.state.accountLastNameChanged == true) {
                              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Text, TrackerHitTypeLID_ENUM.Transaction, TrackerActionLID_ENUM.Select, "customers entering Last Name", 0);
                              _this.setState({
                                accountLastNameChanged: false
                              });
                            }
                          }
                          if (_this.state.accountFirstName.length + _this.state.accountMiddleName.length + _this.state.accountLastName.length > 50) {
                            _this.setState({
                              nameOnBankAccountLengthError: true
                            });
                          } else {
                            _this.setState({
                              nameOnBankAccountLengthError: false
                            });
                          }
                        }
                      }))))) : null, /*#__PURE__*/React.createElement(View, {
                        style: {
                          display: "flex",
                          flexDirection: matches.small ? "column" : "row",
                          alignSelf: "flex-start",
                          justifyContent: "space-between",
                          flexWrap: "wrap",
                          width: "100%",
                          paddingBottom: 10
                        }
                      }, /*#__PURE__*/React.createElement(View, {
                        style: layout.mobile ? {
                          width: "100%"
                        } : {
                          width: matches.smallMedium ? "100%" : "55%",
                          flex: 1,
                          flexDirection: "column",
                          alignSelf: "flex-start",
                          marginRight: matches.smallMedium ? 0 : 30
                        }
                      }, _this.state.duplicateroutingAndAccountNumber ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
                        style: [textStyle.formBody, {
                          color: "#b33734"
                        }]
                      }, translations === null || translations === void 0 ? void 0 : translations.NachaRoutingAndAccountNumberMessage)) : null, /*#__PURE__*/React.createElement(View, {
                        style: matches.small ? {
                          marginTop: 40
                        } : __assign(__assign({}, styles.eDisbursement.inputContainer), {
                          flexDirection: "row",
                          marginTop: 40
                        })
                      }, /*#__PURE__*/React.createElement(PnmacSubheading, {
                        idTag1: 'lblNachaNewAccountRoutingNumber',
                        style: __assign({}, textStyle.defaultTextTitle)
                      }, translations === null || translations === void 0 ? void 0 : translations.RoutingAndTransitNumber), /*#__PURE__*/React.createElement(PnmacTextInput, {
                        textAlign: 'left',
                        accessibilityLabel: "Account routing number",
                        nativeID: "txtNachaNewAccountRoutingNumber",
                        disabled: _this.state.selectedBank !== null,
                        mode: "outlined",
                        label: _this.state.newAccountRoutingNumberError ? translations === null || translations === void 0 ? void 0 : translations.RoutingNumberValidationMessage : translations === null || translations === void 0 ? void 0 : translations.RoutingAndTransitNumber,
                        style: {
                          width: matches.small ? "100%" : "50%"
                        },
                        value: _this.state.newAccountRoutingNumber,
                        placeholder: translations === null || translations === void 0 ? void 0 : translations.RoutingAndTransitNumber,
                        maxLength: 9,
                        error: _this.state.newAccountRoutingNumberError,
                        onChangeText: function (data) {
                          if (checkForAllNumbers(data)) {
                            if (_this.state.newAccountRoutingNumber != data) {
                              _this.setState({
                                newAccountRoutingNumberChanged: true
                              });
                            }
                            _this.setState({
                              newAccountRoutingNumber: data
                            });
                          }
                          if (checkForAllNumbers(data, 9)) {
                            // turn to POST
                            fetch(layout.pennyHomeUrl + "api/payment/ValidateRoutingNumber?routingnumber=".concat(data), {
                              method: 'POST',
                              headers: {
                                "Content-Type": "application/json; charset=utf-8",
                                "Authorization": "Bearer ".concat(layout.token)
                              }
                            }).then(function (res) {
                              return res.json();
                            }).then(function (isValidRoutingNumber) {
                              isValidRoutingNumber ? _this.setState({
                                newAccountRoutingNumberError: false
                              }) : _this.setState({
                                newAccountRoutingNumberError: true
                              });
                            });
                          } else {
                            _this.setState({
                              newAccountRoutingNumberError: true
                            });
                          }
                          if (!_this.state.yesname) {
                            _this.setState({
                              yesNameError: true
                            });
                          } else _this.setState({
                            yesNameError: false
                          });
                        },
                        onBlur: function () {
                          if (_this.state.newAccountRoutingNumberChanged == true) {
                            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "customers entering Routing Number", 0);
                            _this.setState({
                              newAccountRoutingNumberChanged: false
                            });
                          }
                          if (checkForAllNumbers(_this.state.newAccountRoutingNumber, 9)) {
                            // turn to POST
                            fetch(layout.pennyHomeUrl + "api/payment/ValidateRoutingNumber?routingnumber=".concat(_this.state.newAccountRoutingNumber), {
                              method: 'POST',
                              headers: {
                                "Content-Type": "application/json; charset=utf-8",
                                "Authorization": "Bearer ".concat(layout.token)
                              }
                            }).then(function (res) {
                              return res.json();
                            }).then(function (isValidRoutingNumber) {
                              isValidRoutingNumber ? _this.setState({
                                newAccountRoutingNumberError: false
                              }) : _this.setState({
                                newAccountRoutingNumberError: true
                              });
                            });
                          } else {
                            _this.setState({
                              newAccountRoutingNumberError: true
                            });
                          }
                          if (!_this.state.yesname) {
                            _this.setState({
                              yesNameError: true
                            });
                          } else _this.setState({
                            yesNameError: false
                          });
                        }
                      })), /*#__PURE__*/React.createElement(View, {
                        style: matches.small ? {
                          marginTop: 20,
                          flexDirection: "column"
                        } : __assign(__assign({}, styles.eDisbursement.inputContainer), {
                          flexDirection: "row"
                        })
                      }, /*#__PURE__*/React.createElement(PnmacSubheading, {
                        idTag1: 'lblNachaBankAccountNumber',
                        style: textStyle.defaultTextTitle
                      }, translations === null || translations === void 0 ? void 0 : translations.BankAccountNumber), /*#__PURE__*/React.createElement(PnmacTextInput, {
                        textAlign: 'left',
                        accessibilityLabel: "Bank account number",
                        nativeID: "txtNachaBankAccountNumber",
                        disabled: _this.state.selectedBank !== null,
                        mode: "outlined",
                        onContextMenu: function (e) {
                          return e.preventDefault();
                        },
                        style: {
                          width: matches.small ? "100%" : "50%"
                        },
                        value: _this.state.newAccountNumber,
                        placeholder: translations === null || translations === void 0 ? void 0 : translations.BankAccountNumber,
                        maxLength: 17,
                        label: _this.state.newAccountNumberError ? translations === null || translations === void 0 ? void 0 : translations.BankAccountNumberValidationMessage : translations === null || translations === void 0 ? void 0 : translations.BankAccountNumber,
                        error: _this.state.newAccountNumberError,
                        onChangeText: function (data) {
                          if (checkForAllNumbers(data)) {
                            if (_this.state.newAccountNumber != data) {
                              _this.setState({
                                newAccountNumberChanged: true
                              });
                            }
                            _this.setState({
                              newAccountNumber: data
                            });
                          }
                        },
                        onBlur: function () {
                          if (_this.state.newAccountNumberChanged == true) {
                            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "customers entering Bank account Number", 0);
                            _this.setState({
                              newAccountNumberChanged: false
                            });
                          }
                          if (isEmptyOrSpaces(_this.state.newAccountNumber) || checkForAllNumbers(_this.state.newAccountNumber, _this.state.newAccountNumber.length >= 5)) {
                            _this.setState({
                              newAccountNumberError: true
                            });
                          } else if (!isEmptyOrSpaces(_this.state.newAccountNumberRepeat) && _this.state.newAccountNumberRepeat !== _this.state.newAccountNumber) {
                            _this.setState({
                              newAccountNumberRepeatError: true
                            });
                          } else {
                            _this.setState({
                              newAccountNumberError: false
                            });
                            _this.setState({
                              newAccountNumberRepeatError: false
                            });
                          }
                          if (!_this.state.yesname) {
                            _this.setState({
                              yesNameError: true
                            });
                          } else _this.setState({
                            yesNameError: false
                          });
                        }
                      })), /*#__PURE__*/React.createElement(View, {
                        style: matches.small ? {
                          marginTop: 20,
                          flexDirection: "column"
                        } : __assign(__assign({}, styles.eDisbursement.inputContainer), {
                          flexDirection: "row"
                        })
                      }, /*#__PURE__*/React.createElement(PnmacSubheading, {
                        idTag1: 'lblNachaConfirmAccountNumber',
                        style: textStyle.defaultTextTitle
                      }, translations === null || translations === void 0 ? void 0 : translations.ConfirmAccountNumber), /*#__PURE__*/React.createElement(PnmacTextInput, {
                        textAlign: 'left',
                        accessibilityLabel: "Confirm account number",
                        nativeID: "txtNachaConfirmAccountNumber",
                        disabled: _this.state.selectedBank !== null,
                        mode: "outlined",
                        onContextMenu: function (e) {
                          return e.preventDefault();
                        },
                        style: {
                          width: matches.small ? "100%" : "50%"
                        },
                        label: _this.state.newAccountNumberRepeatError ? translations === null || translations === void 0 ? void 0 : translations.ConfirmAccountNumberValidationMessage : translations === null || translations === void 0 ? void 0 : translations.ConfirmAccountNumber,
                        value: _this.state.newAccountNumberRepeat,
                        placeholder: translations === null || translations === void 0 ? void 0 : translations.ConfirmAccountNumber,
                        maxLength: 17,
                        error: _this.state.newAccountNumberRepeatError,
                        onChangeText: function (data) {
                          if (checkForAllNumbers(data)) {
                            if (_this.state.newAccountNumberRepeat != data) {
                              _this.setState({
                                newAccountNumberRepeatChanged: true
                              });
                            }
                            _this.setState({
                              newAccountNumberRepeat: data
                            });
                          }
                        },
                        onBlur: function () {
                          if (_this.state.newAccountNumberRepeatChanged == true) {
                            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "customers reentering Bank account Number ", 0);
                            _this.setState({
                              newAccountNumberRepeatChanged: false
                            });
                          }
                          if (isEmptyOrSpaces(_this.state.newAccountNumberRepeat) || _this.state.newAccountNumberRepeat !== _this.state.newAccountNumber) {
                            _this.setState({
                              newAccountNumberRepeatError: true
                            });
                          } else {
                            _this.setState({
                              newAccountNumberRepeatError: false
                            });
                          }
                        }
                      })), /*#__PURE__*/React.createElement(View, {
                        style: matches.small ? {
                          marginTop: 20
                        } : __assign(__assign({}, styles.eDisbursement.inputContainer), {
                          flexDirection: "row"
                        })
                      }, /*#__PURE__*/React.createElement(PnmacSubheading, {
                        idTag1: 'lblNachaBankAccountType',
                        style: textStyle.defaultTextTitle
                      }, translations.BankAccountType), /*#__PURE__*/React.createElement(PnmacRadioButtonGroup, {
                        idTag1: 'rbnNachaBankAccountType',
                        onValueChange: function (val) {
                          var msg = val === 201286 ? "Checking" : "Savings";
                          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "customers selecting ".concat(msg), 0);
                          _this.setState({
                            newBankAccountType: val
                          });
                        },
                        value: _this.state.newBankAccountType
                      }, /*#__PURE__*/React.createElement(View, {
                        style: {
                          width: matches.small ? "60%" : "50%",
                          display: "flex",
                          flexDirection: "row",
                          alignSelf: matches.small ? "center" : "flex-start",
                          justifyContent: "space-between"
                        }
                      }, /*#__PURE__*/React.createElement(View, {
                        style: {
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          marginRight: matches.small ? 5 : 10
                        }
                      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
                        idTag1: 'lblNachaBankAccountTypeChecking',
                        style: textStyle.defaultTextDescription
                      }, translations === null || translations === void 0 ? void 0 : translations.Checking)), /*#__PURE__*/React.createElement(PnmacRadioButton, {
                        idTag1: 'rbnNachaBankAccountTypeChecking',
                        value: 201286
                      })), /*#__PURE__*/React.createElement(View, {
                        style: {
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          fontSize: 12
                        }
                      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
                        idTag1: 'lblNachaBankAccountTypeSaving',
                        style: textStyle.defaultTextDescription
                      }, translations === null || translations === void 0 ? void 0 : translations.Savings)), /*#__PURE__*/React.createElement(PnmacRadioButton, {
                        idTag1: 'rbnNachaBankAccountTypeSaving',
                        value: 201287
                      })))))), /*#__PURE__*/React.createElement(View, {
                        style: {
                          flex: 1,
                          alignSelf: "center",
                          alignItems: "center"
                        }
                      }, /*#__PURE__*/React.createElement(Image, {
                        source: require("../../assets/check-fill-info.png"),
                        style: {
                          width: 280,
                          height: 180
                        },
                        resizeMode: "contain",
                        alt: "blank check template"
                      }))), /*#__PURE__*/React.createElement(View, {
                        style: {
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          justifyContent: "space-between",
                          alignSelf: "center",
                          marginVertical: 15
                        }
                      }, /*#__PURE__*/React.createElement(View, {
                        style: {
                          marginRight: matches.small ? 0 : 10
                        }
                      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
                        nativeID: "btnNachaBankAccounCancel",
                        mode: "outlined",
                        onPress: function () {
                          var _a, _b;
                          var nachaAddOrManageBankAccount = translations === null || translations === void 0 ? void 0 : translations.NachaAddOrManageBankAccount;
                          var nachaAddNewBankAccount = translations === null || translations === void 0 ? void 0 : translations.NachaAddNewBankAccount;
                          _this.setState({
                            selectedBank: null,
                            selectedBorrower: -1,
                            accountFirstName: '',
                            accountMiddleName: '',
                            accountLastName: '',
                            newAccountRoutingNumber: '',
                            newAccountNumber: '',
                            newAccountNumberRepeat: '',
                            newBankAccountType: null,
                            yesname: null,
                            duplicateroutingAndAccountNumber: false,
                            accountName: '',
                            firstNameError: false,
                            lastNameError: false,
                            nameOnBankAccountLengthError: false,
                            newAccountNumberError: false,
                            newAccountNumberRepeatError: false,
                            newAccountRoutingNumberError: false,
                            yesNameError: false
                          });
                          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "click on Cancel at the bottom of the Add a New Bank Account page", 0);
                          var c = (_a = _this.pushHederRef) === null || _a === void 0 ? void 0 : _a.current.collapseItem(nachaAddOrManageBankAccount);
                          var newBK = (_b = _this.expRef) === null || _b === void 0 ? void 0 : _b.current.collapseItem(nachaAddNewBankAccount);
                          _this.props.checkNachaAddOrManageBanksOpen(false);
                        }
                      }, translations === null || translations === void 0 ? void 0 : translations.CancelText)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacUIButton, {
                        nativeID: "btnNachaBankAccounSubmit",
                        disabled: !allInputsFilled || layout.pennyWise ? true : false,
                        mode: "contained",
                        onPress: function () {
                          var _a, _b;
                          var _c = _this.state,
                            banks = _c.banks,
                            newAccountNumber = _c.newAccountNumber,
                            newAccountRoutingNumber = _c.newAccountRoutingNumber;
                          var account = banks === null || banks === void 0 ? void 0 : banks.filter(function (s) {
                            return s.unmaskedAccountNumber == newAccountNumber && s.routingTransitNumber == newAccountRoutingNumber;
                          });
                          if (account.length > 0) {
                            _this.setState({
                              duplicateroutingAndAccountNumber: true
                            });
                          } else {
                            var nachaAddOrManageBankAccount = translations === null || translations === void 0 ? void 0 : translations.NachaAddOrManageBankAccount;
                            var nachaAddNewBankAccount = translations === null || translations === void 0 ? void 0 : translations.NachaAddNewBankAccount;
                            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "click on Submit at the bottom of the Add a New Bank Account page", 0);
                            _this.addBankAccount();
                            var c = (_a = _this.pushHederRef) === null || _a === void 0 ? void 0 : _a.current.collapseItem(nachaAddOrManageBankAccount);
                            var newBK = (_b = _this.expRef) === null || _b === void 0 ? void 0 : _b.current.collapseItem(nachaAddNewBankAccount);
                            _this.props.checkNachaAddOrManageBanksOpen(false);
                          }
                        }
                      }, translations === null || translations === void 0 ? void 0 : translations.SubmitText))));
                    }
                  } else {
                    return null;
                  }
                },
                renderSectionHeader: function (_a) {
                  var _b, _c, _d, _e, _f;
                  var title = _a.section.title;
                  var open = ((_c = (_b = _this.expRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1;
                  return /*#__PURE__*/React.createElement(PnmacSpecialRowHeader, {
                    rowHeaderStyles: __assign(__assign({}, styles.selectionListView.rowHeaderStyles), {
                      paddingLeft: 10
                    }),
                    rowHeaderContainerStyles: layout.mobile ? {
                      borderBottomColor: "#e9e9e9",
                      borderBottomWidth: open ? 1 : 0,
                      shadowOpacity: 0,
                      marginTop: 0
                    } : {
                      backgroundColor: "transparent",
                      borderBottomWidth: open ? 1 : 0,
                      borderBottomColor: "#e9e9e9",
                      boxShadow: "none",
                      borderRadius: 0,
                      marginTop: 0
                    },
                    onClickExpand: function () {
                      _this.expRef.current.collapseItem(title);
                      setTimeout(function () {
                        Platform.select({
                          android: function () {},
                          ios: function () {},
                          web: function () {
                            var bankRef1 = document.getElementById('txtNachaBankAccountNumber');
                            var bankRef2 = document.getElementById('txtNachaConfirmAccountNumber');
                            if (bankRef1) {
                              bankRef1.addEventListener("copy", function (evt) {
                                evt.preventDefault();
                              }, false);
                              bankRef1.addEventListener("paste", function (evt) {
                                evt.preventDefault();
                              }, false);
                              bankRef1.addEventListener("drag", function (evt) {
                                evt.preventDefault();
                              }, false);
                              bankRef1.addEventListener("drop", function (evt) {
                                evt.preventDefault();
                              }, false);
                            }
                            if (bankRef2) {
                              bankRef2.addEventListener("copy", function (evt) {
                                evt.preventDefault();
                              }, false);
                              bankRef2.addEventListener("paste", function (evt) {
                                evt.preventDefault();
                              }, false);
                              bankRef2.addEventListener("drag", function (evt) {
                                evt.preventDefault();
                              }, false);
                              bankRef2.addEventListener("drop", function (evt) {
                                evt.preventDefault();
                              }, false);
                            }
                          }
                        })();
                      }, 500);
                    },
                    item: /*#__PURE__*/React.createElement(View, {
                      id: title,
                      style: {
                        alignSelf: "center"
                      }
                    }, /*#__PURE__*/React.createElement(PnmacText, {
                      idTag1: "lblAddBankAccountTitle",
                      style: textStyle.formTitleSection
                    }, title)),
                    isExpand: ((_e = (_d = _this.expRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.state.collapsed.indexOf(title)) > -1,
                    disabled: ((_f = banks === null || banks === void 0 ? void 0 : banks.filter(function (s) {
                      return !s.newlyAdded;
                    })) === null || _f === void 0 ? void 0 : _f.length) >= 5 ? true : false,
                    iconColor: 'blue'
                  });
                }
              }))))));
            });
          }
        } else {
          return /*#__PURE__*/React.createElement(View, null);
        }
      },
      renderSectionHeader: function (_a) {
        var _b, _c;
        var title = _a.section.title;
        var last = title === "".concat(translations.getStarted);
        var open = ((_c = (_b = _this.pushHederRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1;
        return /*#__PURE__*/React.createElement(PnmacRowHeader, {
          rowHeaderStyles: __assign({}, styles.selectionListView.rowHeaderStyles),
          rowHeaderContainerStyles: layout.mobile ? {
            borderBottomColor: "#e9e9e9",
            borderBottomWidth: open ? 1 : 0,
            marginTop: 0,
            marginBottom: 0,
            paddingLeft: 5
          } : {
            backgroundColor: "transparent",
            borderBottomWidth: open ? 1 : 0,
            borderBottomColor: "#e9e9e9",
            borderRadius: 0,
            marginTop: 0,
            paddingLeft: 5
          },
          onClickExpand: function () {
            var _a, _b, _c;
            var c = (_a = _this.pushHederRef) === null || _a === void 0 ? void 0 : _a.current.collapseItem(title);
            if (((_c = (_b = _this.pushHederRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1) {
              _this.props.checkNachaAddOrManageBanksOpen(true);
            } else {
              _this.props.checkNachaAddOrManageBanksOpen(false);
            }
          },
          item: /*#__PURE__*/React.createElement(View, {
            id: title,
            style: {
              alignSelf: "center"
            },
            onPress: function () {
              var _a, _b;
              if (((_b = (_a = _this.pushHederRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.state.collapsed.indexOf(title)) > -1) {
                _this.props.checkNachaAddOrManageBanksOpen(true);
              } else {
                _this.props.checkNachaAddOrManageBanksOpen(false);
              }
            }
          }, /*#__PURE__*/React.createElement(PnmacText, {
            idTag1: "lblAddOrManageBankAccountTitle",
            style: textStyle.subTitleText
          }, title)),
          isExpand: open,
          iconColor: 'blue'
        });
      }
    });
  };
  return NachaAddBanks;
}(React.Component);
var AddBankMod = function (_a) {
  var _b, _c, _d;
  var layout = _a.layout,
    unmaskedAccountNumber = _a.unmaskedAccountNumber,
    edit = _a.edit,
    translations = _a.translations,
    payment = _a.payment,
    matches = _a.matches,
    bankAccountType = _a.bankAccountType,
    setState = _a.setState,
    addBank = _a.addBank,
    checkNachaAddOrManageBanksOpen = _a.checkNachaAddOrManageBanksOpen,
    rest = __rest(_a, ["layout", "unmaskedAccountNumber", "edit", "translations", "payment", "matches", "bankAccountType", "setState", "addBank", "checkNachaAddOrManageBanksOpen"]);
  var bankItemsNew = __spreadArray([], ((_b = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _b === void 0 ? void 0 : _b.bankAccounts) || [], true);
  if (edit && bankItemsNew.find(function (d) {
    return d.unmaskedAccountNumber == payment.bankAccount.unmaskedAccountNumber;
  }) === undefined && ((_c = payment === null || payment === void 0 ? void 0 : payment.bankAccount) === null || _c === void 0 ? void 0 : _c.bankAccountId)) {
    bankItemsNew.push(payment.bankAccount);
  }
  var bankItems = (bankItemsNew === null || bankItemsNew === void 0 ? void 0 : bankItemsNew.filter(function (s) {
    return parseInt(s.bankAccountType) == parseInt(bankAccountType) && !s.isRemoved;
  }).map(function (s) {
    return {
      key: s.bankAccountId,
      label: "".concat(s.accountName, " ").concat(s.accountNumber, " Routing# ").concat(s.routingTransitNumber),
      value: s.unmaskedAccountNumber
    };
  })) || [];
  return /*#__PURE__*/React.createElement(View, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: matches.small ? "column" : "row",
      margin: 15,
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      width: matches.small ? "100%" : "40%"
    }
  }, /*#__PURE__*/React.createElement(PnmacSelect, {
    accessibilityLabel: "Payment method",
    key: 'paymentSelect2',
    idTag1: 'dropDownPaymentMethod',
    idTag2: "paymentMethod",
    Icon: layout.mobile ? function () {
      return /*#__PURE__*/React.createElement(Image, {
        style: {
          width: 16,
          height: 16
        },
        source: require("../../assets/expand-icon.png")
      });
    } : function () {
      return null;
    },
    style: {
      viewContainer: __assign({}, layout.mobile ? {
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        borderRadius: 10,
        height: 50,
        borderColor: '#707070',
        borderWidth: 1
      } : null),
      inputIOS: {
        paddingLeft: 10
      }
    },
    onValueChange: function (value) {
      var _a, _b;
      var account = (_b = (_a = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _a === void 0 ? void 0 : _a.bankAccounts) === null || _b === void 0 ? void 0 : _b.find(function (s) {
        return s.unmaskedAccountNumber == value && s.isRemoved == false;
      });
      if (account) {
        setState({
          payment: __assign(__assign({}, payment), {
            bankAccount: account
          })
        });
      }
    },
    value: unmaskedAccountNumber || 'undefined',
    items: bankItems,
    useNativeAndroidPickerStyle: Platform.select({
      android: false,
      web: true,
      ios: true
    })
  }))), (payment === null || payment === void 0 ? void 0 : payment.bankAccount) == null || !((_d = payment === null || payment === void 0 ? void 0 : payment.bankAccount) === null || _d === void 0 ? void 0 : _d.accountNumber) ? /*#__PURE__*/React.createElement(PnmacText, {
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      color: 'red',
      marginHorizontal: 15,
      marginTop: 5
    }),
    idTag1: 'lblNachaBankAccountIsRequired'
  }, translations === null || translations === void 0 ? void 0 : translations.NachaBankAccountIsRequired) : null, /*#__PURE__*/React.createElement(NachaAddBanks, __assign({
    checkNachaAddOrManageBanksOpen: function (nachaflag) {
      checkNachaAddOrManageBanksOpen(nachaflag);
    },
    addBank: function (account) {
      addBank(account);
    }
  }, __assign({
    layout: layout,
    unmaskedAccountNumber: unmaskedAccountNumber,
    translations: translations,
    payment: payment,
    matches: matches,
    bankAccountType: bankAccountType,
    setState: setState
  }, rest))));
};
var MonthlyPayment = /** @class */function (_super) {
  __extends(MonthlyPayment, _super);
  function MonthlyPayment(props) {
    var _this = _super.call(this, props) || this;
    _this.intiialState = function (props) {
      return {
        isNachaOpen: false,
        paymentType: "monthly",
        account: "",
        addBankAccount: false,
        paymentSubmitted: false,
        open: false,
        modalType: 'pendingPayments',
        page: null,
        modalOpenEl: false,
        confirmation: false,
        modalData: {},
        openedTerms: false,
        saturday: false,
        isMounted: false,
        draftDate: false,
        edit: false,
        openDebit: false,
        deliquentPayment: false,
        displayedConfirmationId: "6101",
        errors: {},
        canMakePrincipleReduction: true,
        canMakeAdditionalAmounts: true,
        originalNextPaymentDueDate: null,
        nextPaymentDueDate: null,
        pendingPaymentDate: null,
        otpBanking: false,
        achExist: false,
        tabProgression: ["pay"],
        openCancelAch: false,
        pathname: "",
        currentServerDateTime: "0001-01-01T00:00:00",
        payment: {
          "delinquentPayments": [],
          "mobile": props.layout.mobile || false,
          "loanId": 0,
          "errors": {},
          "isCancelable": false,
          "errorToDisplayToUser": null,
          "suspenseCode": null,
          "bankAccount": {
            "bankAccountType": 201287
          },
          "suspenseAmount": "0.00",
          "paymentId": 0,
          "monthlyPaymentAmount": "0.00",
          "doubleMonthlyPaymentAmount": 0,
          "numberOfPayments": 1,
          "originalEffectiveDate": null,
          "isEditable": false,
          "feesDues": [{
            "feeAmtField": "0.00",
            "feeCodeField": "1",
            "sequenceNumberField": "0.00",
            "fieldName": "lateFeesDue"
          }, {
            "feeAmtField": "0.00",
            "feeCodeField": "2",
            "sequenceNumberField": 0,
            "fieldName": "nsfFeesDue"
          }, {
            "feeAmtField": "0.00",
            "feeCodeField": "G",
            "sequenceNumberField": 0,
            "fieldName": "debitCardConvenienceFee"
          }, {
            "feeAmtField": "0.00",
            "feeCodeField": "1",
            "sequenceNumberField": 0,
            "fieldName": "otherFeesDue"
          }],
          "totalFeesAmount": "0.00",
          "additionalEscrowAmount": "0.00",
          "requestedByUserName": null,
          "paymentType": null,
          "source": 0,
          "paymentUrl": null,
          "forbearanceAmount": "0.00",
          "userAgent": null,
          "delinquentPaymentAmount": "0.00",
          "delinquentPaymentDueDate": null,
          "nextDelinquentPaymentDate": "0001-01-01T00:00:00",
          "currentPrincipalBalance": 0.0,
          "logId": null,
          "otdRequestQueue": null,
          "isFromCashQueue": false,
          "loanSummary": {},
          "draftSource": 0,
          "isPostedToLoanservices": false,
          "dueDate": null,
          "mspDueDate": null,
          "effectiveDate": moment(props.layout.localTime),
          "achRegisterationConfirmationId": 0,
          "totalDraftAmount": "0.00",
          "additionalPrincipalAmount": "0.00",
          "status": 0,
          "bankRoutingTransitNumber": null,
          "bankAccountNumber": null,
          "bankAccountType": 201287,
          "bankAccountName": null,
          "hasPaymentChange": false,
          "created": moment(props.layout.localTime),
          "createdBy": null,
          "modified": moment(props.layout.localTime),
          "modifiedBy": null,
          "achConfigurationKey": null,
          "paymentMethod": 0,
          "fiservConfirmationNumber": null
        }
      };
    };
    _this.submitPayment = function () {
      var _a, _b, _c, _d, _e, _f;
      var _g = _this.props,
        layout = _g.layout,
        holdViewOpen = _g.holdViewOpen,
        isOtp = _g.isOtp;
      var bankAccountType = _this.state.payment.bankAccount.bankAccountType;
      var edit = _this.state.edit;
      if (parseInt(layout.selectedLoanNumber) > 0) {
        _this.setState({
          paymentSubmitted: true
        });
        var payment_1 = _this.state.payment;
        payment_1.loan = layout.currentLoan;
        payment_1.loanId = layout.selectedLoanNumber;
        payment_1.totalDraftAmount = _this.totalDraftAmountFun(true);
        payment_1.doubleMonthlyPaymentAmount = _this.replaceDollarSign(payment_1.doubleMonthlyPaymentAmount);
        if ((_a = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _a === void 0 ? void 0 : _a.mustMakeDelinquentPayment) {
          if (layout.paymentModel.numberofPendingPayments > (edit ? ((_c = (_b = layout.paymentModel) === null || _b === void 0 ? void 0 : _b.payment) === null || _c === void 0 ? void 0 : _c.totalDraftAmount) >= parseFloat(payment_1 === null || payment_1 === void 0 ? void 0 : payment_1.delinquentPaymentAmount) + _this.totalFees() ? 0 : 1 : 0)) {
            payment_1.monthlyPaymentAmount = payment_1.delinquentMonthlyPaymentAmount;
            payment_1.dueDate = payment_1.nextDelinquentPaymentDate;
          } else {
            payment_1.monthlyPaymentAmount = payment_1.delinquentPaymentAmount;
            payment_1.dueDate = payment_1.delinquentPaymentDueDate;
          }
        }
        Object.keys(payment_1).map(function (s) {
          if ("suspenseAmount,monthlyPaymentAmount,totalFeesAmount,additionalEscrowAmount,delinquentPaymentAmount,additionalPrincipalAmount".indexOf(s) > -1) {
            payment_1[s] = isNaN(_this.replaceDollarSign(payment_1[s])) ? 0.00 : _this.replaceDollarSign(payment_1[s]);
          }
        });
        if (payment_1.paymentType == 201297 && ((_d = payment_1 === null || payment_1 === void 0 ? void 0 : payment_1.feesDues) === null || _d === void 0 ? void 0 : _d.find(function (s) {
          return s.fieldName == "debitCardConvenienceFee";
        }))) {
          var indexdebit = payment_1.feesDues.findIndex(function (s) {
            return s.fieldName == "debitCardConvenienceFee";
          });
          payment_1.feesDues.splice(indexdebit, 1);
        }
        if (parseInt(bankAccountType) != 201288 && ((_e = payment_1 === null || payment_1 === void 0 ? void 0 : payment_1.feesDues) === null || _e === void 0 ? void 0 : _e.find(function (s) {
          return s.fieldName == "debitCardConvenienceFee";
        }))) {
          var index = payment_1.feesDues.findIndex(function (s) {
            return s.fieldName == "debitCardConvenienceFee";
          });
          payment_1.feesDues.splice(index, 1);
        }
        if (((_f = payment_1 === null || payment_1 === void 0 ? void 0 : payment_1.feesDues) === null || _f === void 0 ? void 0 : _f.length) > 0) {
          payment_1.feesDues = payment_1 === null || payment_1 === void 0 ? void 0 : payment_1.feesDues.filter(function (s) {
            return parseFloat(s.feeAmtField) > 0;
          });
          payment_1.feesDues.forEach(function (d) {
            return delete d._feeAmtField;
          });
        }
        if (!isOtp) {
          payment_1.draftSource = 4;
        }
        payment_1.effectiveDate = moment(payment_1.effectiveDate, "MM/DD/YYYY").isValid() ? moment(payment_1.effectiveDate, "MM/DD/YYYY").format("MM/DD/YYYY") : moment(payment_1.effectiveDate).format("MM/DD/YYYY");
        payment_1.mobile = layout.mobile;
        fetch("".concat(layout.pennyHomeUrl, "api/payment/").concat(!isOtp ? edit ? "update_ach" : "post_ach" : edit ? "update_payment" : "post_payment"), {
          method: 'POST',
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer ".concat(_this.props.layout.token),
            "TrackerSessionId": "".concat(_this.props.layout.trackerSession)
          },
          body: JSON.stringify(__assign(__assign({}, payment_1), {
            bankAccount: __assign(__assign({}, payment_1.bankAccount), {
              unmaskedAccountNumber: undefined,
              unmaskedAccountNumberEncode: encryptBankAccountNumber(payment_1.bankAccount.unmaskedAccountNumber),
              confirmAccountNumber: undefined,
              confirmAccountNumberEncode: encryptBankAccountNumber(payment_1.bankAccount.confirmAccountNumber)
            })
          }))
        }).then(function (res) {
          return res.json();
        }).then(function (data) {
          var _a, _b, _c, _d, _e;
          if (data && (((_a = Object.keys(data === null || data === void 0 ? void 0 : data.errors)) === null || _a === void 0 ? void 0 : _a.length) == 0 || !(data === null || data === void 0 ? void 0 : data.errors))) {
            payment_1.status = 0;
            payment_1.canCancel = false;
            payment_1.canEdit = false;
            if (parseInt((_b = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _b === void 0 ? void 0 : _b.lienPriorityType) == 2) {
              if ((_c = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _c === void 0 ? void 0 : _c.pendingPayments) {
                layout.paymentModel.pendingPayments.push(payment_1);
              } else {
                layout.paymentModel.pendingPayments = [payment_1];
              }
              _this.props.dispatch({
                type: CLOSED_END_SECONDS,
                payment: layout.paymentModel
              });
            }
            _this.setState({
              displayedConfirmationId: data.displayedConfirmationId || "6101",
              open: true,
              paymentSubmitted: false,
              modalType: !isOtp ? "achPaymentSubmitted" : "paymentSubmitted",
              page: isOtp ? "pay" : "confirm"
            }, function () {
              if (holdViewOpen) {
                holdViewOpen();
              }
            });
          } else {
            var errorType = data === null || data === void 0 ? void 0 : data.errors;
            if ((_d = data === null || data === void 0 ? void 0 : data.errors) === null || _d === void 0 ? void 0 : _d.time) {
              if (((_e = data === null || data === void 0 ? void 0 : data.errors) === null || _e === void 0 ? void 0 : _e.time) === 'AfterWorkingHoursPaymentErrorMessage') {
                errorType = {
                  time: _this.props.translations.AfterWorkingHoursPaymentErrorMessage
                };
              }
              _this.setState(_this.intiialState(_this.props));
              _this.props.dispatch({
                type: PAYMENT_VALIDATION,
                payment: {}
              });
              _this.props.authenticate();
            }
            _this.setState({
              paymentSubmitted: false,
              errors: errorType
            });
          }
        });
      } else {
        _this.props.authenticate();
      }
    };
    _this.isLoanInForbearance = function () {
      var _a, _b, _c, _d, _e;
      var modifications = _this.props.layout.modifications;
      var defaultPayments = (((_b = (_a = _this.props.layout) === null || _a === void 0 ? void 0 : _a.paymentModel) === null || _b === void 0 ? void 0 : _b.loan) || {}).defaultPayments;
      var StatusTypeId = modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId;
      var IsForebearanceOTPVisible = modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible;
      var forbearacne = StatusTypeId > 0 && IsForebearanceOTPVisible || ((_e = (_d = (_c = _this.props.layout) === null || _c === void 0 ? void 0 : _c.paymentModel) === null || _d === void 0 ? void 0 : _d.loan) === null || _e === void 0 ? void 0 : _e.isLoanInForbearance) || (defaultPayments === null || defaultPayments === void 0 ? void 0 : defaultPayments.route) == "Default" && ((defaultPayments === null || defaultPayments === void 0 ? void 0 : defaultPayments.ruleId) == RuleId.Increased_Payment_Plan || (defaultPayments === null || defaultPayments === void 0 ? void 0 : defaultPayments.ruleId) == RuleId.Reduced_Payment_Plan);
      return forbearacne;
    };
    _this.changeAccount = function (value) {
      var _a, _b, _c;
      var account = (_c = (_b = (_a = _this.props.layout.paymentModel) === null || _a === void 0 ? void 0 : _a.bankAccounts) === null || _b === void 0 ? void 0 : _b.filter(function (s) {
        return parseInt(s.bankAccountType) == parseInt(value);
      })) !== null && _c !== void 0 ? _c : [];
      var selectedbankaccount = account.length > 0 ? account[0] : null;
      var payment = _this.state.payment;
      if (parseInt(value) == 201288) {
        payment.effectiveDate = moment(payment.originalEffectiveDate).format("MM/DD/YYYY");
      }
      if (account.length > 0) {
        payment.bankAccount = selectedbankaccount;
        payment.bankAccountType = value;
        _this.setState({
          payment: payment
        });
      } else {
        payment.bankAccount = {
          "bankAccountType": value
        };
        _this.setState({
          payment: payment,
          bankAccountType: value
        });
      }
    };
    _this.replaceDollarSign = function (value) {
      var _a;
      return (_a = value === null || value === void 0 ? void 0 : value.toString()) === null || _a === void 0 ? void 0 : _a.replace("$", "").replace(",", "");
    };
    _this.minimumPaymentDue = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
      var minimuPaymentDue = (_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.monthlyPaymentAmount;
      if (((_e = (_d = (_c = (_b = _this.props.layout) === null || _b === void 0 ? void 0 : _b.paymentModel) === null || _c === void 0 ? void 0 : _c.loan) === null || _d === void 0 ? void 0 : _d.defaultPayments) === null || _e === void 0 ? void 0 : _e.route) == "Default" && (((_j = (_h = (_g = (_f = _this.props.layout) === null || _f === void 0 ? void 0 : _f.paymentModel) === null || _g === void 0 ? void 0 : _g.loan) === null || _h === void 0 ? void 0 : _h.defaultPayments) === null || _j === void 0 ? void 0 : _j.ruleId) == RuleId.Increased_Payment_Plan || ((_o = (_m = (_l = (_k = _this.props.layout) === null || _k === void 0 ? void 0 : _k.paymentModel) === null || _l === void 0 ? void 0 : _l.loan) === null || _m === void 0 ? void 0 : _m.defaultPayments) === null || _o === void 0 ? void 0 : _o.ruleId) == RuleId.Reduced_Payment_Plan)) {
        (_t = (_s = (_r = (_q = (_p = _this.props.layout) === null || _p === void 0 ? void 0 : _p.paymentModel) === null || _q === void 0 ? void 0 : _q.loan) === null || _r === void 0 ? void 0 : _r.defaultPayments) === null || _s === void 0 ? void 0 : _s.defaultPaymentsDue) === null || _t === void 0 ? void 0 : _t.forEach(function (defpayment) {
          var _a;
          if (((_a = defpayment.paymentType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == "r" && (defpayment.defaultPaymentType == defaulPaymentType.PIT || defpayment.defaultPaymentType == defaulPaymentTypeStr.PIT)) {
            minimuPaymentDue = defpayment.paymentAmountDue;
          }
        });
      }
      return minimuPaymentDue;
    };
    _this.checkPaymentOver = function () {
      var _a, _b;
      var _c = (_a = _this.props.layout) === null || _a === void 0 ? void 0 : _a.currentLoan,
        unpaidPrincipalBalanceAmount = _c.unpaidPrincipalBalanceAmount,
        currentTotalMonthlyPaymentAmount = _c.currentTotalMonthlyPaymentAmount;
      var totalNew = parseFloat(unpaidPrincipalBalanceAmount || 0) - (parseFloat(currentTotalMonthlyPaymentAmount) + (((_b = _this.props.layout.paymentModel) === null || _b === void 0 ? void 0 : _b.pendingPayments) || []).reduce(function (a, b) {
        return a + b.totalDraftAmount;
      }, 0));
      var currentbal = _this.totalDraftAmountFun(true);
      if (currentbal >= totalNew || currentbal >= 99999.99) {
        return true;
      }
      return false;
    };
    _this.disableSubmitButton = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
      var layout = _this.props.layout;
      var accountNumber = (((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.bankAccount) || {}).accountNumber;
      var _o = _this.state,
        edit = _o.edit,
        originalNextPaymentDueDate = _o.originalNextPaymentDueDate;
      var status = (_b = layout.selectedLoanAvailability) === null || _b === void 0 ? void 0 : _b.status;
      var modifications = layout.modifications;
      var isTrialPaymentVisible = (modifications === null || modifications === void 0 ? void 0 : modifications.isTrialPaymentVisible) || (modifications === null || modifications === void 0 ? void 0 : modifications.enablePaymentCoupon);
      var currentTime = moment(layout.localTime);
      var dueDate = moment(layout.currentLoan.nextPaymentDueDate);
      var isDefaultOrDelinquent = ((_e = (_d = (_c = layout.paymentModel) === null || _c === void 0 ? void 0 : _c.loan) === null || _d === void 0 ? void 0 : _d.defaultPayments) === null || _e === void 0 ? void 0 : _e.route) == "Default" || ((_h = (_g = (_f = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _f === void 0 ? void 0 : _f.loan) === null || _g === void 0 ? void 0 : _g.defaultPayments) === null || _h === void 0 ? void 0 : _h.route) == "Delinquent";
      var isLegacy = ((_k = (_j = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _j === void 0 ? void 0 : _j.loan) === null || _k === void 0 ? void 0 : _k.defaultPayments) == null ? true : !isDefaultOrDelinquent;
      var paymentWindow = !edit && (ammountPaymentAhead(status, 2) || (isLegacy ? (_l = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _l === void 0 ? void 0 : _l.pendingPaymentWillMakeLoanCurrentByAmount : false) || (getActiveFeatures(layout.features, "BRMS_Delinquent", layout.whitelisted) ? false : ((_m = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _m === void 0 ? void 0 : _m.numberofPendingPayments) >= 2) || moment(originalNextPaymentDueDate).isAfter(moment(layout.localTime)) && moment([dueDate.year(), dueDate.month(), dueDate.date()]).diff(moment([currentTime.year(), currentTime.month(), dueDate.date()]), 'months', true) > 2);
      return _this.checkPaymentOver() || accountNumber == null || paymentWindow && isTrialPaymentVisible || _this.totalDraftAmountFun() <= 0;
    };
    _this.getStateValue = function (filed) {
      var _a, _b;
      var feesDues = _this.state.payment.feesDues;
      return (_b = (_a = feesDues === null || feesDues === void 0 ? void 0 : feesDues.find(function (s) {
        return s.fieldName == filed;
      })) === null || _a === void 0 ? void 0 : _a.feeAmtField) === null || _b === void 0 ? void 0 : _b.toString();
    };
    _this.getStateValueOriginal = function (filed) {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      var feesDues = _this.state.payment.feesDues;
      if (((_b = (_a = _this.props.location) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.edit) || ((_d = (_c = _this.props.route) === null || _c === void 0 ? void 0 : _c.params) === null || _d === void 0 ? void 0 : _d.edit)) {
        return (_f = (_e = feesDues === null || feesDues === void 0 ? void 0 : feesDues.find(function (s) {
          return s.fieldName == filed;
        })) === null || _e === void 0 ? void 0 : _e.editOrignalFeeAmt) === null || _f === void 0 ? void 0 : _f.toString();
      }
      return (_h = (_g = feesDues === null || feesDues === void 0 ? void 0 : feesDues.find(function (s) {
        return s.fieldName == filed;
      })) === null || _g === void 0 ? void 0 : _g.orignalFeeAmt) === null || _h === void 0 ? void 0 : _h.toString();
    };
    _this.enrolledInPaperLess = function () {
      var selectedLoanPreference = _this.props.layout.selectedLoanPreference;
      var stat = {
        yearEnd: false,
        monthEnd: false
      };
      for (var i = 0; i < selectedLoanPreference.length; i++) {
        if (selectedLoanPreference[i].preferenceTypeCode == 300009 && selectedLoanPreference[i].preferenceCode == 300027) {
          stat.monthEnd = true;
        }
        if (selectedLoanPreference[i].preferenceTypeCode == 300010 && selectedLoanPreference[i].preferenceCode == 300027) {
          stat.yearEnd = true;
        }
      }
      return stat.yearEnd && stat.monthEnd;
    };
    _this.totalFees = function () {
      var _a, _b, _c, _d, _e, _f, _g;
      if (((_b = (_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.feesDues) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        var bankAccountType_1 = (_e = (_d = (_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.bankAccount) === null || _d === void 0 ? void 0 : _d.bankAccountType) !== null && _e !== void 0 ? _e : 0;
        return ((_g = (_f = _this.state.payment) === null || _f === void 0 ? void 0 : _f.feesDues.filter(function (s) {
          return s.fieldName.indexOf("Income") == -1 && s.fieldName.indexOf("Corportate") == -1;
        })) === null || _g === void 0 ? void 0 : _g.reduce(function (accumulator, currentValue) {
          var _a, _b, _c;
          if (((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.paymentType) != 201298 && ((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.paymentType) != 201299 && ((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.paymentType) != 201311 && parseInt(bankAccountType_1) != 201288) {
            return accumulator;
          }
          if (currentValue.fieldName == "debitCardConvenienceFee" && parseInt(bankAccountType_1) != 201288) {
            return accumulator;
          }
          return accumulator + parseFloat(_this.replaceDollarSign(currentValue.feeAmtField));
        }, 0)) || 0;
      } else {
        return 0;
      }
    };
    _this.totalDraftAmountFun = function (submit) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
      var deliquentPayment = _this.state.deliquentPayment;
      if (((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.paymentType) == 1000145 || ((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.paymentType) == 1000146) {
        return parseFloat(_this.replaceDollarSign((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.forbearanceAmount)) || 0;
      }
      var totalDraftAmount = (parseFloat(_this.totalFees()) || 0) + (parseFloat(_this.replaceDollarSign((_d = _this.state.payment) === null || _d === void 0 ? void 0 : _d.additionalEscrowAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_e = _this.state.payment) === null || _e === void 0 ? void 0 : _e.additionalPrincipalAmount)) || 0) + (((_f = _this.props.layout.paymentModel) === null || _f === void 0 ? void 0 : _f.mustMakeDelinquentPayment) && _this.props.layout.paymentModel.numberofPendingPayments == 0 ? parseFloat(_this.replaceDollarSign((_g = _this.state.payment) === null || _g === void 0 ? void 0 : _g.delinquentPaymentAmount)) || 0 : parseFloat(_this.replaceDollarSign((_h = _this.state.payment) === null || _h === void 0 ? void 0 : _h.monthlyPaymentAmount)) || 0);
      if (deliquentPayment) {
        totalDraftAmount = (parseFloat(_this.totalFees()) || 0) + (parseFloat(_this.replaceDollarSign((_j = _this.state.payment) === null || _j === void 0 ? void 0 : _j.additionalEscrowAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_k = _this.state.payment) === null || _k === void 0 ? void 0 : _k.additionalPrincipalAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_l = _this.state.payment) === null || _l === void 0 ? void 0 : _l.monthlyPaymentAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_m = _this.state.payment) === null || _m === void 0 ? void 0 : _m.delinquentPaymentAmount)) || 0);
      }
      if (((_o = _this.state.payment) === null || _o === void 0 ? void 0 : _o.paymentType) == 201311) {
        totalDraftAmount = (parseFloat(_this.totalFees()) || 0) + (parseFloat(_this.replaceDollarSign((_p = _this.state.payment) === null || _p === void 0 ? void 0 : _p.additionalEscrowAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_q = _this.state.payment) === null || _q === void 0 ? void 0 : _q.additionalPrincipalAmount)) || 0) + (parseFloat((_s = (_r = _this.state.payment) === null || _r === void 0 ? void 0 : _r.delinquentPayments) === null || _s === void 0 ? void 0 : _s.filter(function (s) {
          return s.selected && !s.paid;
        }).reduce(function (a, o) {
          return a += parseFloat(o.paymentAmount);
        }, 0)) || 0);
      }
      // add principle
      if (((_t = _this.state.payment) === null || _t === void 0 ? void 0 : _t.paymentType) == 201297) {
        totalDraftAmount = parseFloat(_this.replaceDollarSign((_u = _this.state.payment) === null || _u === void 0 ? void 0 : _u.additionalPrincipalAmount)) || 0;
      }
      // add escrow
      if (((_v = _this.state.payment) === null || _v === void 0 ? void 0 : _v.paymentType) == 201299) {
        totalDraftAmount = (parseFloat(_this.totalFees()) || 0) + (parseFloat(_this.replaceDollarSign((_w = _this.state.payment) === null || _w === void 0 ? void 0 : _w.additionalEscrowAmount)) || 0);
      }
      // ach
      if (((_x = _this.state.payment) === null || _x === void 0 ? void 0 : _x.paymentType) == 201309) {
        totalDraftAmount = (parseFloat(_this.replaceDollarSign((_y = _this.state.payment) === null || _y === void 0 ? void 0 : _y.additionalPrincipalAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_z = _this.state.payment) === null || _z === void 0 ? void 0 : _z.monthlyPaymentAmount)) || 0);
      }
      //Trial Payment
      if (((_0 = _this.state.payment) === null || _0 === void 0 ? void 0 : _0.paymentType) == 201296) {
        totalDraftAmount = parseFloat(_this.replaceDollarSign((_1 = _this.state.payment) === null || _1 === void 0 ? void 0 : _1.monthlyPaymentAmount)) || 0;
      }
      return totalDraftAmount;
    };
    _this.separateCommas = function (val) {
      var num = val === null || val === void 0 ? void 0 : val.replace(/,/gi, "");
      var num2 = num === null || num === void 0 ? void 0 : num.replace(/\d(?=(?:\d{3})+$)/g, '$&,');
      return num2;
    };
    _this.delinquentValue = function () {
      var _a, _b, _c, _d;
      if (((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.paymentType) == 201311) {
        return (parseFloat((_c = (_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.delinquentPayments) === null || _c === void 0 ? void 0 : _c.filter(function (s) {
          return s.selected && !s.paid;
        }).reduce(function (a, o) {
          return a += parseFloat(o.paymentAmount);
        }, 0)) || 0).toFixed(2);
      }
      return parseFloat(parseFloat(_this.replaceDollarSign(_this.state.payment.delinquentPaymentAmount)) + parseFloat(_this.replaceDollarSign((_d = _this.state.payment) === null || _d === void 0 ? void 0 : _d.delinquentMonthlyPaymentAmount))).toFixed(2);
    };
    _this.getState = function () {
      return _this.state;
    };
    _this.monthlyPayment = function () {
      var _a, _b, _c;
      if (((_c = (_b = (_a = _this.props.layout.paymentModel) === null || _a === void 0 ? void 0 : _a.payment) === null || _b === void 0 ? void 0 : _b.delinquentPayments) === null || _c === void 0 ? void 0 : _c.length) > 0) {
        return 201311;
      }
      return 201298;
    };
    _this.state = _this.intiialState(props);
    if (props.navigation && props.layout.mobile) {
      var that_1 = _this;
      var unsubscribe = props.navigation.addListener('focus', function () {
        that_1.setState({
          isMounted: false,
          payment: __assign(__assign({}, _this.state.payment), {
            monthlyPaymentAmount: "0.00"
          })
        });
      });
    }
    _this.unsubscribeBlur;
    _this.unsubscribeFocus;
    return _this;
  }
  MonthlyPayment.prototype.componentDidMount = function () {
    var _this = this;
    var _a;
    if (Platform.OS !== 'web') {
      this.unsubscribeFocus = (_a = this.props.navigation) === null || _a === void 0 ? void 0 : _a.addListener('focus', function () {
        _this.props.refreshBankData(_this.props.layout.selectedLoanNumber);
      });
      this.unsubscribeBlur = this.props.navigation.addListener('blur', function () {
        _this.setState({
          open: false
        });
      });
    } else {
      this.props.refreshBankData(this.props.layout.selectedLoanNumber);
    }
  };
  MonthlyPayment.prototype.componentWillUnmount = function () {
    var _a, _b;
    (_a = this.unsubscribeBlur) === null || _a === void 0 ? void 0 : _a.call(this);
    (_b = this.unsubscribeFocus) === null || _b === void 0 ? void 0 : _b.call(this);
  };
  MonthlyPayment.getDerivedStateFromProps = function (props, state) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87;
    var route = props.route;
    var path = props.layout.mobile ? route.pathname : window.location.pathname;
    var achExist = (_c = (_b = (_a = props.layout) === null || _a === void 0 ? void 0 : _a.paymentModel) === null || _b === void 0 ? void 0 : _b.pendingPayments) === null || _c === void 0 ? void 0 : _c.find(function (s) {
      return s.paymentType == 201309;
    });
    if (((_d = state.payment) === null || _d === void 0 ? void 0 : _d.monthlyPaymentAmount) == "0.00" && props.layout.currentLoan != null && props.layout.paymentModel != null && (!state.isMounted || !state.isMountedBank) || path != state.pathname) {
      var modifications = props.layout.modifications;
      var StatusTypeId = modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId;
      var IsForebearanceOTPVisible = modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible;
      var isTrialPaymentVisible_1 = (modifications === null || modifications === void 0 ? void 0 : modifications.isTrialPaymentVisible) || (modifications === null || modifications === void 0 ? void 0 : modifications.enablePaymentCoupon);
      var forbearacne_1 = StatusTypeId > 0 && IsForebearanceOTPVisible || ((_e = props.layout.currentLoan) === null || _e === void 0 ? void 0 : _e.isLoanInForbearance) || ((_j = (_h = (_g = (_f = props.layout) === null || _f === void 0 ? void 0 : _f.paymentModel) === null || _g === void 0 ? void 0 : _g.loan) === null || _h === void 0 ? void 0 : _h.defaultPayments) === null || _j === void 0 ? void 0 : _j.route) == "Default" && (((_o = (_m = (_l = (_k = props.layout) === null || _k === void 0 ? void 0 : _k.paymentModel) === null || _l === void 0 ? void 0 : _l.loan) === null || _m === void 0 ? void 0 : _m.defaultPayments) === null || _o === void 0 ? void 0 : _o.ruleId) == RuleId.Increased_Payment_Plan || ((_s = (_r = (_q = (_p = props.layout) === null || _p === void 0 ? void 0 : _p.paymentModel) === null || _q === void 0 ? void 0 : _q.loan) === null || _r === void 0 ? void 0 : _r.defaultPayments) === null || _s === void 0 ? void 0 : _s.ruleId) == RuleId.Reduced_Payment_Plan);
      var edit = (_u = (_t = props.location) === null || _t === void 0 ? void 0 : _t.state) === null || _u === void 0 ? void 0 : _u.edit;
      if ((_v = props.route) === null || _v === void 0 ? void 0 : _v.params) {
        edit = (_x = (_w = props.route) === null || _w === void 0 ? void 0 : _w.params) === null || _x === void 0 ? void 0 : _x.edit;
      }
      // SVT-36313 - preventing PopUp while changing the langauge (&& state.isMountedBank !== undefined)
      // based on the device type.
      var show = props.layout.mobile ? props.isOtp && !edit && (((_z = (_y = props.layout.paymentModel) === null || _y === void 0 ? void 0 : _y.pendingPayments) === null || _z === void 0 ? void 0 : _z.filter(function (s) {
        return s.paymentType == 201298 || s.paymentType == 201309;
      }).length) > 0 && moment((_0 = props.layout.currentLoan) === null || _0 === void 0 ? void 0 : _0.nextPaymentDueDate).month() >= moment(props.layout.localTime).month() || moment((_1 = props.layout.currentLoan) === null || _1 === void 0 ? void 0 : _1.nextPaymentDueDate) > moment(props.layout.localTime)) && !isTrialPaymentVisible_1 && !forbearacne_1 && !((_3 = (_2 = props.layout) === null || _2 === void 0 ? void 0 : _2.paymentModel) === null || _3 === void 0 ? void 0 : _3.mustMakeDelinquentPayment) && !state.isMounted && state.isMountedBank !== undefined : props.isOtp && !edit && (((_5 = (_4 = props.layout.paymentModel) === null || _4 === void 0 ? void 0 : _4.pendingPayments) === null || _5 === void 0 ? void 0 : _5.filter(function (s) {
        return s.paymentType == 201298 || s.paymentType == 201309;
      }).length) > 0 && moment((_6 = props.layout.currentLoan) === null || _6 === void 0 ? void 0 : _6.nextPaymentDueDate).month() >= moment(props.layout.localTime).month() || moment((_7 = props.layout.currentLoan) === null || _7 === void 0 ? void 0 : _7.nextPaymentDueDate) > moment(props.layout.localTime)) && !isTrialPaymentVisible_1 && !forbearacne_1 && !((_9 = (_8 = props.layout) === null || _8 === void 0 ? void 0 : _8.paymentModel) === null || _9 === void 0 ? void 0 : _9.mustMakeDelinquentPayment) && !state.isMounted;
      var status_1 = (_10 = props.layout.selectedLoanAvailability) === null || _10 === void 0 ? void 0 : _10.status;
      var currentTime = moment(props.layout.localTime);
      var dueDate = moment(props.layout.currentLoan.nextPaymentDueDate);
      var isDefaultOrDelinquent = ((_13 = (_12 = (_11 = props.layout.paymentModel) === null || _11 === void 0 ? void 0 : _11.loan) === null || _12 === void 0 ? void 0 : _12.defaultPayments) === null || _13 === void 0 ? void 0 : _13.route) == "Default" || ((_17 = (_16 = (_15 = (_14 = props.layout) === null || _14 === void 0 ? void 0 : _14.paymentModel) === null || _15 === void 0 ? void 0 : _15.loan) === null || _16 === void 0 ? void 0 : _16.defaultPayments) === null || _17 === void 0 ? void 0 : _17.route) == "Delinquent";
      var isLegacy = ((_20 = (_19 = (_18 = props.layout) === null || _18 === void 0 ? void 0 : _18.paymentModel) === null || _19 === void 0 ? void 0 : _19.loan) === null || _20 === void 0 ? void 0 : _20.defaultPayments) == null ? true : !isDefaultOrDelinquent;
      var paymentWindow_1 = !edit && (ammountPaymentAhead(status_1, 2) || (isLegacy ? (_22 = (_21 = props.layout) === null || _21 === void 0 ? void 0 : _21.paymentModel) === null || _22 === void 0 ? void 0 : _22.pendingPaymentWillMakeLoanCurrentByAmount : false) || (getActiveFeatures(props.layout.features, "BRMS_Delinquent", props.layout.whitelisted) ? false : ((_24 = (_23 = props.layout) === null || _23 === void 0 ? void 0 : _23.paymentModel) === null || _24 === void 0 ? void 0 : _24.numberofPendingPayments) >= 2) || moment((_25 = props.layout.currentLoan) === null || _25 === void 0 ? void 0 : _25.originalNextPaymentDueDate).isAfter(moment(props.layout.localTime)) && moment([dueDate.year(), dueDate.month(), dueDate.date()]).diff(moment([currentTime.year(), currentTime.month(), dueDate.date()]), 'months', true) > 2);
      Object.keys(((_27 = (_26 = props.layout) === null || _26 === void 0 ? void 0 : _26.paymentModel) === null || _27 === void 0 ? void 0 : _27.payment) || {}).map(function (s) {
        if ("suspenseAmount,monthlyPaymentAmount,totalFeesAmount,additionalEscrowAmount,delinquentPaymentAmount,additionalPrincipalAmount".indexOf(s) > -1) {
          props.layout.paymentModel.payment[s] = isNaN(props.layout.paymentModel.payment[s]) ? 0.00 : parseFloat(props.layout.paymentModel.payment[s]).toFixed(2);
        }
      });
      if (((_28 = props.layout.paymentModel) === null || _28 === void 0 ? void 0 : _28.payment) && ((_30 = (_29 = props.layout.paymentModel) === null || _29 === void 0 ? void 0 : _29.payment) === null || _30 === void 0 ? void 0 : _30.feesDues.length) > 0) {
        props.layout.paymentModel.payment.feesDues.forEach(function (s) {
          s.feeAmtField = isNaN(s.feeAmtField) ? 0.00 : parseFloat(s.feeAmtField).toFixed(2);
        });
      }
      if (!edit && ((_34 = (_33 = (_32 = (_31 = props.layout) === null || _31 === void 0 ? void 0 : _31.paymentModel) === null || _32 === void 0 ? void 0 : _32.payment) === null || _33 === void 0 ? void 0 : _33.feesDues) === null || _34 === void 0 ? void 0 : _34.length) > 0) {
        var oFee = props.layout.paymentModel.payment.feesDues.find(function (w) {
          return w.fieldName == "otherFeesDue";
        });
        var oFeeIndex = props.layout.paymentModel.payment.feesDues.findIndex(function (w) {
          return w.fieldName == "otherFeesDue";
        });
        if (oFee) {
          oFee.feeAmtField = "0.00";
          props.layout.paymentModel.payment.feesDues.splice(oFeeIndex, 1, oFee);
        }
      }
      var replaceDollarSign_1 = function (value) {
        var _a;
        return (_a = value === null || value === void 0 ? void 0 : value.toString()) === null || _a === void 0 ? void 0 : _a.replace("$", "").replace(",", "");
      };
      var totalFees_1 = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_b = (_a = state.payment) === null || _a === void 0 ? void 0 : _a.feesDues) === null || _b === void 0 ? void 0 : _b.length) > 0) {
          var bankAccountType_2 = (_e = (_d = (_c = state.payment) === null || _c === void 0 ? void 0 : _c.bankAccount) === null || _d === void 0 ? void 0 : _d.bankAccountType) !== null && _e !== void 0 ? _e : 0;
          return (_h = (_g = (_f = state.payment) === null || _f === void 0 ? void 0 : _f.feesDues) === null || _g === void 0 ? void 0 : _g.reduce(function (accumulator, currentValue) {
            var _a, _b, _c;
            if (((_a = state.payment) === null || _a === void 0 ? void 0 : _a.paymentType) != 201298 && ((_b = state.payment) === null || _b === void 0 ? void 0 : _b.paymentType) != 201299 && ((_c = state.payment) === null || _c === void 0 ? void 0 : _c.paymentType) != 201311 && parseInt(bankAccountType_2) != 201288) {
              return accumulator;
            }
            if (currentValue.fieldName == "debitCardConvenienceFee" && parseInt(bankAccountType_2) != 201288) {
              return accumulator;
            }
            return accumulator + parseFloat(replaceDollarSign_1(currentValue.feeAmtField));
          }, 0)) !== null && _h !== void 0 ? _h : 0;
        } else {
          return 0;
        }
      };
      var minimumPaymentDue = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        var minimuPaymentDue = (_a = state.payment) === null || _a === void 0 ? void 0 : _a.monthlyPaymentAmount;
        if (((_e = (_d = (_c = (_b = props.layout) === null || _b === void 0 ? void 0 : _b.paymentModel) === null || _c === void 0 ? void 0 : _c.loan) === null || _d === void 0 ? void 0 : _d.defaultPayments) === null || _e === void 0 ? void 0 : _e.route) == "Default" && (((_j = (_h = (_g = (_f = props.layout) === null || _f === void 0 ? void 0 : _f.paymentModel) === null || _g === void 0 ? void 0 : _g.loan) === null || _h === void 0 ? void 0 : _h.defaultPayments) === null || _j === void 0 ? void 0 : _j.ruleId) == RuleId.Increased_Payment_Plan || ((_o = (_m = (_l = (_k = props.layout) === null || _k === void 0 ? void 0 : _k.paymentModel) === null || _l === void 0 ? void 0 : _l.loan) === null || _m === void 0 ? void 0 : _m.defaultPayments) === null || _o === void 0 ? void 0 : _o.ruleId) == RuleId.Reduced_Payment_Plan)) {
          (_t = (_s = (_r = (_q = (_p = props.layout) === null || _p === void 0 ? void 0 : _p.paymentModel) === null || _q === void 0 ? void 0 : _q.loan) === null || _r === void 0 ? void 0 : _r.defaultPayments) === null || _s === void 0 ? void 0 : _s.defaultPaymentsDue) === null || _t === void 0 ? void 0 : _t.forEach(function (defpayment) {
            var _a;
            if (((_a = defpayment === null || defpayment === void 0 ? void 0 : defpayment.paymentType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == "r" && (defpayment.defaultPaymentType == defaulPaymentType.PIT || defpayment.defaultPaymentType == defaulPaymentTypeStr.PIT)) {
              minimuPaymentDue = defpayment.paymentAmountDue;
            }
          });
        }
        return minimuPaymentDue;
      };
      var paymentType = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        // return 1000146;
        if (!props.isOtp) {
          return 201309;
        } else {
          if (((_c = (_b = (_a = props.layout.paymentModel) === null || _a === void 0 ? void 0 : _a.payment) === null || _b === void 0 ? void 0 : _b.delinquentPayments) === null || _c === void 0 ? void 0 : _c.length) > 1) {
            if ((_f = (_e = (_d = props.layout.paymentModel) === null || _d === void 0 ? void 0 : _d.payment) === null || _e === void 0 ? void 0 : _e.delinquentPayments) === null || _f === void 0 ? void 0 : _f.some(function (s) {
              return !s.paid;
            })) {
              return 201311;
            } else {
              return 201299;
            }
          }
          if (isTrialPaymentVisible_1) {
            return 201296;
          } else {
            if (paymentWindow_1) {
              if (!(((_h = (_g = props.layout) === null || _g === void 0 ? void 0 : _g.currentLoan) === null || _h === void 0 ? void 0 : _h.escrowFlag) || totalFees_1() > 0)) {
                return 201297;
              } else {
                return 201299;
              }
            } else {
              if (forbearacne_1) {
                var payRuleId = (_m = (_l = (_k = (_j = props.layout) === null || _j === void 0 ? void 0 : _j.paymentModel) === null || _k === void 0 ? void 0 : _k.loan) === null || _l === void 0 ? void 0 : _l.defaultPayments) === null || _m === void 0 ? void 0 : _m.ruleId;
                if (payRuleId == RuleId.Reduced_Payment_Plan || payRuleId == RuleId.Increased_Payment_Plan) {
                  return 1000146;
                } else {
                  return 1000145;
                }
              } else {
                return (_p = (_o = props.layout.paymentModel) === null || _o === void 0 ? void 0 : _o.payment) === null || _p === void 0 ? void 0 : _p.paymentType;
              }
            }
          }
        }
      };
      var achnext = function () {
        var _a, _b;
        if (props.isOtp) {
          return moment((_b = (_a = props.layout.paymentModel) === null || _a === void 0 ? void 0 : _a.payment) === null || _b === void 0 ? void 0 : _b.effectiveDate);
        } else {
          return state.effectiveDate;
        }
      };
      var editPayment = props.layout.mobile ? __assign(__assign({}, (_36 = (_35 = props.route) === null || _35 === void 0 ? void 0 : _35.params) === null || _36 === void 0 ? void 0 : _36.payment), {
        feesHelperMethod: (_39 = (_38 = (_37 = props.layout) === null || _37 === void 0 ? void 0 : _37.paymentModel) === null || _38 === void 0 ? void 0 : _38.payment) === null || _39 === void 0 ? void 0 : _39.feesHelperMethod
      }) : __assign(__assign({}, (_41 = (_40 = props.location) === null || _40 === void 0 ? void 0 : _40.state) === null || _41 === void 0 ? void 0 : _41.payment), {
        feesHelperMethod: props.layout.paymentModel.payment.feesHelperMethod
      });
      var incomingPayment = edit ? editPayment : !props.isOtp && achExist ? achExist : __assign(__assign(__assign({}, state.payment), props.layout.paymentModel.payment), {
        bankAccount: __assign(__assign({}, (_43 = (_42 = props.layout.paymentModel) === null || _42 === void 0 ? void 0 : _42.payment) === null || _43 === void 0 ? void 0 : _43.bankAccount), {
          bankAccountType: ((_46 = (_45 = (_44 = props.layout.paymentModel) === null || _44 === void 0 ? void 0 : _44.payment) === null || _45 === void 0 ? void 0 : _45.bankAccount) === null || _46 === void 0 ? void 0 : _46.bankAccountType) != 201288 ? (_49 = (_48 = (_47 = props.layout.paymentModel) === null || _47 === void 0 ? void 0 : _47.payment) === null || _48 === void 0 ? void 0 : _48.bankAccount) === null || _49 === void 0 ? void 0 : _49.bankAccountType : 201286
        }),
        bankAccountType: ((_52 = (_51 = (_50 = props.layout.paymentModel) === null || _50 === void 0 ? void 0 : _50.payment) === null || _51 === void 0 ? void 0 : _51.bankAccount) === null || _52 === void 0 ? void 0 : _52.bankAccountType) && ((_55 = (_54 = (_53 = props.layout.paymentModel) === null || _53 === void 0 ? void 0 : _53.payment) === null || _54 === void 0 ? void 0 : _54.bankAccount) === null || _55 === void 0 ? void 0 : _55.bankAccountType) != 201288 ? (_58 = (_57 = (_56 = props.layout.paymentModel) === null || _56 === void 0 ? void 0 : _56.payment) === null || _57 === void 0 ? void 0 : _57.bankAccount) === null || _58 === void 0 ? void 0 : _58.bankAccountType : 201286,
        paymentType: paymentType(),
        totalDraftAmount: paymentWindow_1 ? 0 : (_60 = (_59 = props.layout.paymentModel) === null || _59 === void 0 ? void 0 : _59.payment) === null || _60 === void 0 ? void 0 : _60.totalDraftAmount,
        dueDate: (_61 = props.layout.currentLoan) === null || _61 === void 0 ? void 0 : _61.nextPaymentDueDate,
        effectiveDate: achnext(),
        // defaultPayments: props.layout.paymentModel?.payment?.loan?.defaultPayments,
        forbearanceAmount: minimumPaymentDue()
      });
      if (!edit && ((_62 = incomingPayment === null || incomingPayment === void 0 ? void 0 : incomingPayment.delinquentPayments) === null || _62 === void 0 ? void 0 : _62.length) > 1) {
        var lastUnselectedIndex = null;
        incomingPayment.delinquentPayments.sort(function (a, b) {
          return new Date(a.dueDate) - new Date(b.dueDate);
        });
        for (var i = 0; i < incomingPayment.delinquentPayments.length; i++) {
          if (!incomingPayment.delinquentPayments[i].selected && ((_64 = (_63 = incomingPayment.delinquentPayments) === null || _63 === void 0 ? void 0 : _63[i - 1]) === null || _64 === void 0 ? void 0 : _64.status) == 'Pending') {
            lastUnselectedIndex = i;
            break;
          }
        }
        if ((incomingPayment === null || incomingPayment === void 0 ? void 0 : incomingPayment.delinquentPayments) !== null && lastUnselectedIndex > 0 && lastUnselectedIndex < ((_65 = incomingPayment.delinquentPayments) === null || _65 === void 0 ? void 0 : _65.length)) {
          incomingPayment.delinquentPayments[lastUnselectedIndex].selected = true;
        }
      }
      var setPayment = __assign(__assign({}, props.layout), {
        paymentModel: __assign(__assign({}, props.layout.paymentModel), {
          payment: incomingPayment
        })
      });
      if (props.testFixture) {
        props.testFixture(setPayment);
      }
      var getLatestPaidDueDate = function (payments) {
        var _a;
        var latestDueDate = (payments === null || payments === void 0 ? void 0 : payments.length) > 0 ? (_a = payments[0]) === null || _a === void 0 ? void 0 : _a.dueDate : null;
        for (var _i = 0, payments_1 = payments; _i < payments_1.length; _i++) {
          var payment = payments_1[_i];
          if (payment.paid && (!latestDueDate || payment.dueDate > latestDueDate)) {
            latestDueDate = payment.dueDate;
          }
        }
        return moment(latestDueDate).add('month', 1);
      };
      return __assign(__assign({}, state), {
        open: show,
        pathname: path,
        modalType: "pendingPayments",
        lateChargeGraceEndDate: (_66 = props.layout.currentLoan) === null || _66 === void 0 ? void 0 : _66.lateChargeGraceEndDate,
        graceDays: (_67 = props.layout.currentLoan) === null || _67 === void 0 ? void 0 : _67.graceDays,
        pendingPaymentDate: ((_69 = (_68 = props.layout.paymentModel) === null || _68 === void 0 ? void 0 : _68.pendingPayments) === null || _69 === void 0 ? void 0 : _69.find(function (s) {
          return s.paymentType == 201298 || s.paymentType == 201311;
        })) ? (_72 = (_71 = (_70 = props.layout.paymentModel) === null || _70 === void 0 ? void 0 : _70.pendingPayments) === null || _71 === void 0 ? void 0 : _71.filter(function (s) {
          return s.paymentType == 201298 || s.paymentType == 201311;
        })) === null || _72 === void 0 ? void 0 : _72.sort(function (a, b) {
          return new Date(a.dueDate) - new Date(b.dueDate);
        })[0] : {},
        lastEffectiveDate: ((_74 = (_73 = props.layout.paymentModel) === null || _73 === void 0 ? void 0 : _73.pendingPayments) === null || _74 === void 0 ? void 0 : _74.find(function (s) {
          return s.paymentType == 201298 || s.paymentType == 201311;
        })) ? (_77 = (_76 = (_75 = props.layout.paymentModel) === null || _75 === void 0 ? void 0 : _75.pendingPayments) === null || _76 === void 0 ? void 0 : _76.filter(function (s) {
          return s.paymentType == 201298 || s.paymentType == 201311;
        })) === null || _77 === void 0 ? void 0 : _77.sort(function (a, b) {
          return new Date(b.effectiveDate) - new Date(a.effectiveDate);
        })[0] : {},
        isMounted: ((_79 = (_78 = props.layout.paymentModel) === null || _78 === void 0 ? void 0 : _78.payment) === null || _79 === void 0 ? void 0 : _79.monthlyPaymentAmount) != undefined,
        isMountedBank: true,
        edit: edit || false,
        originalNextPaymentDueDate: (_80 = props.layout.currentLoan) === null || _80 === void 0 ? void 0 : _80.originalNextPaymentDueDate,
        nextPaymentDueDate: incomingPayment.delinquentPayments.length > 0 ? getLatestPaidDueDate(incomingPayment.delinquentPayments) : (_81 = props.layout.currentLoan) === null || _81 === void 0 ? void 0 : _81.nextPaymentDueDate,
        canMakePrincipleReduction: moment((_82 = props.layout.currentLoan) === null || _82 === void 0 ? void 0 : _82.originalNextPaymentDueDate).year() > moment(props.layout.localTime).year() || moment((_83 = props.layout.currentLoan) === null || _83 === void 0 ? void 0 : _83.originalNextPaymentDueDate).month() > moment(props.layout.localTime).month(),
        canMakeAdditionalAmounts: ((_85 = (_84 = props.layout) === null || _84 === void 0 ? void 0 : _84.currentLoan) === null || _85 === void 0 ? void 0 : _85.delinquentPaymentCount) <= 1 || (isLegacy ? (_87 = (_86 = props.layout) === null || _86 === void 0 ? void 0 : _86.paymentModel) === null || _87 === void 0 ? void 0 : _87.pendingPaymentWillMakeLoanCurrentByAmount : false),
        page: !props.isOtp && achExist != undefined && !edit ? "confirm" : state.page == "bank" ? "bank" : "pay",
        achExist: achExist != undefined && !props.isOtp,
        openedTerms: achExist != undefined && !props.isOtp || edit || false,
        payment: incomingPayment
      });
    }
    return __assign(__assign({}, state), {
      achExist: achExist != undefined && !props.isOtp
    });
  };
  MonthlyPayment.prototype.render = function () {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84;
    var _85 = this.props,
      translations = _85.translations,
      layout = _85.layout,
      paymentType = _85.paymentType,
      matches = _85.matches,
      disableDebit = _85.disableDebit,
      route = _85.route;
    var _86 = ((_a = this.state.payment) === null || _a === void 0 ? void 0 : _a.bankAccount) || {},
      _87 = _86.bankAccountType,
      bankAccountType = _87 === void 0 ? 201286 : _87,
      bankAccountId = _86.bankAccountId,
      routingTransitNumber = _86.routingTransitNumber,
      accountNumber = _86.accountNumber,
      accountName = _86.accountName,
      unmaskedAccountNumber = _86.unmaskedAccountNumber;
    var _88 = this.state,
      deliquentPayment = _88.deliquentPayment,
      displayedConfirmationId = _88.displayedConfirmationId,
      errors = _88.errors,
      canMakePrincipleReduction = _88.canMakePrincipleReduction,
      canMakeAdditionalAmounts = _88.canMakeAdditionalAmounts,
      nextPaymentDueDate = _88.nextPaymentDueDate,
      edit = _88.edit,
      tabProgression = _88.tabProgression,
      pendingPaymentDate = _88.pendingPaymentDate,
      originalNextPaymentDueDate = _88.originalNextPaymentDueDate,
      openDebit = _88.openDebit,
      achExist = _88.achExist,
      payment = _88.payment,
      graceDays = _88.graceDays;
    var status = (_b = layout.selectedLoanAvailability) === null || _b === void 0 ? void 0 : _b.status;
    var modifications = layout.modifications,
      paymentModel = layout.paymentModel;
    var isTrialPaymentVisible = (modifications === null || modifications === void 0 ? void 0 : modifications.isTrialPaymentVisible) || (modifications === null || modifications === void 0 ? void 0 : modifications.enablePaymentCoupon);
    var currentTime = moment(layout.localTime);
    var dueDate = moment(layout.currentLoan.nextPaymentDueDate);
    var isDefaultOrDelinquent = ((_e = (_d = (_c = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _c === void 0 ? void 0 : _c.loan) === null || _d === void 0 ? void 0 : _d.defaultPayments) === null || _e === void 0 ? void 0 : _e.route) == "Default" || ((_h = (_g = (_f = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _f === void 0 ? void 0 : _f.loan) === null || _g === void 0 ? void 0 : _g.defaultPayments) === null || _h === void 0 ? void 0 : _h.route) == "Delinquent";
    var isLegacy = ((_k = (_j = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _j === void 0 ? void 0 : _j.loan) === null || _k === void 0 ? void 0 : _k.defaultPayments) == null ? true : !isDefaultOrDelinquent;
    var numberofPostedScheduledPendingPayments = (_m = (_l = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _l === void 0 ? void 0 : _l.pendingPaymentsPostedWithoutFailedStatus) === null || _m === void 0 ? void 0 : _m.length;
    //  let paymentWindow = !edit && (ammountPaymentAhead(status, 2) || (getActiveFeatures(layout.features, `BRMS_Delinquent`, layout.whitelisted) ? false: layout?.paymentModel?.numberofPendingPayments >= 2) || (moment(originalNextPaymentDueDate).isAfter(moment(layout.localTime)) && moment([dueDate.year(), dueDate.month(), dueDate.date()]).diff(moment([currentTime.year(), currentTime.month(), dueDate.date()]), 'months', true) > 2))
    var paymentWindow = !edit && (ammountPaymentAhead(status, 2) || (isLegacy ? (_o = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _o === void 0 ? void 0 : _o.pendingPaymentWillMakeLoanCurrentByAmount : false) || (getActiveFeatures(layout.features, "BRMS_Delinquent", layout.whitelisted) ? false : ((_p = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _p === void 0 ? void 0 : _p.numberofPendingPayments) >= 2) || moment(originalNextPaymentDueDate).isAfter(moment(layout.localTime)) && moment([dueDate.year(), dueDate.month(), dueDate.date()]).diff(moment([currentTime.year(), currentTime.month(), dueDate.date()]), 'months', true) > 2);
    var isOtp = this.props.isOtp;
    if ((_q = route === null || route === void 0 ? void 0 : route.params) === null || _q === void 0 ? void 0 : _q.isOtp) {
      isOtp = true;
    }
    var getMinimumPaymentDue = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
      var minimuPaymentDue = (_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.monthlyPaymentAmount;
      if (((_d = (_c = (_b = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _b === void 0 ? void 0 : _b.loan) === null || _c === void 0 ? void 0 : _c.defaultPayments) === null || _d === void 0 ? void 0 : _d.route) == "Default" && (((_g = (_f = (_e = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _e === void 0 ? void 0 : _e.loan) === null || _f === void 0 ? void 0 : _f.defaultPayments) === null || _g === void 0 ? void 0 : _g.ruleId) == RuleId.Increased_Payment_Plan || ((_k = (_j = (_h = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _h === void 0 ? void 0 : _h.loan) === null || _j === void 0 ? void 0 : _j.defaultPayments) === null || _k === void 0 ? void 0 : _k.ruleId) == RuleId.Reduced_Payment_Plan)) {
        (_p = (_o = (_m = (_l = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _l === void 0 ? void 0 : _l.loan) === null || _m === void 0 ? void 0 : _m.defaultPayments) === null || _o === void 0 ? void 0 : _o.defaultPaymentsDue) === null || _p === void 0 ? void 0 : _p.forEach(function (defpayment) {
          var _a;
          if (((_a = defpayment === null || defpayment === void 0 ? void 0 : defpayment.paymentType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == "r" && (defpayment.defaultPaymentType == defaulPaymentType.PIT || defpayment.defaultPaymentType == defaulPaymentTypeStr.PIT)) {
            minimuPaymentDue = defpayment.paymentAmountDue;
          }
        });
      }
      return minimuPaymentDue;
    };
    var getMinimumPaymentDueDate = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
      var paymentDueDate = _this.state.nextPaymentDueDate;
      if (((_c = (_b = (_a = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _a === void 0 ? void 0 : _a.loan) === null || _b === void 0 ? void 0 : _b.defaultPayments) === null || _c === void 0 ? void 0 : _c.route) == "Default" && (((_f = (_e = (_d = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _d === void 0 ? void 0 : _d.loan) === null || _e === void 0 ? void 0 : _e.defaultPayments) === null || _f === void 0 ? void 0 : _f.ruleId) == RuleId.Increased_Payment_Plan || ((_j = (_h = (_g = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _g === void 0 ? void 0 : _g.loan) === null || _h === void 0 ? void 0 : _h.defaultPayments) === null || _j === void 0 ? void 0 : _j.ruleId) == RuleId.Reduced_Payment_Plan)) {
        (_o = (_m = (_l = (_k = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _k === void 0 ? void 0 : _k.loan) === null || _l === void 0 ? void 0 : _l.defaultPayments) === null || _m === void 0 ? void 0 : _m.defaultPaymentsDue) === null || _o === void 0 ? void 0 : _o.forEach(function (defpayment) {
          var _a;
          if (((_a = defpayment.paymentType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == "r" && (defpayment.defaultPaymentType == defaulPaymentType.PIT || defpayment.defaultPaymentType == defaulPaymentTypeStr.PIT)) {
            paymentDueDate = defpayment.paymentDueDate;
          }
        });
      }
      return paymentDueDate;
    };
    var getMaxPaymentEffectiveDate = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j;
      var maxPaymentEffectiveDate = !((_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.mustMakeDelinquentPayment) ? moment(layout.localTime).add(60, 'day') : moment(layout.localTime).endOf('month');
      if (((_d = (_c = (_b = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _b === void 0 ? void 0 : _b.loan) === null || _c === void 0 ? void 0 : _c.defaultPayments) === null || _d === void 0 ? void 0 : _d.route) == "Default" || ((_g = (_f = (_e = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _e === void 0 ? void 0 : _e.loan) === null || _f === void 0 ? void 0 : _f.defaultPayments) === null || _g === void 0 ? void 0 : _g.route) == "Delinquent") {
        maxPaymentEffectiveDate = moment((_j = (_h = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _h === void 0 ? void 0 : _h.loan) === null || _j === void 0 ? void 0 : _j.defaultPayments.maxPaymentEffectiveDate);
      }
      return maxPaymentEffectiveDate;
    };
    var onChange = function (value, property) {
      var _a;
      if (checkForAllNumbersCurrency(value)) {
        _this.setState({
          payment: __assign(__assign({}, _this.state.payment), (_a = {}, _a[property] = value, _a))
        }, function () {
          _this.setState({
            payment: __assign(__assign({}, _this.state.payment), {
              totalDraftAmount: _this.totalDraftAmountFun()
            })
          });
        });
      }
    };
    var onChangeFee = function (value, property) {
      var existingFees = 0;
      var allFes = __spreadArray([], paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.pendingPayments.filter(function (s) {
        var _a;
        return ((_a = s.feesDues) === null || _a === void 0 ? void 0 : _a.find(function (d) {
          return d.fieldName == property;
        })) && s.achConfigurationKey != payment.achConfigurationKey;
      }), true);
      if (allFes.length > 0) {
        allFes.forEach(function (e) {
          existingFees += isNaN(parseFloat(e.feesDues.find(function (d) {
            return d.fieldName == property;
          }).orignalFeeAmt)) ? 0 : parseFloat(e.feesDues.find(function (d) {
            return d.fieldName == property;
          }).orignalFeeAmt);
        });
      }
      var amount = edit ? isNaN(parseFloat(value)) ? 0 + existingFees : parseFloat(value) + existingFees : isNaN(parseFloat(value)) ? 0 : parseFloat(value);
      if (parseFloat(_this.getStateValueOriginal(property)) >= amount && checkForAllNumbersCurrency(value)) {
        var fees = _this.state.payment.feesDues;
        if (fees.find(function (s) {
          return s.fieldName == property;
        })) {
          fees.find(function (s) {
            return s.fieldName == property;
          }).feeAmtField = value;
        }
        _this.setState({
          payment: __assign(__assign({}, _this.state.payment), {
            feesDues: fees
          })
        }, function () {
          _this.setState({
            payment: __assign(__assign({}, _this.state.payment), {
              totalDraftAmount: _this.totalDraftAmountFun()
            })
          });
        });
      }
    };
    var aheadOneMonth = moment(nextPaymentDueDate).clone().add(1, "month");
    var disableDate = function (date) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
      if (date == "" || !date) {
        return true;
      }
      if (isOtp) {
        var blackDate = (_a = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.blackoutDates) === null || _a === void 0 ? void 0 : _a.map(function (s) {
          return moment(s).format("MM/DD/YYYY");
        });
        if (edit && blackDate && paymentModel && paymentModel.blackoutDates && _this.state.payment && _this.state.payment.effectiveDate) {
          blackDate === null || blackDate === void 0 ? void 0 : blackDate.splice(paymentModel.blackoutDates.findIndex(function (s) {
            return moment(s).format("MM/DD/YYYY") == moment(_this.state.payment.effectiveDate).format("MM/DD/YYYY");
          }), 1);
        }
        if (((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.paymentType) == 201297 && canMakePrincipleReduction && moment(date) > moment(layout.localTime).endOf('month')) {
          return true;
        }
        if (blackDate === null || blackDate === void 0 ? void 0 : blackDate.find(function (s) {
          return s == moment(date).format("MM/DD/YYYY");
        })) {
          return true;
        }
        var dd = moment(date, "MM/DD/YYYY", true);
        if (!dd.isValid() || moment(date).isBefore(moment(layout.localTime).add("days", -1))) {
          return true;
        }
        if (((_e = (_d = (_c = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _c === void 0 ? void 0 : _c.loan) === null || _d === void 0 ? void 0 : _d.defaultPayments) === null || _e === void 0 ? void 0 : _e.route) == "Default" || ((_h = (_g = (_f = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _f === void 0 ? void 0 : _f.loan) === null || _g === void 0 ? void 0 : _g.defaultPayments) === null || _h === void 0 ? void 0 : _h.route) == "Delinquent") {
          if (moment(date.date()).isAfter(moment((_k = (_j = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _j === void 0 ? void 0 : _j.loan) === null || _k === void 0 ? void 0 : _k.defaultPayments.maxPaymentEffectiveDate))) {
            return true;
          }
        } else if (moment(date).isSameOrAfter(moment(layout.localTime).add('days', 60))) {
          return true;
        }
      }
      return false;
    };
    var checkDate = function (amount) {
      var dtc = moment(layout.localTime);
      var retv = 4;
      for (var i = 1; i <= amount; i++) {
        var d = dtc.add('days', 1);
        if (d.day() == 0) {
          retv = 5;
        }
      }
      return retv;
    };
    var achStart = moment(originalNextPaymentDueDate).set('month', moment(layout.localTime).month()).set('year', moment(layout.localTime).year());
    var monthlyPaymentdisabled = paymentWindow || !(((_r = this.state.payment) === null || _r === void 0 ? void 0 : _r.delinquentPayments) ? ((_t = (_s = this.state.payment) === null || _s === void 0 ? void 0 : _s.delinquentPayments) === null || _t === void 0 ? void 0 : _t.length) > 0 ? (_v = (_u = this.state.payment) === null || _u === void 0 ? void 0 : _u.delinquentPayments) === null || _v === void 0 ? void 0 : _v.some(function (s) {
      return !s.paid;
    }) : true : true);
    var principalReductionedisabled = !canMakePrincipleReduction || parseInt(bankAccountType) == 201288;
    var additionalAmountDisabled = !canMakeAdditionalAmounts;
    var draftDate = [{
      key: -1,
      label: "".concat(achStart.clone().date()),
      value: achStart.clone().date(),
      date: achStart.clone().format("MM/DD/YYYY")
    }];
    var days = graceDays + 1;
    for (var i = 1; i < days; i++) {
      if (achStart.clone().add("day", i).isSameOrAfter(moment(layout.localTime).endOf('month'))) {
        break;
      }
      draftDate.push({
        key: i,
        label: "".concat(achStart.clone().add("day", i).date()),
        value: achStart.clone().add("day", i).date(),
        date: achStart.clone().add("day", i).format("MM/DD/YYYY")
      });
    }
    return /*#__PURE__*/React.createElement(View, {
      style: {
        backgroundColor: "#FFF",
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
        overflow: 'hidden'
      }
    }, ((_w = Object.keys(errors)) === null || _w === void 0 ? void 0 : _w.length) > 0 ? /*#__PURE__*/React.createElement(PnmacCard, {
      style: {
        padding: 15,
        backgroundColor: "pink"
      }
    }, Object.keys(errors).map(function (s) {
      // return <View><PnmacText>{s} ::: {errors[s]}</PnmacText></View>
      return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, errors[s]));
    })) : null, /*#__PURE__*/React.createElement(PnmacModal, {
      open: openDebit,
      style: {
        borderRadius: 10
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: __assign(__assign({}, useStyles.paper), {
        maxWidth: matches.small ? "90%" : 500,
        maxHeight: "90%"
      })
    }, /*#__PURE__*/React.createElement(Interstitial, {
      timeCallback: function (errorMessage) {
        _this.setState(_this.intiialState(_this.props));
        _this.props.dispatch({
          type: PAYMENT_VALIDATION,
          payment: {}
        });
        _this.props.authenticate();
        var errorType = errorMessage;
        if (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.time) {
          if ((errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.time) === 'AfterWorkingHoursPaymentErrorMessage') {
            errorType = {
              time: _this.props.translations.AfterWorkingHoursPaymentErrorMessage
            };
          }
        }
        _this.setState({
          paymentSubmitted: false,
          errors: errorType
        });
      },
      debitFee: this.replaceDollarSign(this.getStateValueOriginal("debitCardConvenienceFee")),
      closeModal: function () {
        return _this.setState({
          openDebit: false
        });
      },
      payment: function () {
        var _a;
        var payment = _this.getState().payment;
        payment.loan = layout.currentLoan;
        payment.loanId = layout.selectedLoanNumber;
        payment.totalDraftAmount = _this.totalDraftAmountFun(true);
        payment.doubleMonthlyPaymentAmount = _this.replaceDollarSign(payment.doubleMonthlyPaymentAmount);
        Object.keys(payment).map(function (s) {
          if ("suspenseAmount,monthlyPaymentAmount,totalFeesAmount,additionalEscrowAmount,delinquentPaymentAmount,additionalPrincipalAmount".indexOf(s) > -1) {
            payment[s] = isNaN(_this.replaceDollarSign(payment[s])) ? 0.00 : _this.replaceDollarSign(payment[s]);
          }
        });
        if (((_a = payment === null || payment === void 0 ? void 0 : payment.feesDues) === null || _a === void 0 ? void 0 : _a.length) > 0) {
          payment.feesDues = payment === null || payment === void 0 ? void 0 : payment.feesDues.filter(function (s) {
            return parseFloat(s.feeAmtField) > 0;
          });
          payment.feesDues.forEach(function (d) {
            return delete d._feeAmtField;
          });
        }
        return payment;
      }
    }))), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        justifyContent: "flex-start"
      }
    }, /*#__PURE__*/React.createElement(PnmacTabs, {
      small: true,
      selected: this.state.page,
      style: layout.mobile ? {
        justifyContent: "flex-start",
        alignItems: "flex-start",
        marginTop: 20,
        marginLeft: !isOtp ? 10 : 15,
        width: !isOtp ? "95%" : "70%"
      } : {
        justifyContent: "flex-start",
        marginLeft: 20,
        marginTop: 20
      },
      iconStyle: __assign(__assign({}, styles.oneTimePayment.tabPan), textStyle.nonActiveTab),
      selectedIconStyle: __assign({
        height: "auto",
        borderWidth: 1,
        borderColor: "#DDD",
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        padding: 10,
        color: "#FFF"
      }, textStyle.activeTab),
      onSelect: function (el) {
        if ((_this.state.confirmation || !isOtp) && tabProgression.includes(el.props.name)) {
          _this.setState({
            page: el.props.name
          });
        }
      }
    }, /*#__PURE__*/React.createElement(View, {
      name: "pay"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblOtpPaymentDetailsStepTitle',
      style: this.state.page === 'pay' ? textStyle.activeTabText : textStyle.nonActiveTabText
    }, matches.small ? "Payment" : translations.OtpPaymentDetailsStepTitle)), !isOtp && /*#__PURE__*/React.createElement(View, {
      name: "bank"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblPaymentBankAccount',
      style: this.state.page === 'bank' ? textStyle.activeTabText : textStyle.nonActiveTabText
    }, "Bank Account")), /*#__PURE__*/React.createElement(View, {
      name: "confirm"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblOtpConfirmationStepTitle',
      style: this.state.page === 'confirm' ? textStyle.activeTabText : textStyle.nonActiveTabText
    }, translations.OtpConfirmationStepTitle)))), /*#__PURE__*/React.createElement(AddBankAccount, __assign({
      addBank: function (account) {
        _this.setState({
          payment: __assign(__assign({}, _this.state.payment), {
            bankAccount: account,
            bankAccountType: account.bankAccountType
          })
        });
      },
      isOtp: isOtp,
      bankAccountId: bankAccountId,
      bankAccountType: bankAccountType || 201286,
      matches: matches,
      setBankType: function (type) {
        return _this.changeAccount(type);
      },
      open: this.state.addBankAccount
    }, this.props, {
      closeModal: function () {
        return _this.setState({
          addBankAccount: false
        });
      },
      trackerDispatcher: this.props.trackerDispatcher
    })), /*#__PURE__*/React.createElement(TransitionsModal, __assign({
      firstMonthlyPaymentDate: pendingPaymentDate === null || pendingPaymentDate === void 0 ? void 0 : pendingPaymentDate.effectiveDate,
      nextPaymentDueDate: nextPaymentDueDate,
      displayedConfirmationId: displayedConfirmationId,
      matches: matches,
      location: this.props.location,
      paymentCallback: function (go) {
        var _a, _b, _c, _d, _e, _f;
        if (go || layout.paymentModel.pendingPayments.filter(function (w) {
          return w.paymentType == 201298 || w.paymentType == 201311;
        }).length == 0 && !edit) {
          if (!_this.state.deliquentPayment && ((_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.mustMakeDelinquentPayment) && !go && !((modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId) > 0 && (modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible)) && !((_b = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _b === void 0 ? void 0 : _b.isLoanInForbearance) && _this.isLoanInForbearance() == false) {
            /// this one can be removed with legacy delinquent payments
            _this.setState({
              modalType: "oneDelinquentPayment"
            });
          } else {
            if (_this.state.payment.delinquentPayments.filter(function (s) {
              return s.paid == false && s.mandatory == false;
            }).length != _this.state.payment.delinquentPayments.filter(function (s) {
              return s.paid == false && s.mandatory == false && s.selected == true;
            }).length && _this.state.modalType != "oneDelinquentPayment" && !((_c = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _c === void 0 ? void 0 : _c.isLoanInForbearance) && _this.isLoanInForbearance() == false) {
              _this.setState({
                modalType: "oneDelinquentPayment"
              });
            } else {
              _this.setState({
                page: "confirm",
                confirmation: true,
                open: false
              });
            }
          }
        } else {
          if (edit) {
            _this.setState({
              page: "confirm",
              confirmation: true,
              open: false
            });
          } else {
            if (((_f = (_e = (_d = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _d === void 0 ? void 0 : _d.pendingPayments) === null || _e === void 0 ? void 0 : _e.filter(function (w) {
              return ((w === null || w === void 0 ? void 0 : w.paymentType) == 201298 || (w === null || w === void 0 ? void 0 : w.paymentType) == 201311) && (w === null || w === void 0 ? void 0 : w.status) != 201295;
            })) === null || _f === void 0 ? void 0 : _f.length) > 0) {
              _this.setState({
                modalType: "pendingOneTimePayment"
              });
            } else {
              _this.setState({
                page: "confirm",
                confirmation: true,
                open: false
              });
            }
          }
        }
      },
      history: this.props.history,
      modalType: this.state.modalType,
      layout: layout,
      translations: translations,
      open: this.state.open
    }, this.props, {
      closeModal: function () {
        return _this.setState({
          open: false
        });
      }
    })), this.state.page == "bank" ? /*#__PURE__*/React.createElement(View, {
      style: __assign(__assign({}, styles.shadowStyles), {
        backgroundColor: "#FFF",
        padding: 10,
        marginLeft: 10,
        marginRight: 10,
        marginBottom: 10,
        marginTop: 0,
        borderRadius: 10
      }),
      name: "bank"
    }, bankAccountType != 201288 ? /*#__PURE__*/React.createElement(AddBankMod, __assign({
      edit: edit,
      checkNachaAddOrManageBanksOpen: function (nachaflag) {
        _this.setState({
          isNachaOpen: nachaflag
        });
      },
      addBank: function (account) {
        _this.setState({
          payment: __assign(__assign({}, _this.state.payment), {
            bankAccount: account,
            bankAccountType: account.bankAccountType
          })
        });
      }
    }, this.props, {
      setState: function (st) {
        return _this.setState(st);
      },
      isOtp: isOtp,
      bankAccountType: bankAccountType,
      payment: this.state.payment,
      matches: matches,
      unmaskedAccountNumber: unmaskedAccountNumber,
      translations: translations,
      layout: layout
    })) : null, /*#__PURE__*/React.createElement(View, {
      style: {
        backgroundColor: "#EFEFEF",
        padding: 10,
        borderRadius: 10,
        marginBottom: 15
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, translations === null || translations === void 0 ? void 0 : translations.PaymentMethod)), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: matches.small ? "flex-start" : "center",
        marginLeft: matches.small ? 10 : 15,
        marginBottom: 20
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: matches.small ? 10 : 0
      }
    }, /*#__PURE__*/React.createElement(PnmacToolTip, {
      text: translations.PaymentMethod,
      title: translations.IconPaymentMethod
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: matches.small ? 0 : 15
      }
    }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'rbnBankCheckingAccount',
      label: "First item",
      onPress: function () {
        _this.changeAccount(201286);
      },
      status: parseInt(bankAccountType) == 201286 ? "checked" : "unchecked"
    }), /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblBankCheckingAccount',
      style: textStyle.defaultTextDescription
    }, translations.CheckingAccount)), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: matches.small ? 0 : 15
      }
    }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'rbnBankSavingAccount',
      label: "First item",
      onPress: function () {
        _this.changeAccount(201287);
      },
      status: parseInt(bankAccountType) == 201287 ? "checked" : "unchecked"
    }), /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblBankSavingAccount',
      style: textStyle.defaultTextDescription
    }, translations.SavingsAccount))), /*#__PURE__*/React.createElement(BankAccountGrid, {
      matches: matches,
      isOtp: isOtp,
      layout: layout,
      setError: function () {
        return null;
      },
      setCanSubmitted: function () {
        return null;
      },
      translations: translations,
      bankAccount: {
        bankRoutingNumber: routingTransitNumber,
        bankAccountName: accountName,
        bankAccountType: bankAccountType,
        bankAccountNumber: maskBankInfo(accountNumber),
        confirmAccountNumber: accountNumber,
        unmaskedAccountNumber: unmaskedAccountNumber
      },
      onChange: function () {
        return null;
      }
    }), /*#__PURE__*/React.createElement(View, {
      style: {
        width: '100%',
        display: "flex",
        justifyContent: "space-between",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        width: '100%',
        display: "flex",
        justifyContent: "space-between",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      nativeID: "btnPreviousButtonPnmacText",
      style: {
        width: matches.small ? "90%" : "25%",
        marginTop: 25
      },
      disabled: this.state.paymentSubmitted,
      mode: "contained",
      testID: "PreviousButtonPnmacText",
      onPress: function () {
        return _this.setState({
          page: "pay"
        });
      }
    }, translations.PreviousButtonPnmacText), /*#__PURE__*/React.createElement(PnmacUIButton, {
      nativeID: "btnCancelButtonPnmacText",
      style: {
        width: matches.small ? "90%" : "25%",
        marginTop: 25
      },
      disabled: this.state.paymentSubmitted,
      mode: "outlined",
      testID: "CancelButtonPnmacText",
      onPress: function () {
        return _this.setState({
          page: "pay"
        });
      }
    }, translations.CancelButtonPnmacText), /*#__PURE__*/React.createElement(PnmacUIButton, {
      nativeID: "btnContinueButtonPnmacText",
      style: {
        width: matches.small ? "90%" : "25%",
        marginTop: 25
      },
      loading: this.state.paymentSubmitted,
      disabled: this.disableSubmitButton(),
      mode: "contained",
      testID: "ContinueButtonText",
      onPress: function () {
        _this.setState({
          page: "confirm",
          confirmation: true,
          tabProgression: __spreadArray(__spreadArray([], tabProgression, true), ["confirm"], false)
        });
      }
    }, translations.ContinueButtonText)))) : this.state.page == "pay" ? /*#__PURE__*/React.createElement(View, {
      style: __assign(__assign({
        backgroundColor: "#FFF",
        padding: matches.small ? 10 : 20,
        borderTopWidth: 1
      }, textStyle.formLineWeight), {
        borderBottomWidth: 0
      }),
      name: "pay"
    }, /*#__PURE__*/React.createElement(View, null, isOtp && /*#__PURE__*/React.createElement(View, {
      style: {
        backgroundColor: "#EAF5F8",
        padding: 10,
        marginHorizontal: -5,
        borderRadius: 6,
        marginBottom: 5,
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formTextInput
    }, translations === null || translations === void 0 ? void 0 : translations.PaymentMethod)), isOtp && /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: matches.small ? "flex-start" : "center",
        marginLeft: matches.small ? 10 : 15
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: matches.small ? 10 : 0
      }
    }, /*#__PURE__*/React.createElement(PnmacToolTip, {
      text: translations.PaymentMethod,
      title: translations.IconPaymentMethod
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: matches.small ? 0 : 15
      }
    }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'rbnOTPCheckingAccount',
      label: "First item",
      onPress: function () {
        _this.changeAccount(201286);
      },
      status: parseInt(bankAccountType) == 201286 ? "checked" : "unchecked"
    }), /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblOTPCheckingAccount',
      style: styles.oneTimePayment.labelText
    }, translations.CheckingAccount)), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: matches.small ? 0 : 15
      }
    }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'rbnOTPSavingAccount',
      label: "First item",
      onPress: function () {
        _this.changeAccount(201287);
      },
      status: parseInt(bankAccountType) == 201287 ? "checked" : "unchecked"
    }), /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblOTPSavingAccount',
      style: styles.oneTimePayment.labelText
    }, translations.SavingsAccount))), bankAccountType != 201288 && isOtp ? /*#__PURE__*/React.createElement(AddBankMod, __assign({
      edit: edit,
      checkNachaAddOrManageBanksOpen: function (nachaflag) {
        _this.setState({
          isNachaOpen: nachaflag
        });
      },
      addBank: function (account) {
        _this.setState({
          payment: __assign(__assign({}, _this.state.payment), {
            bankAccount: account,
            bankAccountType: account.bankAccountType
          })
        });
      }
    }, this.props, {
      setState: function (st) {
        return _this.setState(st);
      },
      isOtp: isOtp,
      bankAccountType: bankAccountType,
      payment: this.state.payment,
      matches: matches,
      unmaskedAccountNumber: unmaskedAccountNumber,
      translations: translations,
      layout: layout
    })) : null, this.state.payment.paymentType != 1000145 && this.state.payment.paymentType != 1000146 && /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: 15
      }
    }, getActiveFeaturesWithExceptions(layout, "DebitCard", (_y = (_x = layout.currentLoan) === null || _x === void 0 ? void 0 : _x.organizationServicerSummary) === null || _y === void 0 ? void 0 : _y.servicingContractTypeId) && isOtp && !(((_z = paymentStatus(status, "delinquent", [])) === null || _z === void 0 ? void 0 : _z.hasStatus) || ((_0 = this.state.payment) === null || _0 === void 0 ? void 0 : _0.paymentType) == 201297 || isTrialPaymentVisible) && paymentModel.canUseDebitCard && !layout.mobile && /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'rbnDebitCard',
      disabled: !(isOtp && !(((_1 = paymentStatus(status, "delinquent", [])) === null || _1 === void 0 ? void 0 : _1.hasStatus) || ((_2 = this.state.payment) === null || _2 === void 0 ? void 0 : _2.paymentType) == 201297 || isTrialPaymentVisible)) || edit,
      label: "First item",
      onPress: function () {
        _this.setState({
          isNachaOpen: false
        });
        _this.changeAccount(201288);
      },
      status: parseInt(bankAccountType) == 201288 ? "checked" : "unchecked"
    }), /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1,
        marginRight: 20
      }
    }, /*#__PURE__*/React.createElement(PnmacToolTip, {
      containerStyle: {
        flex: 1
      },
      style: {
        color: "#000",
        flex: 1
      },
      text: translations.DebitCard,
      title: translations.DebitCardTip
    }))), !paymentModel.canUseDebitCard && paymentModel.showNoDebitCardBannerMessage && !layout.mobile ? /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(BannerView.Text, null, translations === null || translations === void 0 ? void 0 : translations.NoDebitCardBannerMessage)) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 10,
        marginHorizontal: -5,
        borderRadius: 5,
        backgroundColor: "#EAF5F8",
        marginBottom: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formTextInput
    }, translations === null || translations === void 0 ? void 0 : translations.PaymentType)), !isTrialPaymentVisible && isOtp && this.state.payment.paymentType != 1000146 ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        marginLeft: 10,
        alignItems: "center",
        width: matches.small ? '100%' : '45%'
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        maxWidth: '50%'
      }
    }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'rbnMonthlyPaymentType',
      disabled: paymentWindow || edit || !(((_3 = this.state.payment) === null || _3 === void 0 ? void 0 : _3.delinquentPayments) ? ((_5 = (_4 = this.state.payment) === null || _4 === void 0 ? void 0 : _4.delinquentPayments) === null || _5 === void 0 ? void 0 : _5.length) > 0 ? (_7 = (_6 = this.state.payment) === null || _6 === void 0 ? void 0 : _6.delinquentPayments) === null || _7 === void 0 ? void 0 : _7.some(function (s) {
        return !s.paid;
      }) : true : true),
      label: "First item",
      onPress: function () {
        var _a;
        paymentType(201298);
        disableDebit(true);
        _this.setState({
          payment: __assign(__assign({}, _this.state.payment), {
            paymentType: _this.monthlyPayment(),
            effectiveDate: moment(payment === null || payment === void 0 ? void 0 : payment.originalEffectiveDate) || ((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.effectiveDate),
            totalDraftAmount: _this.totalDraftAmountFun(),
            additionalPrincipalAmount: "0.00",
            additionalEscrowAmount: "0.00"
          })
        }, function () {
          _this.setState({
            payment: __assign(__assign({}, _this.state.payment), {
              totalDraftAmount: _this.totalDraftAmountFun()
            })
          });
        });
      },
      status: ((_8 = this.state.payment) === null || _8 === void 0 ? void 0 : _8.paymentType) == 201298 || ((_9 = this.state.payment) === null || _9 === void 0 ? void 0 : _9.paymentType) == 201311 ? "checked" : "monthly"
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        maxWidth: '50%'
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblMonthlyPaymentType',
      style: textStyle.defaultTextDescription
    }, translations.MonthlyPayment))) : null, !isTrialPaymentVisible && isOtp && this.state.payment.paymentType != 1000146 ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        marginLeft: 10,
        alignItems: "center",
        width: matches.small ? '100%' : '45%'
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        maxWidth: '50%'
      }
    }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'rbnPrincipleReductionPaymentType',
      disabled: !canMakePrincipleReduction || edit || parseInt(bankAccountType) == 201288,
      label: "First item",
      onPress: function () {
        var _a, _b, _c, _d;
        paymentType(201297);
        disableDebit();
        _this.setState({
          payment: __assign(__assign({}, _this.state.payment), {
            paymentType: 201297,
            bankAccountType: (_b = (_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.bankAccount) === null || _b === void 0 ? void 0 : _b.bankAccountType,
            additionalPrincipalAmount: "0.00",
            additionalEscrowAmount: "0.00",
            bankAccount: __assign(__assign({}, _this.state.payment.bankAccount), {
              bankAccountType: parseInt(bankAccountType) == 201288 ? 201287 : (_d = (_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.bankAccount) === null || _d === void 0 ? void 0 : _d.bankAccountType
            })
          })
        }, function () {
          _this.setState({
            payment: __assign(__assign({}, _this.state.payment), {
              totalDraftAmount: _this.totalDraftAmountFun(),
              effectiveDate: moment(payment.originalEffectiveDate)
            })
          });
        });
      },
      status: ((_10 = this.state.payment) === null || _10 === void 0 ? void 0 : _10.paymentType) == 201297 ? "checked" : "principle"
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        maxWidth: '50%'
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblPrincipleReductionPaymentType',
      style: textStyle.defaultTextDescription
    }, translations.PrincipalReductionOnly))) : null, !isTrialPaymentVisible && isOtp && this.state.payment.paymentType != 1000146 && (layout.currentLoan.escrowFlag || this.totalFees() > 0) ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: 10,
        width: matches.small ? '100%' : '45%'
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        maxWidth: '50%'
      }
    }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'rbnAdditionalAmountPaymentType',
      label: "First item",
      onPress: function () {
        var _a;
        _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Payment Type-Additional Amounts|Mobile', -1, '', false);
        paymentType(201299);
        disableDebit(true);
        _this.setState({
          payment: __assign(__assign({}, _this.state.payment), {
            paymentType: 201299,
            additionalPrincipalAmount: "0.00",
            additionalEscrowAmount: "0.00",
            effectiveDate: moment(payment === null || payment === void 0 ? void 0 : payment.originalEffectiveDate) || ((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.effectiveDate)
          })
        }, function () {
          _this.setState({
            payment: __assign(__assign({}, _this.state.payment), {
              totalDraftAmount: _this.totalDraftAmountFun()
            })
          });
        });
      },
      status: ((_11 = this.state.payment) === null || _11 === void 0 ? void 0 : _11.paymentType) == 201299 ? "checked" : "additional",
      disabled: !canMakeAdditionalAmounts || edit
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        maxWidth: '50%'
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblAdditionalAmountPaymentType',
      style: textStyle.defaultTextDescription
    }, translations.AdditionalAmountsOnly))) : null, isTrialPaymentVisible && isOtp ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: 10,
        width: matches.small ? '100%' : '45%'
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        maxWidth: '50%'
      }
    }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'rbnModificationTrialPayment',
      label: "First item",
      onPress: function () {
        _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Payment Type-Mod Trial Payment|Mobile', -1, '', false);
        paymentType(201296);
        _this.setState({
          payment: __assign(__assign({}, _this.state.payment), {
            paymentType: 201296,
            additionalPrincipalAmount: "0.00",
            additionalEscrowAmount: "0.00"
          })
        }, function () {
          _this.setState({
            payment: __assign(__assign({}, _this.state.payment), {
              totalDraftAmount: _this.totalDraftAmountFun()
            })
          });
        });
      },
      status: ((_12 = this.state.payment) === null || _12 === void 0 ? void 0 : _12.paymentType) == 201296 ? "checked" : "additional"
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        maxWidth: '50%'
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblModificationTrialPayment',
      style: textStyle.defaultTextDescription
    }, translations.ModificationTrialPayment))), paymentWindow ? /*#__PURE__*/React.createElement(BannerView, {
      type: 'warning'
    }, /*#__PURE__*/React.createElement(BannerView.Text, null, (_13 = translations === null || translations === void 0 ? void 0 : translations.ScheduledMaximumTrialPayments) === null || _13 === void 0 ? void 0 : _13.replace("{0}", "60"))) : null) : null, !isOtp ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: 5,
        width: matches.small ? '100%' : '45%'
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        maxWidth: '50%'
      }
    }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'rbnAchDraftFrequencyMonthly',
      label: "First item",
      onPress: function () {
        paymentType(201309);
        disableDebit(true);
        _this.setState({
          payment: __assign(__assign({}, _this.state.payment), {
            paymentType: 201309,
            additionalPrincipalAmount: "0.00",
            additionalEscrowAmount: "0.00"
          })
        }, function () {
          _this.setState({
            payment: __assign(__assign({}, _this.state.payment), {
              totalDraftAmount: _this.totalDraftAmountFun()
            })
          });
        });
      },
      status: ((_14 = this.state.payment) === null || _14 === void 0 ? void 0 : _14.paymentType) == 201309 ? "checked" : "additional"
    })), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblAchDraftFrequencyMonthly',
      style: textStyle.defaultTextDescription
    }, translations.AchDraftFrequencyMonthly))) : null), (this.state.payment.paymentType == 201298 || ((_15 = this.state.payment) === null || _15 === void 0 ? void 0 : _15.paymentType) == 201311) && isOtp && (paymentWindow && !isTrialPaymentVisible ? /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(BannerView.Text, null, (_16 = translations.ScheduledMaximumMonthlyPayments) === null || _16 === void 0 ? void 0 : _16.replace("{0}", "60"))) : ((_17 = paymentStatus(status, "delinquent", [])) === null || _17 === void 0 ? void 0 : _17.hasStatus) || !canMakePrincipleReduction || edit || parseInt(bankAccountType) == 201288 ? /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(BannerView.Text, null, translations.UntilMonthlyPaymentsPaid)) : null), !edit && isOtp && ((_18 = this.state.payment) === null || _18 === void 0 ? void 0 : _18.paymentType) == 201298 && layout.isEscrowAnalysisEnabled && ((_19 = this.state.payment) === null || _19 === void 0 ? void 0 : _19.changeinMonthlyPaymentAmount) != null && ((_20 = this.state.payment) === null || _20 === void 0 ? void 0 : _20.changeinMonthlyPaymentAmount) ? /*#__PURE__*/React.createElement(BannerView, {
      type: 'warning',
      style: {
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, this.props, {
      size: 14,
      value: translations.PaymentEescrowlink,
      navigation: {
        navigate: function () {
          var label = "OTP/Escrow Payment Change|Mobile";
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, label, -1, "", false);
          PnmacNavigation(__assign({
            action: {
              pathname: "/Loan/EscrowAnalysisPaymentChange"
            }
          }, _this.props));
        }
      },
      onClick: function (e) {
        var target = e.target.toString();
        if (target != null && target.indexOf('/Loan/EscrowAnalysisPaymentChange') > -1) {
          var label = "OTP/Escrow Payment Change|WEB";
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, label, 0);
        }
      }
    }))) : null, isOtp && ((isLegacy ? !(((_21 = layout.paymentModel) === null || _21 === void 0 ? void 0 : _21.mustMakeDelinquentPayment) && numberofPostedScheduledPendingPayments == 0) : true) && (((_22 = this.state.payment) === null || _22 === void 0 ? void 0 : _22.paymentType) == 201298 || ((_23 = this.state.payment) === null || _23 === void 0 ? void 0 : _23.paymentType) == 1000146) && !paymentWindow || isTrialPaymentVisible ? /*#__PURE__*/React.createElement(React.Fragment, null, !edit && /*#__PURE__*/React.createElement(View, {
      style: __assign({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginHorizontal: Platform.OS === 'web' ? -20 : -10,
        marginTop: 20,
        paddingHorizontal: Platform.OS === 'web' ? 25 : 15,
        paddingVertical: 10,
        borderTopWidth: 1
      }, textStyle.formLineWeight)
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, layout.mobile ? /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBodyTotal, {
        color: '#117AAA'
      }],
      idTag1: 'lblPaymentAmountDue'
    }, translations.PaymentAmountDue) : /*#__PURE__*/React.createElement(PnmacToolTip, {
      style: textStyle.defaultTextDescription,
      text: translations.PaymentAmountDue,
      title: translations.DefaultPaymentsPaymentAmountMessage
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 2,
        alignItems: Platform.OS === 'web' ? undefined : 'flex-end'
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        alignItems: layout.mobile ? undefined : 'flex-end',
        width: layout.mobile ? undefined : 200
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBodyTotal, {
        color: '#117AAA'
      }],
      idTag1: 'lblMonthlyPaymentAmount'
    }, currencyFormatter('en-US', 'currency', 'USD', getMinimumPaymentDue()))))), !edit && /*#__PURE__*/React.createElement(View, {
      style: __assign({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginHorizontal: Platform.OS === 'web' ? -20 : -10,
        paddingHorizontal: Platform.OS === 'web' ? 25 : 15,
        paddingVertical: 10
      }, textStyle.formLineWeight)
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblPaymentDueOn'
    }, translations.PaymentDueOn)), /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 2,
        alignItems: Platform.OS === 'web' ? undefined : 'flex-end'
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        alignItems: layout.mobile ? undefined : 'flex-end',
        width: layout.mobile ? undefined : 200
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblNextPaymentDueDate',
      style: [textStyle.defaultTextDescription]
    }, moment(getMinimumPaymentDueDate()).format("MMM DD, YYYY")))))) : (((_24 = this.state.payment) === null || _24 === void 0 ? void 0 : _24.paymentType) == 201298 || ((_25 = this.state.payment) === null || _25 === void 0 ? void 0 : _25.paymentType) == 201311 || __spreadArray([], payment.delinquentPayments, true).length > 0) && (edit && !getActiveFeatures(layout.features, "BRMS_Delinquent", layout.whitelisted) ? layout.paymentModel.numberofPendingPayments > 1 : true) && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
      style: {
        paddingTop: 5
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblPaymentsPnmacText'
    }, translations.PaymentsPnmacText), /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblInOrderToUseOtpIncludeAllPastPayments',
      style: __assign(__assign({}, textStyle.defaultTextDescription), {
        fontStyle: "italic"
      })
    }, translations.InOrderToUseOtpIncludeAllPastPayments)), this.state.payment.paymentType == 201311 || __spreadArray([], payment.delinquentPayments, true).length > 0 ? /*#__PURE__*/React.createElement(Delinquent, __assign({
      delinquentPayments: __spreadArray([], payment.delinquentPayments, true),
      edit: edit,
      totalFees: this.totalFees,
      setState: function (st) {
        return _this.setState(st);
      }
    }, this.props, {
      payment: payment
    })) : /*#__PURE__*/React.createElement(LegacyDelinquent, __assign({
      deliquentPayment: this.state.deliquentPayment,
      totalFees: this.totalFees,
      setState: function (st) {
        return _this.setState(st);
      }
    }, this.props, {
      payment: payment
    })))), !isOtp ? /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(BannerView.Text, null, translations.AchPaymentDescription)) : null, /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        width: "100%",
        paddingLeft: 5,
        marginBottom: 20,
        marginTop: 20,
        paddingRight: 10
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        marginTop: 10,
        flex: 1
      }
    }, isOtp ? layout.mobile ? /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, translations.EffectiveDate) : /*#__PURE__*/React.createElement("label", {
      for: "EffectiveDateInput"
    }, /*#__PURE__*/React.createElement(PnmacToolTip, {
      style: textStyle.defaultTextDescription,
      text: translations.EffectiveDate,
      title: translations.EffectiveDateMessage
    })) : layout.mobile ? /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, translations.DraftDate) : /*#__PURE__*/React.createElement("label", {
      for: "EffectiveDateInput"
    }, /*#__PURE__*/React.createElement(PnmacToolTip, {
      style: textStyle.defaultTextDescription,
      text: translations.DraftDate,
      title: translations.EffectiveDateMessage
    }))), /*#__PURE__*/React.createElement(View, {
      style: Platform.OS === 'web' ? {
        flex: 2
      } : {
        flex: 1
      }
    }, isOtp ? parseInt(bankAccountType) != 201288 ? /*#__PURE__*/React.createElement(View, {
      style: {
        width: layout.mobile ? undefined : 200
      }
    }, /*#__PURE__*/React.createElement(PnmacDatePicker, {
      onPress: function () {
        return _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Payment Date|Mobile', -1, '', false);
      },
      onCancel: function () {
        return _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Payment Date-Back|Mobile', -1, '', false);
      },
      autoOk: true,
      initialFocusedDate: moment(layout.localTime),
      accessibilityLabel: "Select date",
      variant: "inline",
      inputVariant: "outlined",
      disablePast: true,
      format: "d",
      helperText: "Effective data",
      maxDate: getMaxPaymentEffectiveDate(),
      shouldDisableDate: function (date) {
        return disableDate(date);
      },
      minDateMessage: "You must select a date greater than today.",
      maxDateMessage: "You must select a date before this date.",
      style: __assign({}, layout.mobile ? {
        borderWidth: 1,
        borderColor: "#707070",
        borderRadius: 10,
        display: "flex",
        flexDirection: "row",
        paddingHorizontal: 10,
        height: 50,
        justifyContent: "space-between"
      } : null),
      id: "EffectiveDateInput",
      value: moment(this.state.payment.effectiveDate),
      onChange: function (dat) {
        if (dat && dat != moment(_this.state.payment.effectiveDate)) {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Payment Date-Save date|Mobile', -1, dat.clone(), false);
          _this.setState({
            payment: __assign(__assign({}, _this.state.payment), {
              effectiveDate: dat.clone()
            })
          });
        }
      },
      InputAdornmentProps: {
        position: "start"
      },
      animateYearScrolling: true
    })) : /*#__PURE__*/React.createElement(View, {
      style: {
        width: layout.mobile ? undefined : 200,
        alignItems: 'flex-end',
        height: 50,
        justifyContent: 'center',
        paddingHorizontal: 14
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblEffectiveDate'
    }, moment(this.state.payment.effectiveDate).format("MM/DD/YYYY"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PnmacSelect, {
      accessibilityLabel: "Select date",
      useNativeAndroidPickerStyle: Platform.select({
        android: false,
        web: true,
        ios: true
      }),
      placeholder: {
        label: 'Select a date...',
        value: null
      },
      Icon: layout.mobile ? function () {
        return /*#__PURE__*/React.createElement(Image, {
          style: {
            width: 16,
            height: 16
          },
          source: require("../../assets/expand-icon.png")
        });
      } : function () {
        return null;
      },
      idTag1: 'dropDownAchPayment',
      idTag2: 'dropDownDraftDate',
      onValueChange: function (value, d) {
        if (value) {
          var month = moment(originalNextPaymentDueDate) > moment(layout.localTime) ? moment(originalNextPaymentDueDate).month() : moment(layout.localTime).month();
          var ckDate = draftDate[d - 1];
          var current = moment(layout.localTime);
          if (moment(layout.localTime).add('days', checkDate(4)).isAfter(moment(ckDate.date, "MM/DD/YYYY")) && moment(originalNextPaymentDueDate).isSameOrBefore(moment(layout.localTime).add('day', checkDate(4)))) {
            var check = function () {
              var currentst = moment(layout.localTime).add('days', checkDate(4));
              var st = currentst.month();
              var ct = moment(layout.localTime).month();
              if (st > ct) {
                return currentst.date();
              }
              return 0;
            };
            if (moment(layout.localTime).date() > current.endOf('month').date() - checkDate(4) && parseInt(value) <= check()) {
              month = current.add('month', 2).month();
            } else {
              month = current.add('month', 1).month();
            }
          }
          var draftdate = moment(originalNextPaymentDueDate).set('date', parseInt(value));
          var finaldate = draftdate.set('month', month);
          if (finaldate < moment(layout.localTime)) {
            finaldate.set('year', finaldate.year() + 1);
          }
          _this.setState({
            draftDate: true,
            payment: __assign(__assign({}, _this.state.payment), {
              effectiveDate: finaldate
            })
          });
        }
      },
      style: {
        viewContainer: __assign({}, layout.mobile ? {
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "white",
          borderRadius: 10,
          height: 50,
          borderColor: '#707070',
          borderWidth: 1
        } : {
          maxWidth: 200
        }),
        iconContainer: {
          alignSelf: "center",
          justifyContent: "space-between"
        },
        inputIOSContainer: {
          justifyContent: "space-between"
        },
        inputIOS: {
          paddingLeft: 10
        },
        inputAndroidContainer: {
          borderRadius: 10,
          borderColor: '#707070',
          borderWidth: 1
        },
        inputAndroid: {
          paddingLeft: 10,
          paddingRight: 20
        }
      },
      value: moment((_27 = (_26 = this.state) === null || _26 === void 0 ? void 0 : _26.payment) === null || _27 === void 0 ? void 0 : _27.effectiveDate).date(),
      items: draftDate
    }), ((_28 = this.state.payment) === null || _28 === void 0 ? void 0 : _28.effectiveDate) && moment((_30 = (_29 = this.state) === null || _29 === void 0 ? void 0 : _29.payment) === null || _30 === void 0 ? void 0 : _30.effectiveDate).isAfter(moment(nextPaymentDueDate)) ? /*#__PURE__*/React.createElement(View, {
      style: {
        marginTop: 5
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, "Please note: Because your projected first draft date is ", moment((_32 = (_31 = this.state) === null || _31 === void 0 ? void 0 : _31.payment) === null || _32 === void 0 ? void 0 : _32.effectiveDate).format("MM/DD/YYYY"), ", if you haven't already done so, please make arrangements to cover any payments due prior to that date.")) : ((_33 = this.state.payment) === null || _33 === void 0 ? void 0 : _33.effectiveDate) ? /*#__PURE__*/React.createElement(View, {
      style: {
        marginTop: 5
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, "Your first draft date will be on ", moment((_35 = (_34 = this.state) === null || _34 === void 0 ? void 0 : _34.payment) === null || _35 === void 0 ? void 0 : _35.effectiveDate).format("MM/DD/YYYY"))) : null))), (this.state.payment.paymentType == 201298 || this.state.payment.paymentType == 201311) && moment(this.state.payment.effectiveDate).isSameOrAfter(moment((_36 = layout.currentLoan) === null || _36 === void 0 ? void 0 : _36.lateChargeGraceEndDate).add('days', 1).set("month", moment(nextPaymentDueDate).month())) && isOtp && moment(layout.localTime).month() >= moment(originalNextPaymentDueDate).month() ? /*#__PURE__*/React.createElement(BannerView, {
      style: {},
      type: 'warning'
    }, /*#__PURE__*/React.createElement(BannerView.Text, null, translations === null || translations === void 0 ? void 0 : translations.PaymentPastGracePeriod, " ", moment((_37 = layout.currentLoan) === null || _37 === void 0 ? void 0 : _37.lateChargeGraceEndDate).set("month", moment(nextPaymentDueDate).month()).format("MM/DD/YYYY"), " ", translations === null || translations === void 0 ? void 0 : translations.AdditionalLateFee, " ", currencyFormatter('en-US', 'currency', 'USD', (_38 = layout.currentLoan) === null || _38 === void 0 ? void 0 : _38.quotedLateChargeFeeAmount))) : null, (this.state.payment.paymentType == 201298 || this.state.payment.paymentType == 201311) && moment((_39 = this.state.payment) === null || _39 === void 0 ? void 0 : _39.effectiveDate).isSameOrAfter(aheadOneMonth) && isOtp && moment(layout.localTime).month() >= moment(originalNextPaymentDueDate).month() ? /*#__PURE__*/React.createElement(BannerView, {
      style: {
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement(BannerView.Text, null, translations.AdverseCredit)) : null, (((_40 = this.state.payment) === null || _40 === void 0 ? void 0 : _40.paymentType) == 201298 || ((_41 = this.state.payment) === null || _41 === void 0 ? void 0 : _41.paymentType) == 201309 || ((_42 = this.state.payment) === null || _42 === void 0 ? void 0 : _42.paymentType) == 201311) && (!paymentWindow || !isOtp) ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        paddingLeft: 5,
        marginBottom: 20,
        marginTop: 20,
        paddingRight: 10
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
      for: "txtPaymentAmt"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblPaymentAmount'
    }, translations.PaymentAmount)) : /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblPaymentAmount'
    }, translations.PaymentAmount)), /*#__PURE__*/React.createElement(View, {
      style: Platform.OS === 'web' ? {
        flex: 2
      } : {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacTextInput, {
      name: "monthlyPaymentAmount",
      nativeID: "txtPaymentAmt",
      mode: "outlined",
      disabled: true,
      disabledColored: true,
      style: {
        cursor: "not-allowed",
        width: layout.mobile ? undefined : 200
      },
      value: deliquentPayment || ((_43 = this.state.payment) === null || _43 === void 0 ? void 0 : _43.paymentType) == 201311 ? "$".concat(this.delinquentValue()) : "$".concat(this.replaceDollarSign(((_44 = layout.paymentModel) === null || _44 === void 0 ? void 0 : _44.mustMakeDelinquentPayment) && layout.paymentModel.numberofPendingPayments == 0 ? this.state.payment.delinquentPaymentAmount : this.state.payment.monthlyPaymentAmount)),
      onChangeText: function (text) {
        return onChange(_this.replaceDollarSign(text), "monthlyPaymentAmount");
      }
    }))) : null, this.replaceDollarSign(this.getStateValueOriginal("lateFeesDue")) > 0 && (((_45 = this.state.payment) === null || _45 === void 0 ? void 0 : _45.paymentType) == 201298 || ((_46 = this.state.payment) === null || _46 === void 0 ? void 0 : _46.paymentType) == 201299 || ((_47 = this.state.payment) === null || _47 === void 0 ? void 0 : _47.paymentType) == 201311) && /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        paddingLeft: 5,
        marginBottom: 20,
        paddingRight: 10
      }
    }, !layout.mobile ? /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("label", {
      for: "lateFeesDue"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblLateFeesDue'
    }, translations.LateFeesDue)), /*#__PURE__*/React.createElement(PnmacToolTip, {
      style: textStyle.defaultTextDescription,
      text: "Late fee $".concat(this.replaceDollarSign(this.getStateValueOriginal("lateFeesDue", edit))),
      title: translations.LateFeesMessage
    })) : /*#__PURE__*/React.createElement(View, {
      style: {
        width: '50%'
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblLateFeesDue'
    }, translations.LateFeesDue), /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblLateFeesDue'
    }, "Late fee $".concat(this.replaceDollarSign(this.getStateValueOriginal("lateFeesDue", edit))))), /*#__PURE__*/React.createElement(View, {
      style: Platform.OS === 'web' ? {
        flex: 2
      } : {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacTextInput, {
      accessibilityLabel: "Late fees due",
      nativeID: "lateFeesDue",
      keyboardType: layout.mobile ? "decimal-pad" : "default",
      mode: "outlined",
      style: {
        width: layout.mobile ? undefined : 200
      },
      disabled: parseFloat(this.replaceDollarSign(this.getStateValueOriginal("lateFeesDue"))) <= 0,
      onBlur: function () {
        if (parseFloat(_this.replaceDollarSign(_this.getStateValue("lateFeesDue")) || 0) <= 0.01) {
          onChangeFee("0.00", "lateFeesDue");
        } else {
          if (!isNaN(parseFloat(_this.replaceDollarSign(_this.getStateValue("lateFeesDue"))))) {
            onChangeFee(parseFloat(_this.replaceDollarSign(_this.getStateValue("lateFeesDue"))).toFixed(2), "lateFeesDue");
          }
        }
      },
      onFocus: function () {
        if (parseFloat(_this.replaceDollarSign(_this.getStateValue("lateFeesDue")) || 0) <= 0.01) {
          onChangeFee("", "lateFeesDue");
        }
      },
      value: "$".concat(this.replaceDollarSign(this.getStateValue("lateFeesDue"))),
      onChangeText: function (text) {
        var _a;
        var amount = _this.replaceDollarSign(text);
        if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
          onChangeFee(amount, "lateFeesDue");
        }
      }
    }))), this.replaceDollarSign(this.getStateValueOriginal("nsfFeesDue")) > 0 && (((_48 = this.state.payment) === null || _48 === void 0 ? void 0 : _48.paymentType) == 201298 || ((_49 = this.state.payment) === null || _49 === void 0 ? void 0 : _49.paymentType) == 201299 || ((_50 = this.state.payment) === null || _50 === void 0 ? void 0 : _50.paymentType) == 201311) ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        paddingLeft: 5,
        marginBottom: 20,
        paddingRight: 10
      }
    }, !layout.mobile ? /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("label", {
      for: "nsfFeesDue"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody,
      idTag1: 'lblNSFFeesDue'
    }, translations.NSFFeesDue)), /*#__PURE__*/React.createElement(PnmacToolTip, {
      style: textStyle.formBody,
      text: "NSF fee $".concat(this.replaceDollarSign(this.getStateValueOriginal("nsfFeesDue"))),
      title: translations.NsfFeesMessage
    })) : /*#__PURE__*/React.createElement(View, {
      style: {
        width: '50%'
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody,
      idTag1: 'lblNSFFeesDue'
    }, translations.NSFFeesDue), /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody,
      idTag1: 'lblNSFFeesDue'
    }, "NSF fee $".concat(this.replaceDollarSign(this.getStateValueOriginal("nsfFeesDue"))))), /*#__PURE__*/React.createElement(View, {
      style: Platform.OS === 'web' ? {
        flex: 2
      } : {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacTextInput, {
      accessibilityLabel: "NSF fees due",
      nativeID: "nsfFeesDue",
      keyboardType: layout.mobile ? "decimal-pad" : "default",
      mode: "outlined",
      style: {
        width: layout.mobile ? undefined : 200
      },
      onBlur: function () {
        if (parseFloat(_this.replaceDollarSign(_this.getStateValue("nsfFeesDue")) || 0) <= 0.01) {
          onChangeFee("0.00", "nsfFeesDue");
        } else {
          if (!isNaN(parseFloat(_this.replaceDollarSign(_this.getStateValue("nsfFeesDue"))))) {
            onChangeFee(parseFloat(_this.replaceDollarSign(_this.getStateValue("nsfFeesDue"))).toFixed(2), "nsfFeesDue");
          }
        }
      },
      onFocus: function () {
        if (parseFloat(_this.replaceDollarSign(_this.getStateValue("nsfFeesDue")) || 0) <= 0.01) {
          onChangeFee("", "nsfFeesDue");
        }
      },
      disabled: parseFloat(this.replaceDollarSign(this.getStateValueOriginal("nsfFeesDue"))) <= 0,
      value: "$".concat(this.replaceDollarSign(this.getStateValue("nsfFeesDue"))),
      onChangeText: function (text) {
        var _a;
        var amount = _this.replaceDollarSign(text);
        if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
          onChangeFee(amount, "nsfFeesDue");
        }
      }
    }))) : null, this.replaceDollarSign(this.getStateValueOriginal("otherFeesDue")) > 0 && (((_51 = this.state.payment) === null || _51 === void 0 ? void 0 : _51.paymentType) == 201298 || ((_52 = this.state.payment) === null || _52 === void 0 ? void 0 : _52.paymentType) == 201299 || ((_53 = this.state.payment) === null || _53 === void 0 ? void 0 : _53.paymentType) == 201311) ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        paddingLeft: 5,
        marginBottom: 20,
        paddingRight: 10
      }
    }, !layout.mobile ? /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("label", {
      for: "otherFeesDue"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblOtherFeesDue'
    }, translations.OtherFeesDue)), /*#__PURE__*/React.createElement(PnmacToolTip, {
      style: textStyle.defaultTextDescription,
      text: "Other fee $".concat(this.replaceDollarSign(this.getStateValueOriginal("otherFeesDue", edit))),
      title: translations.OtherFeesMessage
    })) : /*#__PURE__*/React.createElement(View, {
      style: {
        width: '50%'
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblOtherFeesDue'
    }, translations.OtherFeesDue), /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblOtherFeesDue'
    }, "Other fee $".concat(this.replaceDollarSign(this.getStateValueOriginal("otherFeesDue", edit))))), /*#__PURE__*/React.createElement(View, {
      style: Platform.OS === 'web' ? {
        flex: 2
      } : {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacTextInput, {
      accessibilityLabel: "Other fees due",
      nativeID: "otherFeesDue",
      mode: "outlined",
      keyboardType: layout.mobile ? "decimal-pad" : "default",
      style: {
        width: layout.mobile ? undefined : 200
      },
      onBlur: function () {
        if (parseFloat(_this.replaceDollarSign(_this.getStateValue("otherFeesDue")) || 0) <= 0.01) {
          onChangeFee("0.00", "otherFeesDue");
        } else {
          if (!isNaN(parseFloat(_this.replaceDollarSign(_this.getStateValue("otherFeesDue"))))) {
            onChangeFee(parseFloat(_this.replaceDollarSign(_this.getStateValue("otherFeesDue"))).toFixed(2), "otherFeesDue");
          }
        }
      },
      onFocus: function () {
        if (parseFloat(_this.replaceDollarSign(_this.getStateValue("otherFeesDue")) || 0) <= 0.01) {
          onChangeFee("", "otherFeesDue");
        }
      },
      disabled: parseFloat(this.replaceDollarSign(this.getStateValueOriginal("otherFeesDue"))) <= 0,
      name: "otherFeesDue",
      value: "$".concat(this.replaceDollarSign(this.getStateValue("otherFeesDue"))),
      onChangeText: function (text) {
        var _a;
        var amount = _this.replaceDollarSign(text);
        if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
          onChangeFee(amount, "otherFeesDue");
        }
      }
    }))) : null, (((_54 = this.state.payment) === null || _54 === void 0 ? void 0 : _54.paymentType) == 201298 || ((_55 = this.state.payment) === null || _55 === void 0 ? void 0 : _55.paymentType) == 201297 || ((_56 = this.state.payment) === null || _56 === void 0 ? void 0 : _56.paymentType) == 201309) && !((_57 = layout.paymentModel) === null || _57 === void 0 ? void 0 : _57.mustMakeDelinquentPayment) ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        paddingLeft: 5,
        marginBottom: 20,
        paddingRight: 10
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
      for: "additionalPrincipalAmount"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblAdditionalPrincipalAmount'
    }, translations.AdditionalPrincipal)) : /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblAdditionalPrincipalAmount'
    }, translations.AdditionalPrincipal)), /*#__PURE__*/React.createElement(View, {
      style: Platform.OS === 'web' ? {
        flex: 2
      } : {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacTextInput, {
      mode: "outlined",
      accessibilityLabel: "Additional principal",
      nativeID: "additionalPrincipalAmount",
      style: {
        width: layout.mobile ? undefined : 200
      },
      keyboardType: layout.mobile ? "decimal-pad" : "default",
      payment: false,
      onBlur: function () {
        var _a, _b, _c;
        if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalPrincipalAmount) || 0) <= 0.01) {
          onChange("0.00", "additionalPrincipalAmount");
        } else {
          if (!isNaN(parseFloat(_this.replaceDollarSign((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.additionalPrincipalAmount)))) {
            onChange(parseFloat(_this.replaceDollarSign((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.additionalPrincipalAmount)).toFixed(2), "additionalPrincipalAmount");
          }
        }
      },
      onFocus: function () {
        var _a;
        if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalPrincipalAmount) || 0) <= 0.01) {
          onChange("", "additionalPrincipalAmount");
        }
      },
      value: "$".concat((_58 = this.state.payment) === null || _58 === void 0 ? void 0 : _58.additionalPrincipalAmount),
      onChangeText: function (text) {
        var _a;
        var amount = _this.replaceDollarSign(text);
        if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
          onChange(amount, "additionalPrincipalAmount");
        }
      }
    }))) : (((_59 = this.state.payment) === null || _59 === void 0 ? void 0 : _59.paymentType) == 201298 || ((_60 = this.state.payment) === null || _60 === void 0 ? void 0 : _60.paymentType) == 201297 || ((_61 = this.state.payment) === null || _61 === void 0 ? void 0 : _61.paymentType) == 201309) && (this.state.deliquentPayment || layout.paymentModel.numberofPendingPayments > 0) && !((_62 = layout.paymentModel) === null || _62 === void 0 ? void 0 : _62.mustMakeDelinquentPayment) ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        paddingLeft: 5,
        marginBottom: 20
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
      for: "additionalPrincipalAmount"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblAdditionalPrincipalAmount'
    }, translations.AdditionalPrincipal)) : /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblAdditionalPrincipalAmount'
    }, translations.AdditionalPrincipal)), /*#__PURE__*/React.createElement(View, {
      style: Platform.OS === 'web' ? {
        flex: 2
      } : {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacTextInput, {
      mode: "outlined",
      accessibilityLabel: "Additional principal",
      nativeID: "additionalPrincipalAmount",
      style: {
        width: layout.mobile ? undefined : 200
      },
      keyboardType: layout.mobile ? "decimal-pad" : "default",
      payment: false,
      onBlur: function () {
        var _a, _b, _c;
        if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalPrincipalAmount) || 0) <= 0.01) {
          onChange("0.00", "additionalPrincipalAmount");
        } else {
          if (!isNaN(parseFloat(_this.replaceDollarSign((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.additionalPrincipalAmount)))) {
            onChange(parseFloat(_this.replaceDollarSign((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.additionalPrincipalAmount)).toFixed(2), "additionalPrincipalAmount");
          }
        }
      },
      onFocus: function () {
        var _a;
        if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalPrincipalAmount) || 0) <= 0.01) {
          onChange("", "additionalPrincipalAmount");
        }
      },
      value: "$".concat((_63 = this.state.payment) === null || _63 === void 0 ? void 0 : _63.additionalPrincipalAmount),
      onChangeText: function (text) {
        var _a;
        var amount = _this.replaceDollarSign(text);
        if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
          onChange(amount, "additionalPrincipalAmount");
        }
      }
    }))) : null, ((_64 = layout.currentLoan) === null || _64 === void 0 ? void 0 : _64.escrowFlag) && (((_65 = this.state.payment) === null || _65 === void 0 ? void 0 : _65.paymentType) == 201298 || ((_66 = this.state.payment) === null || _66 === void 0 ? void 0 : _66.paymentType) == 201299 || ((_67 = this.state.payment) === null || _67 === void 0 ? void 0 : _67.paymentType) == 201311) && /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        paddingLeft: 5,
        marginBottom: 20,
        paddingRight: 10
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
      for: "additionalEscrowAmount"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      nativeID: "lblAdditionalEscrowAmount"
    }, translations.AdditionalEscrow)) : /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      nativeID: "lblAdditionalEscrowAmount"
    }, translations.AdditionalEscrow)), /*#__PURE__*/React.createElement(View, {
      style: Platform.OS === 'web' ? {
        flex: 2
      } : {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacTextInput, {
      mode: "outlined",
      accessibilityLabel: "Additional escrow",
      nativeID: "additionalEscrowAmount",
      style: {
        width: layout.mobile ? undefined : 200
      },
      keyboardType: layout.mobile ? "decimal-pad" : "default",
      edit: true,
      onBlur: function () {
        var _a, _b, _c;
        if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalEscrowAmount) || 0) <= 0) {
          onChange("0.00", "additionalEscrowAmount");
        } else {
          if (!isNaN(parseFloat(_this.replaceDollarSign((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.additionalEscrowAmount)))) {
            onChange(parseFloat(_this.replaceDollarSign((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.additionalEscrowAmount)).toFixed(2), "additionalEscrowAmount");
          }
        }
      },
      onFocus: function () {
        var _a;
        if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalEscrowAmount) || 0) <= 0) {
          onChange("", "additionalEscrowAmount");
        }
      },
      value: "$".concat((_68 = this.state.payment) === null || _68 === void 0 ? void 0 : _68.additionalEscrowAmount),
      onChangeText: function (text) {
        var _a;
        var amount = _this.replaceDollarSign(text);
        if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
          if (parseFloat(amount) <= 0.02) {
            onChange('0.00', "additionalEscrowAmount");
          } else {
            onChange(amount, "additionalEscrowAmount");
          }
        }
      }
    }))), bankAccountType == 201288 && this.replaceDollarSign(this.getStateValueOriginal("debitCardConvenienceFee")) > 0 ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        paddingLeft: 5,
        marginBottom: 20,
        paddingRight: 10
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
      for: "debitCardConvenienceFee"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblDebitCardConvenienceFee'
    }, translations.DebitCardConvenienceFee)) : /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody,
      idTag1: 'lblDebitCardConvenienceFee'
    }, translations.DebitCardConvenienceFee)), /*#__PURE__*/React.createElement(View, {
      style: Platform.OS === 'web' ? {
        flex: 2
      } : {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacTextInput, {
      mode: "outlined",
      accessibilityLabel: "Debit card convenience fee",
      nativeID: "debitCardConvenienceFee",
      style: {
        cursor: "not-allowed",
        width: layout.mobile ? undefined : 200
      },
      disabled: true,
      disabledColored: true,
      value: "$".concat(this.replaceDollarSign(this.getStateValue("debitCardConvenienceFee"))),
      onChange: function (text) {
        return onChangeFee(_this.replaceDollarSign(text), "debitCardConvenienceFee");
      }
    }))) : null, ((_69 = this.state.payment) === null || _69 === void 0 ? void 0 : _69.paymentType) == 1000145 && (modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId) > 0 && (modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible) ? /*#__PURE__*/React.createElement(View, {
      style: {
        paddingLeft: 15,
        marginBottom: 20,
        flex: 1,
        display: 'flex'
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      layout: layout,
      value: translations.ForbearancePlan2
    })) : ((_70 = this.state.payment) === null || _70 === void 0 ? void 0 : _70.paymentType) == 1000145 && !((modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId) > 0 && (modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible)) && ((_71 = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _71 === void 0 ? void 0 : _71.isLoanInForbearance) ? /*#__PURE__*/React.createElement(BannerView, {
      type: 'error',
      style: {
        marginBottom: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      layout: layout,
      value: translations.ForbearanceWarningMessage
    })) : ((_72 = this.state.payment) === null || _72 === void 0 ? void 0 : _72.paymentType) == 1000146 ? /*#__PURE__*/React.createElement(BannerView, {
      type: 'error',
      style: {
        marginBottom: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      layout: layout,
      value: (_73 = translations.DefaultPaymentsLossMitigationPlanMessage) === null || _73 === void 0 ? void 0 : _73.replace("{0}", moment(getMinimumPaymentDueDate()).format("MM/DD/YYYY"))
    })) : null, ((_74 = this.state.payment) === null || _74 === void 0 ? void 0 : _74.paymentType) == 1000145 || this.state.payment.paymentType == 1000146 ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        paddingLeft: 5,
        marginBottom: 20
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
      for: "paymentAmount"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody,
      idTag1: 'lblPaymentAmount'
    }, translations.PaymentAmount)) : /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody,
      idTag1: 'lblPaymentAmount'
    }, translations.PaymentAmount)), /*#__PURE__*/React.createElement(View, {
      style: Platform.OS === 'web' ? {
        flex: 2
      } : {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacTextInput, {
      mode: "outlined",
      nativeID: "paymentAmount",
      accessibilityLabel: "Payment amount",
      style: {
        cursor: "not-allowed",
        width: layout.mobile ? undefined : 200
      },
      keyboardType: layout.mobile ? "decimal-pad" : "default",
      onBlur: function () {
        var _a;
        if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.forbearanceAmount) || 0) <= 0) {
          onChange("0.00", "forbearanceAmount");
        }
      },
      onFocus: function () {
        var _a;
        if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.forbearanceAmount) || 0) <= 0) {
          onChange("", "forbearanceAmount");
        }
      },
      value: "$".concat((_75 = this.state.payment) === null || _75 === void 0 ? void 0 : _75.forbearanceAmount),
      onChangeText: function (text) {
        var _a;
        var amount = _this.replaceDollarSign(text);
        if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
          if (parseFloat(amount) <= 0.02) {
            onChange('0.00', "forbearanceAmount");
          } else {
            onChange(amount, "forbearanceAmount");
          }
        }
      }
    }))) : null, /*#__PURE__*/React.createElement(View, {
      accessible: true,
      accessibilityLabel: 'Total Payment',
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: 5,
        backgroundColor: '#EAF5F8',
        padding: 10,
        borderRadius: 10
      }
    }, this.state.payment.paymentType == 201298 || this.state.payment.paymentType == 201311 ? /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, Platform.OS === 'web' ? /*#__PURE__*/React.createElement(PnmacToolTip, {
      idTag1: 'lblTotalPaymentMessage',
      text: translations.TotalPayment,
      title: translations.TotalPaymentMessage
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextTitle, {
        marginBottom: 5
      }],
      idTag1: 'lblTotalPaymentMessage'
    }, translations.TotalPayment), /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.totalAndAmounts,
      idTag1: 'lblTotalPaymentMessage'
    }, translations.TotalPaymentMessage))) : /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, !layout.mobile ? this.state.payment.paymentType == 1000146 ? /*#__PURE__*/React.createElement(PnmacToolTip, {
      idTag1: 'lblTotalPaymentMessage',
      text: translations.TotalPayment,
      title: translations.DefaultPaymentsPaymentAmountMessage
    }) :
    /*#__PURE__*/
    // Ari's design
    React.createElement("label", {
      for: "totalDraftAmount"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextTitle,
      idTag1: 'lblTotalDraftPayment'
    }, translations.TotalPayment)) :
    /*#__PURE__*/
    // Ari's design
    React.createElement(PnmacText, {
      style: [textStyle.defaultTextTitle],
      idTag1: 'lblTotalDraftPayment'
    }, translations.TotalPayment)), /*#__PURE__*/React.createElement(View, {
      accessible: true,
      accessibilityLabel: 'Total Draft Amount input',
      style: Platform.OS === 'web' ? {
        flex: 2
      } : {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacTextInput, {
      bold: true,
      mode: "outlined",
      accessibilityLabel: "Total draft amount",
      nativeID: "totalDraftAmount",
      style: {
        cursor: "not-allowed",
        width: layout.mobile ? undefined : 200,
        backgroundColor: '#EFEFEF'
      },
      disabled: true,
      disabledColored: true,
      value: currencyFormatter('en-US', 'currency', 'USD', this.totalDraftAmountFun())
    })))), !isOtp ? /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1,
        display: "flex",
        alignItems: matches.small ? "center" : "initial",
        marginTop: 20,
        marginLeft: Platform.OS === 'web' ? 20 : 0
      }
    }, ((_76 = layout.currentLoan) === null || _76 === void 0 ? void 0 : _76.helocFlag) ? /*#__PURE__*/React.createElement(View, {
      accessible: true,
      accessibilityLabel: 'Calendar',
      style: {
        display: "flex",
        flexDirection: "column",
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: 10
      }
    }, /*#__PURE__*/React.createElement(Image, {
      style: {
        height: 200,
        width: 282
      },
      source: require('../../assets/calendar-ach12_151.gif')
    })), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblCalendarLightboxDescriptionMax',
      style: __assign(__assign({}, textStyle.formBody), {
        paddingLeft: matches.small ? 10 : 0
      })
    }, translations.CalendarLightboxDescriptionMax))) : /*#__PURE__*/React.createElement(View, {
      accessible: true,
      accessibilityLabel: 'Calendar',
      style: {
        display: "flex",
        flexDirection: "column",
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: 10,
        alignItems: Platform.OS === ' web' ? undefined : 'center'
      }
    }, /*#__PURE__*/React.createElement(Image, {
      style: {
        height: 200,
        width: 282
      },
      source: require('../../assets/calendar-ach12_150.gif')
    })), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
      idTag1: 'lblCalendarLightboxDescription',
      style: __assign(__assign({}, textStyle.formBody), {
        paddingLeft: matches.small ? 10 : 0
      })
    }, translations.CalendarLightboxDescription)))) : null)), this.state.payment.paymentType == 1000145 && ((_77 = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.loan) === null || _77 === void 0 ? void 0 : _77.defaultPayments) == null ? /*#__PURE__*/React.createElement(BannerView, {
      style: {
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      layout: layout,
      value: translations.ForbearanceWarningMessage2
    })) : this.state.payment.paymentType == 1000146 || this.state.payment.paymentType == 1000145 ? /*#__PURE__*/React.createElement(BannerView, {
      style: {
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      layout: layout,
      value: translations.DefaultPaymentsFullPaymentMessage
    })) : null, /*#__PURE__*/React.createElement(View, {
      style: {
        width: '100%',
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }
    }, this.checkPaymentOver() ? /*#__PURE__*/React.createElement(BannerView, {
      type: 'error',
      style: {
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, this.props, {
      layout: layout,
      value: translations === null || translations === void 0 ? void 0 : translations.DefaultPaymentsPayoffMessage
    }))) : null, /*#__PURE__*/React.createElement(View, {
      style: {
        width: '100%',
        display: "flex",
        justifyContent: "space-between",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center",
        alignSelf: "flex-end"
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      nativeID: "btnCancelButton",
      style: {
        width: matches.small ? "90%" : "35%",
        marginTop: 20
      },
      loading: this.state.paymentSubmitted,
      mode: "outlined",
      testID: "CancelButtonPnmacText",
      onPress: function () {
        PnmacNavigation(__assign({
          action: {
            pathname: '/',
            state: {}
          },
          wind: false
        }, _this.props));
      }
    }, translations.CancelButtonPnmacText), /*#__PURE__*/React.createElement(PnmacUIButton, {
      nativeID: "btnContinueButton",
      style: {
        width: matches.small ? "90%" : "35%",
        marginTop: 15
      },
      loading: this.state.paymentSubmitted,
      disabled: monthlyPaymentdisabled && principalReductionedisabled && additionalAmountDisabled || this.state.isNachaOpen || this.checkPaymentOver() || (((_78 = this.state.payment) === null || _78 === void 0 ? void 0 : _78.bankAccount) == null || !((_80 = (_79 = this.state.payment) === null || _79 === void 0 ? void 0 : _79.bankAccount) === null || _80 === void 0 ? void 0 : _80.accountNumber)) && isOtp && parseInt(bankAccountType) != 201288 || paymentWindow && isTrialPaymentVisible || this.totalDraftAmountFun() <= (bankAccountType == 201288 ? 6.75 : 0) || disableDate(moment((_82 = (_81 = this.state) === null || _81 === void 0 ? void 0 : _81.payment) === null || _82 === void 0 ? void 0 : _82.effectiveDate)) || !((_84 = (_83 = this.state) === null || _83 === void 0 ? void 0 : _83.payment) === null || _84 === void 0 ? void 0 : _84.effectiveDate),
      mode: "contained",
      testID: "ContinueButtonText",
      onPress: function () {
        if (parseInt(bankAccountType) == 201288) {
          _this.setState({
            openDebit: true
          });
        } else if (isOtp) {
          _this.setState({
            modalType: "effectiveDateConfirmation",
            open: true,
            tabProgression: __spreadArray(__spreadArray([], tabProgression, true), ["bank"], false)
          });
        } else {
          _this.setState({
            page: "bank",
            tabProgression: __spreadArray(__spreadArray([], tabProgression, true), ["bank"], false)
          });
        }
      }
    }, translations.ContinueButtonText)))) : /*#__PURE__*/React.createElement(View, {
      nativeID: "pay-view",
      style: {
        marginTop: -1,
        paddingTop: 10,
        backgroundColor: "#FFF",
        marginBottom: 10,
        borderTopWidth: Platform.OS === 'web' ? 1 : 0.5,
        borderColor: '#DBDBDB'
      },
      name: "confirm"
    }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacTermsModal, {
      cancelTerms: function () {
        return null;
      },
      open: this.state.modalOpenEl,
      ACE: true,
      callbackOnAccept: function (data) {
        var _a;
        return _this.setState((_a = {}, _a[data.node] = true, _a.modalOpenEl = false, _a.openedTerms = true, _a));
      },
      enject: true,
      handleClose: function () {
        return _this.setState({
          modalOpenEl: false
        });
      },
      data: this.state.modalData,
      idTag7: "terms_scroll"
    })), /*#__PURE__*/React.createElement(BannerView, {
      style: {
        marginBottom: 10,
        marginHorizontal: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, this.props, {
      layout: layout,
      size: 14,
      value: translations.OTPConfirmationPageStaticContent
    }))), /*#__PURE__*/React.createElement(View, {
      style: __assign({
        paddingBottom: 10,
        marginTop: 10,
        paddingHorizontal: 20
      }, textStyle.formLineWeight)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextTitle
    }, translations === null || translations === void 0 ? void 0 : translations.PaymentType)), /*#__PURE__*/React.createElement(View, {
      style: styles.selectionListView.bankPaymentItemStyles
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription)
    }, paymentTypes[this.state.payment.paymentType])), /*#__PURE__*/React.createElement(View, {
      style: __assign({
        paddingBottom: 10,
        marginTop: 10,
        paddingHorizontal: 20
      }, textStyle.formLineWeight)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextTitle
    }, translations.OtpBankInformationStepTitle)), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription)
    }, translations.BankRoutingTransitNumber)), /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription), {
        textAlign: 'right'
      })
    }, routingTransitNumber))), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription)
    }, translations.BankAccountNumber)), /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription), {
        textAlign: 'right'
      })
    }, maskBankInfo(accountNumber)))), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription)
    }, translations.BankAccountType)), /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription), {
        textAlign: 'right'
      })
    }, accountype[bankAccountType]))), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription)
    }, translations.NameOnBankAccount)), /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription), {
        textAlign: 'right'
      })
    }, accountName)))), /*#__PURE__*/React.createElement(View, {
      style: __assign({
        paddingBottom: 10,
        marginTop: 10,
        paddingHorizontal: 20
      }, textStyle.formLineWeight)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextTitle
    }, translations.OtpPaymentDetailsStepTitle)), isOtp ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription)
    }, translations.TotalPaymentAmount)), /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription), {
        textAlign: 'right'
      })
    }, currencyFormatter('en-US', 'currency', 'USD', this.totalDraftAmountFun())))), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: __assign(__assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles), {
        borderBottomWidth: 0
      })
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription)
    }, translations.EffectiveDate)), /*#__PURE__*/React.createElement(View, {
      style: __assign(__assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles), {
        borderBottomWidth: 0
      })
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription), {
        textAlign: 'right'
      })
    }, moment(this.state.payment.effectiveDate, "MM/DD/YYYY").isValid() ? moment(this.state.payment.effectiveDate, "MM/DD/YYYY").format("MM/DD/YYYY") : moment(this.state.payment.effectiveDate).format("MM/DD/YYYY"))))) : /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription)
    }, translations.DraftDate)), /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription), {
        textAlign: 'right'
      })
    }, moment(this.state.payment.effectiveDate, "MM/DD/YYYY").isValid() ? moment(this.state.payment.effectiveDate, "MM/DD/YYYY").format("Do") : moment(this.state.payment.effectiveDate).format("Do"), " of the month"))), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription)
    }, translations.MonthlyPayment)), /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription), {
        textAlign: 'right'
      })
    }, currencyFormatter('en-US', 'currency', 'USD', this.state.payment.monthlyPaymentAmount)))), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription)
    }, translations.AdditionalPrincipal)), /*#__PURE__*/React.createElement(View, {
      style: __assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles)
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({
        flexGrow: 2
      }, textStyle.defaultTextDescription), {
        textAlign: 'right'
      })
    }, currencyFormatter('en-US', 'currency', 'USD', this.state.payment.additionalPrincipalAmount)))), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: __assign(__assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles), {
        borderBottomWidth: 0
      })
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign({
        flexGrow: 2
      }, textStyle.formBodyTotal)
    }, translations.TotalPaymentAmount)), /*#__PURE__*/React.createElement(View, {
      style: __assign(__assign({
        width: "50%"
      }, styles.selectionListView.bankPaymentItemStyles), {
        borderBottomWidth: 0
      })
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({
        flexGrow: 2
      }, textStyle.formBodyTotal), {
        textAlign: 'right'
      })
    }, currencyFormatter('en-US', 'currency', 'USD', this.totalDraftAmountFun()))))), /*#__PURE__*/React.createElement(PnmacModal, {
      open: this.state.openCancelAch,
      onClose: function () {
        return _this.setState({
          openCancelAch: false
        });
      },
      "aria-label": "payments breakdown"
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        borderRadius: 10,
        padding: 20,
        width: matches.small ? undefined : 500,
        backgroundColor: "#f5f5f5",
        height: "auto"
      }
    }, /*#__PURE__*/React.createElement(PnmacTitle, {
      style: textStyle.defaultTextTitle
    }, translations.CancelServiceEdited), /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, translations.CancelServiceMessageLine1), /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, translations.CancelServiceMessageLine2), /*#__PURE__*/React.createElement(View, {
      style: {
        marginTop: 20
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      loading: this.state.loading,
      nativeID: "btnACHAlertModalYesCancelMyService",
      testId: "ACHAlertModalYesCancelMyService",
      testID: "ACHAlertModalYesCancelMyService",
      mode: "contained",
      onPress: function () {
        var _a, _b, _c;
        var pay = (_b = (_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.pendingPayments) === null || _b === void 0 ? void 0 : _b.find(function (s) {
          return s.paymentType == 201309;
        });
        trackEvent('ach_canceled', {
          paymentType: pay === null || pay === void 0 ? void 0 : pay.paymentType
        });
        pay.mobile = layout.mobile;
        _this.setState({
          loading: true
        });
        fetch("".concat(layout.pennyHomeUrl, "api/payment/").concat(parseInt((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.draftSource) == 4 ? "delete_ach" : "delete_payment"), {
          method: 'POST',
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer ".concat(_this.props.layout.token),
            "TrackerSessionId": "".concat(_this.props.layout.trackerSession)
          },
          body: JSON.stringify(__assign(__assign({}, pay), {
            bankAccount: __assign(__assign({}, pay.bankAccount), {
              unmaskedAccountNumber: undefined,
              confirmAccountNumber: undefined,
              confirmAccountNumberEncode: encryptBankAccountNumber(pay.bankAccount.confirmAccountNumber)
            }),
            loan: layout.currentLoan
          }))
        }).then(function (res) {
          return res.json();
        }).then(function (data) {
          var _a, _b, _c, _d;
          if (data && (((_a = Object.keys(data === null || data === void 0 ? void 0 : data.errors)) === null || _a === void 0 ? void 0 : _a.length) == 0 || !(data === null || data === void 0 ? void 0 : data.errors))) {
            var newPaymentModel = __assign({}, layout.paymentModel);
            var p = (_b = layout.paymentModel) === null || _b === void 0 ? void 0 : _b.pendingPayments.findIndex(function (s) {
              return s.achConfigurationKey == pay.achConfigurationKey;
            });
            newPaymentModel.pendingPayments.splice(p, 1);
            _this.props.dispatch({
              type: PAYMENT_VALIDATION,
              payment: newPaymentModel
            }, function () {
              return _this.props.refreshBankData(layout.selectedLoanNumber);
            });
            if (!layout.mobile) {
              if (parseInt((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.draftSource) == 4) {
                windowObject.dataLayer = windowObject.dataLayer || [];
                dataLayer.push({
                  event: 'ach_canceled'
                });
              }
            }
          }
          _this.setState({
            isMounted: false,
            openedTerms: false,
            loading: false,
            page: "pay",
            openCancelAch: false,
            payment: __assign(__assign({}, __assign(__assign({}, (_d = layout.paymentModel) === null || _d === void 0 ? void 0 : _d.payment), {
              effectiveDate: null
            })), {
              paymentType: pay.paymentType
            })
          });
        });
      }
    }, translations.ACHAlertModalYesCancelMyService), /*#__PURE__*/React.createElement(PnmacUIButton, {
      nativeID: "btnACHAlertModalNo",
      testID: "ACHAlertModalNo",
      mode: "outlined",
      testId: "ACHAlertModalNo",
      style: {
        marginTop: 10
      },
      onPress: function () {
        return _this.setState({
          openCancelAch: false
        });
      }
    }, translations.ACHAlertModalNo)))), /*#__PURE__*/React.createElement(BannerView, {
      style: {
        marginHorizontal: 10
      }
    }, !this.state.openedTerms ? /*#__PURE__*/React.createElement(View, {
      style: {
        borderRadius: 5,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, this.props, {
      layout: layout,
      value: !isOtp ? translations.ACHTerms : translations.PaymentTermsOtp
    }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: "center"
      },
      onPress: function () {
        if (!achExist && !isOtp) {
          _this.setState({
            openedTerms: false
          });
        }
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, this.props, {
      layout: layout,
      value: !isOtp ? translations.ACHTerms : translations.PaymentTermsOtp
    })))), /*#__PURE__*/React.createElement(View, {
      style: {
        borderRadius: 10,
        marginTop: 10,
        marginBottom: 10
      }
    }, /*#__PURE__*/React.createElement(BannerView.Text, {
      idTag1: 'lblBankInfoWarningLine'
    }, translations.BankInfoWarningLine1, " ", currencyFormatter('en-US', 'currency', 'USD', this.totalDraftAmountFun()), " ", translations.BankInfoWarningLine2, " ", accountNumber))), achExist && !edit ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        marginTop: 20,
        marginBottom: 20,
        marginHorizontal: 20
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      loading: this.state.loading,
      nativeID: "btnCancelService",
      disabled: layout.pennyWise,
      style: {
        marginRight: 10
      },
      mode: "outlined",
      testID: "CancelService",
      onPress: function () {
        _this.setState({
          openCancelAch: true
        });
      }
    }, translations.CancelService), /*#__PURE__*/React.createElement(PnmacUIButton, {
      nativeID: "btnMakeChanges",
      style: {
        marginLeft: 10
      },
      mode: "contained",
      testID: "MakeChanges",
      onPress: function () {
        var _a, _b;
        var d = (_b = (_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.pendingPayments) === null || _b === void 0 ? void 0 : _b.find(function (s) {
          return s.paymentType == 201309;
        });
        PnmacNavigation(__assign({
          action: {
            pathname: '/Payment/AchUpdate',
            state: {
              payment: d,
              edit: true
            }
          },
          wind: false
        }, _this.props));
      }
    }, translations.MakeChanges)) : /*#__PURE__*/React.createElement(View, {
      style: {
        marginHorizontal: Platform.OS === 'web' ? 10 : 0,
        justifyContent: "space-between",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      nativeID: "btnPreviousButtonPnmacText",
      testId: "PreviousButtonPnmacText",
      style: {
        width: matches.small ? "90%" : "25%",
        marginTop: 25
      },
      disabled: this.state.paymentSubmitted,
      mode: "contained",
      testID: "PreviousButtonPnmacText",
      onPress: function () {
        return _this.setState({
          page: "pay"
        });
      }
    }, translations.PreviousButtonPnmacText), /*#__PURE__*/React.createElement(PnmacUIButton, {
      nativeID: "btnCancelButtonPnmacText",
      style: {
        width: matches.small ? "90%" : "25%",
        marginTop: 25
      },
      disabled: this.state.paymentSubmitted,
      testId: "CancelButtonPnmacText",
      mode: "outlined",
      testID: "CancelButtonPnmacText",
      onPress: function () {
        return _this.setState({
          page: "pay"
        });
      }
    }, translations.CancelButtonPnmacText), /*#__PURE__*/React.createElement(PnmacUIButton, {
      nativeID: "btnSubmitButtonPnmacText",
      name: "SubmitButtonPnmacText",
      testId: "SubmitButtonPnmacText",
      style: {
        width: matches.small ? "90%" : "25%",
        marginTop: 25
      },
      loading: this.state.paymentSubmitted,
      disabled: layout.pennyWise,
      mode: "contained",
      testID: "SubmitButtonPnmacText",
      onPress: function () {
        _this.submitPayment();
        _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Div, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "click on Submit at the bottom of the confirmation page", 0);
      }
    }, translations.SubmitButtonPnmacText))));
  };
  return MonthlyPayment;
}(React.Component);
export default MonthlyPayment;